/**
 * API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as querystring from "querystring";
import * as url from "url";

const isomorphicFetch = fetch;
const assign: (target: any, ...sources: any[]) => any = (Object as any).assign;

interface Dictionary<T> { [index: string]: T; }
export interface FetchAPI { (url: string, init?: any): Promise<any>; }

const BASE_PATH = "https://localhost".replace(/\/+$/, "");

export interface FetchArgs {
    url: string;
    options: any;
}

export class BaseAPI {
    basePath: string;
    fetch: FetchAPI;

    constructor(fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) {
        this.basePath = basePath;
        this.fetch = fetch;
    }
};

export interface AlkAddress {
    "streetAddress"?: string;
    "city"?: string;
    "state"?: string;
    "zip"?: string;
    "county"?: string;
    "country"?: string;
    "countryPostalFilter"?: number;
    "abbreviationFormat"?: number;
}

export interface Assembly {
    "definedTypes"?: Array<TypeInfo>;
    "exportedTypes"?: Array<Type>;
    "codeBase"?: string;
    "entryPoint"?: MethodInfo;
    "fullName"?: string;
    "imageRuntimeVersion"?: string;
    "isDynamic"?: boolean;
    "location"?: string;
    "reflectionOnly"?: boolean;
    "isCollectible"?: boolean;
    "isFullyTrusted"?: boolean;
    "customAttributes"?: Array<CustomAttributeData>;
    "escapedCodeBase"?: string;
    "manifestModule"?: Module;
    "modules"?: Array<Module>;
    "globalAssemblyCache"?: boolean;
    "hostContext"?: number;
    "securityRuleSet"?: SecurityRuleSet;
}

export interface AssignDriverToEventsRequest {
    "videoEventIdList"?: Array<number>;
    "driverId"?: string;
    "email"?: string;
    "firstName"?: string;
    "lastName"?: string;
    "phoneNumber"?: string;
    "isActive"?: boolean;
}

export interface AutoScoreSettingsRequest {
    "id"?: number;
    "videoEventTypeId"?: number;
    "videoEventScoreId"?: number;
}

export interface AutoScoreSettingsResponse {
    "autoScoreSettingsId"?: number;
    "videoEventTypeId"?: number;
    "videoEventTypeDisplayName"?: string;
    "videoEventScoreId"?: number;
    "videoEventScoreDisplayName"?: string;
}

export interface BulkRatingRequest {
    "ratingValue"?: number;
    "videoEventIdList"?: Array<number>;
}

export interface BulkRequest {
    "videoEventIdList"?: Array<number>;
    "adminResolution"?: VideoEventAdminResolutionEnum;
}

export type CallingConventions = "Standard" | "VarArgs" | "Any" | "HasThis" | "ExplicitThis";

export interface CameraDeviceEarliestFootageResponse {
    "serialNumber"?: string;
    "earliestFootageDate"?: Date;
}

export interface CameraDevicePairingResponse {
    "id"?: number;
    "fleetId"?: number;
    "deviceTypeId"?: number;
    "serialNumber"?: string;
    "imei"?: string;
    "iccid"?: string;
    "deviceType"?: CameraDeviceViewType;
    "lastHeartbeatTime"?: Date;
    "deviceStatus"?: CameraDeviceStatusEnum;
    "lastProcessedEventTime"?: Date;
    "onlineStatus"?: string;
    "pairingStatus"?: string;
    "vehicleCameraPairing"?: VehicleCameraPairingResponse;
}

export interface CameraDeviceRequest {
    "id"?: number;
    "fleetId"?: number;
    "deviceTypeId"?: number;
    "serialNumber"?: string;
    "imei"?: string;
    "iccid"?: string;
    "deviceType"?: CameraDeviceViewType;
    "lastHeartbeatTime"?: Date;
    "deviceStatus"?: CameraDeviceStatusEnum;
    "lastProcessedEventTime"?: Date;
    "onlineStatus"?: string;
    "isGpsTrackingEnabled"?: boolean;
}

export interface CameraDeviceResponse {
    "id"?: number;
    "fleetId"?: number;
    "deviceTypeId"?: number;
    "serialNumber"?: string;
    "imei"?: string;
    "iccid"?: string;
    "deviceType"?: CameraDeviceViewType;
    "lastHeartbeatTime"?: Date;
    "deviceStatus"?: CameraDeviceStatusEnum;
    "pairingStatus"?: string;
    "lastProcessedEventTime"?: Date;
    "onlineStatus"?: string;
}

export interface CameraDeviceSegment {
    "startTime": Date;
    "endTime": Date;
    "existingRequestId"?: number;
}

export interface CameraDeviceSegmentProgressResult {
    "isReady"?: boolean;
    "failed"?: boolean;
    "percent"?: number;
    "failureReason"?: string;
    "fileUrl"?: string;
}

export interface CameraDeviceSegmentsResponse {
    "serialNumber": string;
    "segments": Array<CameraDeviceSegment>;
}

export type CameraDeviceStatusEnum = "Active" | "Suspended" | "Retired" | "Expired" | "New" | "PendingSignature" | "Pairing" | "Disabled" | "Deprovisioned";

export interface CameraDeviceViewType {
    "id"?: number;
    "displayName"?: string;
    "sysName"?: string;
}

export interface CameraRequestResponse {
    "id"?: number;
    "cameraDeviceId"?: number;
    "requestDate"?: Date;
    "commandPayloadJson"?: string;
    "completionDate"?: Date;
    "uploadStrategy"?: string;
    "command"?: string;
    "requestStepId"?: VideoEventPipelineStepEnum;
    "requestStepDescriptionId"?: number;
    "claimToken"?: string;
    "requestedBy"?: string;
    "cameraRequestTypeId"?: CameraRequestTypeEnum;
    "requestStepDescription"?: VideoEventPipelineStepDescriptionResponse;
}

export type CameraRequestTypeEnum = "Video";

export interface ClientConfigResponse {
    "showAgreements"?: boolean;
    "googleMapsAPIKey"?: string;
    "integrationPlatform"?: string;
    "deployEnvironment"?: string;
    "clientIdWebStandalone"?: string;
    "identityServerUrl"?: string;
    "apmServiceUrl"?: string;
    "apmServiceName"?: string;
    "pendoApiKey"?: string;
    "trimbleMapsAPIKey"?: string;
    "isEncompassIdentityDeprecationSplitOn"?: boolean;
    "oktaIssuerUrl"?: string;
    "oktaClientId"?: string;
}

export interface Color {
    "a"?: number;
    "b"?: number;
    "g"?: number;
    "r"?: number;
}

export interface CommentRequest {
    "id"?: number;
    "comment": string;
}

export interface CommentResponse {
    "id"?: number;
    "commentDate"?: Date;
    "comment"?: string;
    "commentByUser"?: string;
    "commentByUserId"?: string;
}

export interface CommentResponseResponseBase {
    "success"?: boolean;
    "error"?: Exception;
    "totalCount"?: number;
    "data"?: CommentResponse;
}

export interface ConstructorInfo {
    "name"?: string;
    "declaringType"?: Type;
    "reflectedType"?: Type;
    "module"?: Module;
    "customAttributes"?: Array<CustomAttributeData>;
    "isCollectible"?: boolean;
    "metadataToken"?: number;
    "attributes"?: MethodAttributes;
    "methodImplementationFlags"?: MethodImplAttributes;
    "callingConvention"?: CallingConventions;
    "isAbstract"?: boolean;
    "isConstructor"?: boolean;
    "isFinal"?: boolean;
    "isHideBySig"?: boolean;
    "isSpecialName"?: boolean;
    "isStatic"?: boolean;
    "isVirtual"?: boolean;
    "isAssembly"?: boolean;
    "isFamily"?: boolean;
    "isFamilyAndAssembly"?: boolean;
    "isFamilyOrAssembly"?: boolean;
    "isPrivate"?: boolean;
    "isPublic"?: boolean;
    "isConstructedGenericMethod"?: boolean;
    "isGenericMethod"?: boolean;
    "isGenericMethodDefinition"?: boolean;
    "containsGenericParameters"?: boolean;
    "methodHandle"?: RuntimeMethodHandle;
    "isSecurityCritical"?: boolean;
    "isSecuritySafeCritical"?: boolean;
    "isSecurityTransparent"?: boolean;
    "memberType"?: MemberTypes;
}

export interface ContactInformationTMCRequest {
    "firstName": string;
    "lastName": string;
    "emailAddress": string;
    "title": string;
    "phoneNumber"?: string;
    "extension"?: string;
    "companyName": string;
    "address1": string;
    "address2"?: string;
    "city": string;
    "stateAbbreviation": string;
    "zipCode": string;
}

export interface ContactInformationTMCResponse {
    "contactInformationIdentifier"?: string;
    "firstName"?: string;
    "lastName"?: string;
    "emailAddress"?: string;
    "title"?: string;
    "companyName"?: string;
    "phoneNumber"?: string;
    "extension"?: string;
    "address1"?: string;
    "address2"?: string;
    "city"?: string;
    "stateAbbreviation"?: string;
    "zipCode"?: string;
}

export interface CountryResponse {
    "id"?: number;
    "name"?: string;
}

export interface CountryResponseIEnumerableResponseBase {
    "success"?: boolean;
    "error"?: Exception;
    "totalCount"?: number;
    "data"?: Array<CountryResponse>;
}

export interface CourseDetailsResponse {
    "courseInformation": CourseResponse;
    "activeInProgress": Array<EnrollmentDetailsResponse>;
    "activeNotStarted": Array<EnrollmentDetailsResponse>;
    "activePastDue": Array<EnrollmentDetailsResponse>;
    "activeFailed": Array<EnrollmentDetailsResponse>;
    "completed": Array<EnrollmentDetailsResponse>;
}

export interface CourseEnrollmentResponse {
    "course"?: CourseEventTypeResponse;
    "enrollment"?: EnrollmentDetailsResponse;
    "lastCompletedDate"?: Date;
}

export interface CourseEnrollmentTMCResponse {
    "courseId"?: number;
    "courseTitle"?: string;
    "activeLearnerCount"?: number;
}

export interface CourseEventTypeRequest {
    "eventTypeIds": Array<number>;
    "learnerId": string;
}

export interface CourseEventTypeResponse {
    "courseId"?: number;
    "courseTitle": string;
    "courseDescription": string;
    "courseImageUrl": string;
}

export interface CourseFilter {
    "field": string;
    "type": FilterTypeEnum;
    "value": string;
}

export interface CourseRequest {
    "sortBy"?: string;
    "filter"?: CourseFilter;
}

export interface CourseResponse {
    "courseId"?: number;
    "courseTitle": string;
    "productDescription": string;
    "durationSeconds"?: number;
    "imageUrl": string;
}

export interface CreateUserRequest {
    "firstName": string;
    "lastName": string;
    "email": string;
    "phoneNumber"?: string;
    "roleId": number;
    "settings": UserSettingsRequest;
}

export interface CreateVehicleRequest {
    "name": string;
    "vin"?: string;
    "assignedDriverId"?: number;
    "assignedLocationId"?: number;
    "cameraDeviceId"?: number;
}

export interface CreateVideoRecallPreviewRequest {
    "serialNumber"?: string;
    "channelId"?: number;
    "startTime"?: Date;
    "endTime"?: Date;
}

export interface CriticalSpeedResponse {
    "fleetId"?: number;
    "speedThreshold"?: number;
}

export interface CriticalSpeedResponseWithUnits {
    "speedThreshold": number;
    "speedTypeEnum"?: SpeedTypeEnum;
    "fleetId"?: number;
}

export interface CustomAttributeData {
    "attributeType"?: Type;
    "constructor"?: ConstructorInfo;
    "constructorArguments"?: Array<CustomAttributeTypedArgument>;
    "namedArguments"?: Array<CustomAttributeNamedArgument>;
}

export interface CustomAttributeNamedArgument {
    "memberInfo"?: MemberInfo;
    "typedValue"?: CustomAttributeTypedArgument;
    "memberName"?: string;
    "isField"?: boolean;
}

export interface CustomAttributeTypedArgument {
    "argumentType"?: Type;
}

export interface DashboardDriverRankingDatasetResponse {
    "startDate"?: Date;
    "endDate"?: Date;
    "ranking"?: { [key: string]: DashboardDriverRankingEntryResponse; };
}

export interface DashboardDriverRankingDatasetResponseDashboardWindowedDatasetModel {
    "windowDescription"?: string;
    "previous"?: DashboardDriverRankingDatasetResponse;
    "current"?: DashboardDriverRankingDatasetResponse;
}

export interface DashboardDriverRankingEntryResponse {
    "name"?: string;
    "eventCount"?: number;
    "score"?: number;
}

export interface DashboardEventScoreDatasetResponse {
    "startDate"?: Date;
    "endDate"?: Date;
    "totalCount"?: number;
    "data"?: { [key: string]: number; };
}

export interface DashboardEventScoreDatasetResponseDashboardWindowedDatasetModel {
    "windowDescription"?: string;
    "previous"?: DashboardEventScoreDatasetResponse;
    "current"?: DashboardEventScoreDatasetResponse;
}

export interface DashboardEventStatisticsDatasetResponse {
    "startDate"?: Date;
    "endDate"?: Date;
    "totalCount"?: number;
    "data"?: { [key: string]: DashboardEventStatisticsEventTypeResponse; };
}

export interface DashboardEventStatisticsDatasetResponseDashboardWindowedDatasetModel {
    "windowDescription"?: string;
    "previous"?: DashboardEventStatisticsDatasetResponse;
    "current"?: DashboardEventStatisticsDatasetResponse;
}

export interface DashboardEventStatisticsDriverResponse {
    "count"?: number;
    "name"?: string;
}

export interface DashboardEventStatisticsEventTypeResponse {
    "eventType"?: string;
    "totalCount"?: number;
    "lastEventDate"?: Date;
    "drivers"?: Array<DashboardEventStatisticsDriverResponse>;
}

export interface DashboardEventStatusDatasetResponse {
    "totalCount"?: number;
    "data"?: { [key: string]: number; };
}

export interface DashboardMetaResponse {
    "version"?: string;
    "generatedAt"?: Date;
}

export interface DashboardResponse {
    "meta"?: DashboardMetaResponse;
    "eventStatus"?: DashboardEventStatusDatasetResponse;
    "eventScore"?: DashboardEventScoreDatasetResponseDashboardWindowedDatasetModel;
    "eventStatistics"?: Array<DashboardEventStatisticsDatasetResponseDashboardWindowedDatasetModel>;
    "driverRanking"?: DashboardDriverRankingDatasetResponseDashboardWindowedDatasetModel;
}

export interface DashboardSummaryData {
    "eventStatus"?: EventStatus;
    "eventScore"?: EventScore;
    "eventStatistics"?: EventStatistics;
    "driverRanking"?: DriverRanking;
    "includesPurgedData"?: boolean;
}

export interface DashboardSummaryResponse {
    "requestedSummary"?: DashboardSummaryData;
    "previousSummary"?: DashboardSummaryData;
}

export interface DriverCommentResponse {
    "id"?: number;
    "videoEventId"?: number;
    "comment"?: string;
    "createdOn"?: Date;
}

export interface DriverDetailsResponse {
    "firstName": string;
    "lastName": string;
    "driverId": string;
    "email": string;
    "phoneNumber"?: string;
    "assignedVehicleId"?: number;
    "assignedLocationId"?: number;
    "id"?: number;
    "fullName"?: string;
    "score"?: Array<DriverScoreResponse>;
    "videoEvents"?: Array<DriverVideoEventResponse>;
    "createdOn"?: Date;
    "isDeleted"?: boolean;
    "assignedVehicleName"?: string;
    "assignedLocationName"?: string;
    "integrationPartnerSourceId"?: string;
    "driverComments"?: Array<CommentResponse>;
    "tmcLearnerId"?: string;
    "enrollmentLists": EnrollmentLists;
}

export interface DriverDetailsResponseResponseBase {
    "success"?: boolean;
    "error"?: Exception;
    "totalCount"?: number;
    "data"?: DriverDetailsResponse;
}

export interface DriverRanking {
    "ranking"?: { [key: string]: Ranking; };
}

export interface DriverRequest {
    "firstName": string;
    "lastName": string;
    "driverId": string;
    "email": string;
    "phoneNumber"?: string;
    "assignedVehicleId"?: number;
    "assignedLocationId"?: number;
}

export interface DriverResponse {
    "firstName": string;
    "lastName": string;
    "driverId": string;
    "email": string;
    "phoneNumber"?: string;
    "assignedVehicleId"?: number;
    "assignedLocationId"?: number;
    "id"?: number;
    "fullName"?: string;
    "score"?: number;
    "assignedVehicleName"?: string;
    "assignedLocationName"?: string;
    "createdOn"?: Date;
    "isDeleted"?: boolean;
    "locationAssignedDate"?: Date;
    "tmcLearnerId"?: string;
}

export interface DriverResponseIEnumerableResponseBase {
    "success"?: boolean;
    "error"?: Exception;
    "totalCount"?: number;
    "data"?: Array<DriverResponse>;
}

export interface DriverScoreResponse {
    "month"?: Date;
    "score"?: number;
}

export interface DriverStatistics {
    "count"?: number;
    "name"?: string;
}

export interface DriverVideoEventResponse {
    "eventId"?: number;
    "displayEventId"?: string;
    "eventStartDate"?: Date;
    "videoEventTypeNames"?: Array<string>;
    "videoEventTypeIds"?: Array<number>;
    "workflowStatusName"?: string;
}

export interface EditUserProfileRequest {
    "firstName": string;
    "lastName": string;
    "email": string;
    "settings": UserSettingsRequest;
}

export interface EditUserRequest {
    "firstName": string;
    "lastName": string;
    "email": string;
    "phoneNumber"?: string;
    "roleId": number;
    "fleetId"?: number;
    "settings": UserSettingsRequest;
}

export interface EditUserRequestResponseBase {
    "success"?: boolean;
    "error"?: Exception;
    "totalCount"?: number;
    "data"?: EditUserRequest;
}

export interface EditVehicleCameraPairingRequest {
    "cameraDeviceId"?: number;
    "vehicleId"?: number;
    "isGpsTrackingEnabled"?: boolean;
    "vehicle"?: VehicleRequest;
    "currentPairingId"?: number;
}

export interface EnrollmentDetailsResponse {
    "enrollmentId"?: number;
    "courseId"?: number;
    "driverId"?: number;
    "learnerIdentifier"?: string;
    "learnerFirstName": string;
    "learnerLastName": string;
    "learnerFullName"?: string;
    "learnerEmail": string;
    "enrollmentDate"?: Date;
    "dueDate"?: Date;
    "reminderDate"?: Date;
    "courseStartDate"?: Date;
    "courseCompletionDate"?: Date;
    "courseExpirationDate"?: Date;
    "thresholdScore"?: number;
    "finalScore"?: number;
    "courseTitle": string;
    "courseDescription": string;
}

export interface EnrollmentLearnersTMCRequest {
    "courseId"?: number;
    "learnerIds"?: Array<string>;
    "courseDueDate"?: Date;
    "reminderDate"?: Date;
    "minimumScoreRequired"?: number;
}

export interface EnrollmentLists {
    "activeInProgress": Array<EnrollmentDetailsResponse>;
    "activeNotStarted": Array<EnrollmentDetailsResponse>;
    "activePastDue": Array<EnrollmentDetailsResponse>;
    "activeFailed": Array<EnrollmentDetailsResponse>;
    "completed": Array<EnrollmentDetailsResponse>;
}

export type EventAttributes = "None" | "SpecialName" | "RTSpecialName" | "ReservedMask";

export interface EventInfo {
    "name"?: string;
    "declaringType"?: Type;
    "reflectedType"?: Type;
    "module"?: Module;
    "customAttributes"?: Array<CustomAttributeData>;
    "isCollectible"?: boolean;
    "metadataToken"?: number;
    "memberType"?: MemberTypes;
    "attributes"?: EventAttributes;
    "isSpecialName"?: boolean;
    "addMethod"?: MethodInfo;
    "removeMethod"?: MethodInfo;
    "raiseMethod"?: MethodInfo;
    "isMulticast"?: boolean;
    "eventHandlerType"?: Type;
}

export interface EventNotificationResponse {
    "eventTypeId"?: number;
    "name"?: string;
    "isActive"?: boolean;
    "type"?: NotificationTypeEnum;
    "subscribers"?: number;
    "mergeableEventTypeIds"?: Array<number>;
}

export interface EventScore {
    "totalCount"?: number;
    "data"?: { [key: string]: number; };
}

export interface EventStatistics {
    "totalCount"?: number;
    "data"?: { [key: string]: EventStatisticsData; };
}

export interface EventStatisticsData {
    "eventType"?: string;
    "label"?: string;
    "totalCount"?: number;
    "drivers"?: Array<DriverStatistics>;
}

export interface EventStatus {
    "totalCount"?: number;
    "data"?: Array<EventStatusData>;
}

export interface EventStatusData {
    "statusKey"?: VideoEventWorkflowStatusIdEnum;
    "label"?: string;
    "count"?: number;
}

export interface Exception {
    "targetSite"?: MethodBase;
    "message"?: string;
    "data"?: any;
    "innerException"?: Exception;
    "helpLink"?: string;
    "source"?: string;
    "hResult"?: number;
    "stackTrace"?: string;
}

export type FieldAttributes = "PrivateScope" | "Private" | "FamANDAssem" | "Assembly" | "Family" | "FamORAssem" | "Public" | "FieldAccessMask" | "Static" | "InitOnly" | "Literal" | "NotSerialized" | "HasFieldRVA" | "SpecialName" | "RTSpecialName" | "HasFieldMarshal" | "PinvokeImpl" | "HasDefault" | "ReservedMask";

export interface FieldInfo {
    "name"?: string;
    "declaringType"?: Type;
    "reflectedType"?: Type;
    "module"?: Module;
    "customAttributes"?: Array<CustomAttributeData>;
    "isCollectible"?: boolean;
    "metadataToken"?: number;
    "memberType"?: MemberTypes;
    "attributes"?: FieldAttributes;
    "fieldType"?: Type;
    "isInitOnly"?: boolean;
    "isLiteral"?: boolean;
    "isNotSerialized"?: boolean;
    "isPinvokeImpl"?: boolean;
    "isSpecialName"?: boolean;
    "isStatic"?: boolean;
    "isAssembly"?: boolean;
    "isFamily"?: boolean;
    "isFamilyAndAssembly"?: boolean;
    "isFamilyOrAssembly"?: boolean;
    "isPrivate"?: boolean;
    "isPublic"?: boolean;
    "isSecurityCritical"?: boolean;
    "isSecuritySafeCritical"?: boolean;
    "isSecurityTransparent"?: boolean;
    "fieldHandle"?: RuntimeFieldHandle;
}

export type FileUploadExtensionEnum = "Mp4" | "Jpeg" | "Mp5" | "Txt" | "Webm" | "Ogv" | "png";

export type FileUploadTypeEnum = "FrontVideo" | "RearVideo" | "SideVideo" | "Log" | "AltVideo";

export type FilterTypeEnum = "Equals" | "In";

export interface FleetResponse {
    "id"?: number;
    "name"?: string;
    "pricingPlan"?: PricingPlanTypeEnum;
    "isActive"?: boolean;
    "cgRootId"?: string;
    "companyId"?: string;
    "isVrs"?: boolean;
    "isInternal"?: boolean;
}

export interface FleetSettingResponse {
    "key"?: string;
    "value"?: string;
}

export interface FleetTimezoneRequest {
    "timezone"?: string;
}

export interface FleetTimezoneResponse {
    "timezone"?: string;
}

export type GenericParameterAttributes = "None" | "Covariant" | "Contravariant" | "VarianceMask" | "ReferenceTypeConstraint" | "NotNullableValueTypeConstraint" | "DefaultConstructorConstraint" | "SpecialConstraintMask" | "AllowByRefLike";

export interface Group {
    "children"?: Array<Group>;
    "color"?: Color;
    "comments"?: string;
    "id"?: Id;
    "path"?: string;
    "name"?: string;
    "parent"?: Group;
    "reference"?: string;
}

export interface GroupDto {
    "id"?: string;
    "name"?: string;
    "isGlobalReportingGroup"?: boolean;
    "children"?: Array<GroupDto>;
}

export interface HealthCheckResponse {
}

export interface HealthCheckResponseResponseBase {
    "success"?: boolean;
    "error"?: Exception;
    "totalCount"?: number;
    "data"?: HealthCheckResponse;
}

export interface ICustomAttributeProvider {
}

export interface Id {
}

export interface ImpersonateUserRequest {
    "fleetId"?: number;
    "fleetName"?: string;
    "emailAddress"?: string;
    "reason"?: string;
}

export interface ImpersonateUserResponse {
    "fleetId"?: number;
    "impersonateUserInfo"?: string;
    "errorMessage"?: string;
}

export interface InstallerUserDatesUpdateRequest {
    "startDate"?: Date;
    "endDate"?: Date;
}

export interface InstallerUserRequest {
    "id"?: string;
    "firstName"?: string;
    "lastName"?: string;
    "email"?: string;
    "phoneNumber"?: string;
    "companyName"?: string;
    "startDate"?: Date;
    "endDate"?: Date;
}

export interface InstallerUserResponse {
    "id"?: string;
    "firstName"?: string;
    "lastName"?: string;
    "email"?: string;
    "phoneNumber"?: string;
    "companyName"?: string;
    "startDate"?: Date;
    "endDate"?: Date;
}

export interface IntPtr {
}

export type LayoutKind = "Sequential" | "Explicit" | "Auto";

export interface LearnerEnrollmentsTMCResponse {
    "driverId"?: number;
    "name"?: string;
    "email"?: string;
    "assignedLocationId"?: number;
    "assignedLocationName"?: string;
    "activeEnrollmentCount"?: number;
}

export interface LiveVideoEndTimeUpdateRequest {
    "cameraDeviceLiveVideoUsageId"?: number;
    "endTime"?: Date;
    "closeStream"?: boolean;
    "alertDriver"?: boolean;
}

export interface LiveVideoStartResponse {
    "cameraDeviceLiveVideoUsageId"?: number;
}

export interface LiveVideoStartTimeRequest {
    "vehicleCameraPairingId"?: number;
    "startTime"?: Date;
    "sessionId"?: string;
    "alertDriver"?: boolean;
}

export interface LiveVideoUrlResponse {
    "success"?: boolean;
    "message"?: string;
    "url"?: string;
    "usageAvailableSeconds"?: number;
    "sessionId"?: string;
}

export interface LocationDetailsResponse {
    "id"?: number;
    "fleetId"?: number;
    "name"?: string;
    "address"?: string;
    "city"?: string;
    "region"?: string;
    "postalCode"?: string;
    "contactNumber"?: string;
    "assignedDrivers"?: Array<DriverResponse>;
    "assignedVehicles"?: Array<VehicleResponse>;
    "totalAssets"?: number;
}

export interface LocationDetailsResponseResponseBase {
    "success"?: boolean;
    "error"?: Exception;
    "totalCount"?: number;
    "data"?: LocationDetailsResponse;
}

export interface LocationDriverRequest {
    "locationId"?: number;
    "driverIds": Array<number>;
}

export interface LocationFilterRequest {
    "locationIds": Array<number>;
}

export interface LocationFilterResponse {
    "id"?: number;
    "name"?: string;
}

export interface LocationInformationResponse {
    "id"?: number;
    "name"?: string;
    "region"?: string;
    "assignedDriversCount"?: number;
    "assignedVehiclesCount"?: number;
}

export interface LocationRequest {
    "name": string;
    "address"?: string;
    "city"?: string;
    "region"?: string;
    "postalCode"?: string;
    "contactNumber"?: string;
}

export interface LocationsResponse {
    "locations"?: Array<LocationInformationResponse>;
    "unassignedDrivers"?: Array<DriverResponse>;
    "unassignedVehicles"?: Array<VehicleResponse>;
}

export interface LocationsResponseResponseBase {
    "success"?: boolean;
    "error"?: Exception;
    "totalCount"?: number;
    "data"?: LocationsResponse;
}

export interface LogRequest {
    "videoEventId"?: number;
}

export interface MemberInfo {
    "memberType"?: MemberTypes;
    "name"?: string;
    "declaringType"?: Type;
    "reflectedType"?: Type;
    "module"?: Module;
    "customAttributes"?: Array<CustomAttributeData>;
    "isCollectible"?: boolean;
    "metadataToken"?: number;
}

export type MemberTypes = "Constructor" | "Event" | "Field" | "Method" | "Property" | "TypeInfo" | "Custom" | "NestedType" | "All";

export interface MessageResponse {
    "message"?: string;
}

export type MethodAttributes = "PrivateScope" | "ReuseSlot" | "Private" | "FamANDAssem" | "Assembly" | "Family" | "FamORAssem" | "Public" | "MemberAccessMask" | "UnmanagedExport" | "Static" | "Final" | "Virtual" | "HideBySig" | "NewSlot" | "VtableLayoutMask" | "CheckAccessOnOverride" | "Abstract" | "SpecialName" | "RTSpecialName" | "PinvokeImpl" | "HasSecurity" | "RequireSecObject" | "ReservedMask";

export interface MethodBase {
    "memberType"?: MemberTypes;
    "name"?: string;
    "declaringType"?: Type;
    "reflectedType"?: Type;
    "module"?: Module;
    "customAttributes"?: Array<CustomAttributeData>;
    "isCollectible"?: boolean;
    "metadataToken"?: number;
    "attributes"?: MethodAttributes;
    "methodImplementationFlags"?: MethodImplAttributes;
    "callingConvention"?: CallingConventions;
    "isAbstract"?: boolean;
    "isConstructor"?: boolean;
    "isFinal"?: boolean;
    "isHideBySig"?: boolean;
    "isSpecialName"?: boolean;
    "isStatic"?: boolean;
    "isVirtual"?: boolean;
    "isAssembly"?: boolean;
    "isFamily"?: boolean;
    "isFamilyAndAssembly"?: boolean;
    "isFamilyOrAssembly"?: boolean;
    "isPrivate"?: boolean;
    "isPublic"?: boolean;
    "isConstructedGenericMethod"?: boolean;
    "isGenericMethod"?: boolean;
    "isGenericMethodDefinition"?: boolean;
    "containsGenericParameters"?: boolean;
    "methodHandle"?: RuntimeMethodHandle;
    "isSecurityCritical"?: boolean;
    "isSecuritySafeCritical"?: boolean;
    "isSecurityTransparent"?: boolean;
}

export type MethodImplAttributes = "IL" | "Managed" | "Native" | "OPTIL" | "CodeTypeMask" | "Runtime" | "ManagedMask" | "Unmanaged" | "NoInlining" | "ForwardRef" | "Synchronized" | "NoOptimization" | "PreserveSig" | "AggressiveInlining" | "AggressiveOptimization" | "InternalCall" | "Async" | "MaxMethodImplVal";

export interface MethodInfo {
    "name"?: string;
    "declaringType"?: Type;
    "reflectedType"?: Type;
    "module"?: Module;
    "customAttributes"?: Array<CustomAttributeData>;
    "isCollectible"?: boolean;
    "metadataToken"?: number;
    "attributes"?: MethodAttributes;
    "methodImplementationFlags"?: MethodImplAttributes;
    "callingConvention"?: CallingConventions;
    "isAbstract"?: boolean;
    "isConstructor"?: boolean;
    "isFinal"?: boolean;
    "isHideBySig"?: boolean;
    "isSpecialName"?: boolean;
    "isStatic"?: boolean;
    "isVirtual"?: boolean;
    "isAssembly"?: boolean;
    "isFamily"?: boolean;
    "isFamilyAndAssembly"?: boolean;
    "isFamilyOrAssembly"?: boolean;
    "isPrivate"?: boolean;
    "isPublic"?: boolean;
    "isConstructedGenericMethod"?: boolean;
    "isGenericMethod"?: boolean;
    "isGenericMethodDefinition"?: boolean;
    "containsGenericParameters"?: boolean;
    "methodHandle"?: RuntimeMethodHandle;
    "isSecurityCritical"?: boolean;
    "isSecuritySafeCritical"?: boolean;
    "isSecurityTransparent"?: boolean;
    "memberType"?: MemberTypes;
    "returnParameter"?: ParameterInfo;
    "returnType"?: Type;
    "returnTypeCustomAttributes"?: ICustomAttributeProvider;
}

export interface Module {
    "assembly"?: Assembly;
    "fullyQualifiedName"?: string;
    "name"?: string;
    "mdStreamVersion"?: number;
    "moduleVersionId"?: string;
    "scopeName"?: string;
    "moduleHandle"?: ModuleHandle;
    "customAttributes"?: Array<CustomAttributeData>;
    "metadataToken"?: number;
}

export interface ModuleHandle {
    "mdStreamVersion"?: number;
}

export type NotificationTypeEnum = "Event" | "Fault" | "Recall";

export type ParameterAttributes = "None" | "In" | "Out" | "Lcid" | "Retval" | "Optional" | "HasDefault" | "HasFieldMarshal" | "Reserved3" | "Reserved4" | "ReservedMask";

export interface ParameterInfo {
    "attributes"?: ParameterAttributes;
    "member"?: MemberInfo;
    "name"?: string;
    "parameterType"?: Type;
    "position"?: number;
    "isIn"?: boolean;
    "isLcid"?: boolean;
    "isOptional"?: boolean;
    "isOut"?: boolean;
    "isRetval"?: boolean;
    "hasDefaultValue"?: boolean;
    "customAttributes"?: Array<CustomAttributeData>;
    "metadataToken"?: number;
}

export type PricingPlanFeatureTypeEnum = "GeotabIntegration" | "SingleSignOn" | "Tier1Support" | "RoadFacingVideoRecording" | "VideoRecall" | "CourtReporter" | "GeotabEventTrigger_Collision" | "VideoEventScoring" | "VideoEventWorkflow" | "VideoEventStatusWorkflow" | "InVehicleAudioAlerts_DistractedDriving" | "InVehicleAudioAlerts_FollowingTooClose" | "InVehicleAudioAlerts_ForwardCollision" | "HighVideoDataSecurity" | "GeotabEventTrigger_HarshAcceleration" | "DriverFacingVideoRecording" | "AIEventTrigger_NoDriver" | "DriverCoachingWorkflowApp" | "InVehicleCamera_CargoInterior" | "GeotabEventTrigger_HarshBraking" | "GeotabEventTrigger_HarshCornering" | "AIEventTrigger_DriverFatigue" | "AIEventTrigger_CellPhone" | "AIEventTrigger_DistractedDriver" | "AIEventTrigger_ForwardCollisionWarning" | "AIEventTrigger_HeadwayMonitoring" | "AIEventTrigger_PedestrianCollisionWarning" | "AIEventTrigger_NoSeatbelt" | "GenericEventTrigger_DriverInitiated" | "GforceEventTrigger_HarshAcceleration" | "GforceEventTrigger_HarshBraking" | "GforceEventTrigger_HarshCornering" | "AIEventTrigger_VideoLoss" | "AIEventTrigger_LensCovered" | "AIEventTrigger_StorageMalfunction" | "AIEventTrigger_OverSpeed" | "AIEventTrigger_LowVoltage" | "AIEventTrigger_ACCAlarm" | "AIEventTrigger_DriverSmoking" | "AIEventTrigger_LaneDepartureWarning" | "AIEventTrigger_StopSignViolationAlarm" | "AIEventTrigger_SpeedLimitSignViolationAlarm" | "AIEventTrigger_PowerFailureAlarm" | "AIEventTrigger_Yawn" | "GeotabEventTrigger_NoSeatbelt" | "GeotabEventTrigger_NoSeatbeltCustom" | "CriticalSpeeding" | "GforceEventTrigger_HarshCorneringLeftTurn" | "Streamax_CollisionDetected" | "IXT_ExcessiveSafetyIncident" | "Divert_ExcessiveSafetyIncident" | "Crossland_ExcessiveSafetyIncident" | "Roanoke_ExcessiveSafetyIncident" | "Legacy_ExcessiveSafetyIncident" | "Southern_ExcessiveSafetyIncident" | "American_ExcessiveSafetyIncident" | "IXT_HarshBraking" | "Divert_HarshBraking" | "Crossland_HarshBraking" | "Roanoke_HarshBraking" | "Legacy_HarshBraking" | "Southern_HarshBraking" | "AmericanLinen_HarshBraking" | "IXT_HarshCornering" | "Divert_HarshCornering" | "Crossland_HarshCornering" | "Roanoke_HarshCornering" | "Legacy_HarshCornering" | "Southern_HarshCornering" | "AmericanLinen_HarshCornering" | "Divert_SeatBelt" | "GeotabEventTrigger_MajorCollision" | "Ambipar_SeatBelt" | "GeotabEventTrigger_MinorCollision";

export interface PricingPlanResponse {
    "fleetId"?: number;
    "features"?: Array<PricingPlanFeatureTypeEnum>;
}

export type PricingPlanTypeEnum = "Base" | "Pro" | "ProPlus";

export type PropertyAttributes = "None" | "SpecialName" | "RTSpecialName" | "HasDefault" | "Reserved2" | "Reserved3" | "Reserved4" | "ReservedMask";

export interface PropertyInfo {
    "name"?: string;
    "declaringType"?: Type;
    "reflectedType"?: Type;
    "module"?: Module;
    "customAttributes"?: Array<CustomAttributeData>;
    "isCollectible"?: boolean;
    "metadataToken"?: number;
    "memberType"?: MemberTypes;
    "propertyType"?: Type;
    "attributes"?: PropertyAttributes;
    "isSpecialName"?: boolean;
    "canRead"?: boolean;
    "canWrite"?: boolean;
    "getMethod"?: MethodInfo;
    "setMethod"?: MethodInfo;
}

export interface Ranking {
    "name"?: string;
    "eventCount"?: number;
    "score"?: number;
}

export interface ReminderNotificationTMCRequest {
    "enrollmentIds"?: Array<number>;
}

export interface RosterViewRequest {
    "rosterPageEnum"?: number;
    "columnFilter"?: string;
    "columnVisibility"?: string;
    "columnOrder"?: string;
    "dateRangeFilter"?: string;
}

export interface RosterViewResponse {
    "rosterPageEnum"?: number;
    "columnFilter"?: string;
    "columnVisibility"?: string;
    "columnOrder"?: string;
    "dateRangeFilter"?: string;
}

export interface RosterViewResponseResponseBase {
    "success"?: boolean;
    "error"?: Exception;
    "totalCount"?: number;
    "data"?: RosterViewResponse;
}

export interface RuntimeFieldHandle {
    "value"?: IntPtr;
}

export interface RuntimeMethodHandle {
    "value"?: IntPtr;
}

export interface RuntimeTypeHandle {
    "value"?: IntPtr;
}

export type SecurityRuleSet = "None" | "Level1" | "Level2";

export interface SendEmailRequest {
    "videoEventId"?: number;
    "emailAddress": string;
    "timezoneOffsetHrs"?: number;
    "timezoneName"?: string;
}

export interface SendTextRequest {
    "videoEventId"?: number;
    "phoneNumber": string;
    "timezoneOffsetHrs"?: number;
    "timezoneName"?: string;
}

export interface SignedAgreementHistoryRequest {
    "agreementsVersionId"?: number;
    "signedOn"?: Date;
    "matches"?: boolean;
}

export interface SignedAgreementHistoryResponse {
    "agreementsVersionId"?: number;
    "signedOn"?: Date;
    "matches"?: boolean;
}

export interface SpeedGraphPointResponse {
    "id"?: number;
    "speed"?: number;
    "time"?: Date;
    "videoEventId"?: number;
}

export type SpeedTypeEnum = "MilesPerHour" | "KilometersPerHour";

export interface SplitFeatureToggle {
    "featureToggle"?: string;
    "isSplitOn"?: boolean;
}

export interface SplitTreatmentOptions {
    "featureToggle"?: string;
    "attributes"?: any;
    "controlDefault"?: boolean;
}

export interface StandaloneVideoEventFilterMultiselectRequest {
    "eventTypes"?: Array<number>;
    "driverIds"?: Array<number>;
    "startDate"?: Date;
    "endDate"?: Date;
    "vehicleIds"?: Array<number>;
    "currentPage"?: number;
    "itemsPerPage"?: number;
    "sortBy"?: string;
    "sortAsc"?: boolean;
    "flaggedUsers"?: Array<string>;
    "showVideoPipelineSuccessOnly"?: boolean;
    "videoEventId"?: number;
    "status"?: Array<VideoEventWorkflowStatusIdEnum>;
    "scoreIds"?: Array<number>;
    "fromHours"?: number;
    "toHours"?: number;
    "timezoneOffset"?: number;
    "locationIds"?: Array<number>;
}

export interface StandaloneVideoEventResponse {
    "id"?: number;
    "displayId"?: string;
    "videoEventType"?: Array<number>;
    "driverFirstName"?: string;
    "driverLastName"?: string;
    "driverFullName"?: string;
    "driverId"?: number;
    "eventStartDate"?: Date;
    "eventEndDate"?: Date;
    "vehicleName"?: string;
    "flaggedByUsers"?: Array<UserResponse>;
    "score"?: number;
    "videoEventStatus"?: VideoEventWorkflowStatusIdEnum;
    "videoEventTypePairings"?: Array<VideoEventTypePairingResponse>;
    "videoEventTypeString"?: string;
    "workflowStep"?: VideoEventPipelineStepEnum;
    "latitude"?: number;
    "longitude"?: number;
}

export interface StandaloneVideoEventResponseIEnumerablePagedResponseBase {
    "success"?: boolean;
    "error"?: Exception;
    "totalCount"?: number;
    "data"?: Array<StandaloneVideoEventResponse>;
    "currentPage"?: number;
    "itemsPerPage"?: number;
    "totalPages"?: number;
}

export interface StandaloneVideoEventResponseIEnumerableResponseBase {
    "success"?: boolean;
    "error"?: Exception;
    "totalCount"?: number;
    "data"?: Array<StandaloneVideoEventResponse>;
}

/**
 *   This model represents the statistics dashboard filter model.
 */
export interface StatisticsDashboardFilterModel {
    /**
     *   The statistics date to start from.  This is inclusive.
     */
    "startDate"?: Date;
    /**
     *   The statistics date to end with.  This is inclusive.
     */
    "endDate"?: Date;
    /**
     *   The group filter.    Currently, this is a System.String comma seperated list of identifiers.
     */
    "groupsFilter"?: string;
    /**
     *   List of location ids for filter data. used for Standalone
     */
    "locationIds"?: Array<number>;
}

export interface StructLayoutAttribute {
    "value"?: LayoutKind;
}

export interface SubscriberRequest {
    "id"?: number;
    "name": string;
    "email"?: string;
    "emailPreferred"?: boolean;
    "textPreferred"?: boolean;
    "phone"?: string;
    "subscriptionsCount"?: number;
    "subscriptionEventTypeIds"?: Array<number>;
    "isActive"?: boolean;
    "dateSubscribed"?: Date;
}

export interface SubscriberResponse {
    "id"?: number;
    "name"?: string;
    "email"?: string;
    "emailPreferred"?: boolean;
    "textPreferred"?: boolean;
    "phone"?: string;
    "subscriptionsCount"?: number;
    "subscriptionEventTypeIds"?: Array<number>;
    "isActive"?: boolean;
    "dateSubscribed"?: Date;
}

export interface TelematicDeviceRequest {
    "serialNumber"?: string;
    "deviceId"?: string;
    "name"?: string;
    "id"?: number;
    "type"?: string;
    "provider"?: string;
}

export interface TelematicDeviceResponse {
    "serialNumber"?: string;
    "deviceId"?: string;
    "name"?: string;
    "id"?: number;
    "type"?: string;
    "provider"?: string;
}

export interface TelematicProviderDriverResponse {
    "firstName"?: string;
    "lastName"?: string;
    "id"?: string;
    "email"?: string;
    "phoneNumber"?: string;
    "isActive"?: boolean;
}

export interface TelematicProviderUserResponse {
    "name"?: string;
    "lastName"?: string;
    "firstName"?: string;
    "id"?: string;
    "isMetric"?: boolean;
    "isRootLevel"?: boolean;
    "securityGroups"?: Array<Group>;
    "companyGroups"?: Array<GroupDto>;
}

export interface TelematicProviderVehiclePairingsResponse {
    "cameraId"?: number;
    "cameraSerialNumber"?: string;
    "startDate"?: Date;
    "endDate"?: Date;
}

export interface TelematicProviderVehicleResponse {
    "name"?: string;
    "id"?: string;
    "serialNumber"?: string;
    "isActive"?: boolean;
    "deviceType"?: string;
    "companyLevelId"?: string;
    "companyLevelName"?: string;
    "pairings"?: Array<TelematicProviderVehiclePairingsResponse>;
}

export interface TimezoneResponse {
    "id"?: number;
    "name"?: string;
}

export interface TimezoneResponseIEnumerableResponseBase {
    "success"?: boolean;
    "error"?: Exception;
    "totalCount"?: number;
    "data"?: Array<TimezoneResponse>;
}

export interface Type {
    "name"?: string;
    "customAttributes"?: Array<CustomAttributeData>;
    "isCollectible"?: boolean;
    "metadataToken"?: number;
    "memberType"?: MemberTypes;
    "namespace"?: string;
    "assemblyQualifiedName"?: string;
    "fullName"?: string;
    "assembly"?: Assembly;
    "module"?: Module;
    "isInterface"?: boolean;
    "isNested"?: boolean;
    "declaringType"?: Type;
    "declaringMethod"?: MethodBase;
    "reflectedType"?: Type;
    "underlyingSystemType"?: Type;
    "isTypeDefinition"?: boolean;
    "isArray"?: boolean;
    "isByRef"?: boolean;
    "isPointer"?: boolean;
    "isConstructedGenericType"?: boolean;
    "isGenericParameter"?: boolean;
    "isGenericTypeParameter"?: boolean;
    "isGenericMethodParameter"?: boolean;
    "isGenericType"?: boolean;
    "isGenericTypeDefinition"?: boolean;
    "isSZArray"?: boolean;
    "isVariableBoundArray"?: boolean;
    "isByRefLike"?: boolean;
    "isFunctionPointer"?: boolean;
    "isUnmanagedFunctionPointer"?: boolean;
    "hasElementType"?: boolean;
    "genericTypeArguments"?: Array<Type>;
    "genericParameterPosition"?: number;
    "genericParameterAttributes"?: GenericParameterAttributes;
    "attributes"?: TypeAttributes;
    "isAbstract"?: boolean;
    "isImport"?: boolean;
    "isSealed"?: boolean;
    "isSpecialName"?: boolean;
    "isClass"?: boolean;
    "isNestedAssembly"?: boolean;
    "isNestedFamANDAssem"?: boolean;
    "isNestedFamily"?: boolean;
    "isNestedFamORAssem"?: boolean;
    "isNestedPrivate"?: boolean;
    "isNestedPublic"?: boolean;
    "isNotPublic"?: boolean;
    "isPublic"?: boolean;
    "isAutoLayout"?: boolean;
    "isExplicitLayout"?: boolean;
    "isLayoutSequential"?: boolean;
    "isAnsiClass"?: boolean;
    "isAutoClass"?: boolean;
    "isUnicodeClass"?: boolean;
    "isCOMObject"?: boolean;
    "isContextful"?: boolean;
    "isEnum"?: boolean;
    "isMarshalByRef"?: boolean;
    "isPrimitive"?: boolean;
    "isValueType"?: boolean;
    "isSignatureType"?: boolean;
    "isSecurityCritical"?: boolean;
    "isSecuritySafeCritical"?: boolean;
    "isSecurityTransparent"?: boolean;
    "structLayoutAttribute"?: StructLayoutAttribute;
    "typeInitializer"?: ConstructorInfo;
    "typeHandle"?: RuntimeTypeHandle;
    "guid"?: string;
    "baseType"?: Type;
    "isSerializable"?: boolean;
    "containsGenericParameters"?: boolean;
    "isVisible"?: boolean;
}

export type TypeAttributes = "NotPublic" | "AutoLayout" | "AnsiClass" | "Class" | "Public" | "NestedPublic" | "NestedPrivate" | "NestedFamily" | "NestedAssembly" | "NestedFamANDAssem" | "VisibilityMask" | "NestedFamORAssem" | "SequentialLayout" | "ExplicitLayout" | "LayoutMask" | "Interface" | "ClassSemanticsMask" | "Abstract" | "Sealed" | "SpecialName" | "RTSpecialName" | "Import" | "Serializable" | "WindowsRuntime" | "UnicodeClass" | "AutoClass" | "StringFormatMask" | "CustomFormatClass" | "HasSecurity" | "ReservedMask" | "BeforeFieldInit" | "CustomFormatMask";

export interface TypeInfo {
    "name"?: string;
    "customAttributes"?: Array<CustomAttributeData>;
    "isCollectible"?: boolean;
    "metadataToken"?: number;
    "memberType"?: MemberTypes;
    "namespace"?: string;
    "assemblyQualifiedName"?: string;
    "fullName"?: string;
    "assembly"?: Assembly;
    "module"?: Module;
    "isInterface"?: boolean;
    "isNested"?: boolean;
    "declaringType"?: Type;
    "declaringMethod"?: MethodBase;
    "reflectedType"?: Type;
    "underlyingSystemType"?: Type;
    "isTypeDefinition"?: boolean;
    "isArray"?: boolean;
    "isByRef"?: boolean;
    "isPointer"?: boolean;
    "isConstructedGenericType"?: boolean;
    "isGenericParameter"?: boolean;
    "isGenericTypeParameter"?: boolean;
    "isGenericMethodParameter"?: boolean;
    "isGenericType"?: boolean;
    "isGenericTypeDefinition"?: boolean;
    "isSZArray"?: boolean;
    "isVariableBoundArray"?: boolean;
    "isByRefLike"?: boolean;
    "isFunctionPointer"?: boolean;
    "isUnmanagedFunctionPointer"?: boolean;
    "hasElementType"?: boolean;
    "genericTypeArguments"?: Array<Type>;
    "genericParameterPosition"?: number;
    "genericParameterAttributes"?: GenericParameterAttributes;
    "attributes"?: TypeAttributes;
    "isAbstract"?: boolean;
    "isImport"?: boolean;
    "isSealed"?: boolean;
    "isSpecialName"?: boolean;
    "isClass"?: boolean;
    "isNestedAssembly"?: boolean;
    "isNestedFamANDAssem"?: boolean;
    "isNestedFamily"?: boolean;
    "isNestedFamORAssem"?: boolean;
    "isNestedPrivate"?: boolean;
    "isNestedPublic"?: boolean;
    "isNotPublic"?: boolean;
    "isPublic"?: boolean;
    "isAutoLayout"?: boolean;
    "isExplicitLayout"?: boolean;
    "isLayoutSequential"?: boolean;
    "isAnsiClass"?: boolean;
    "isAutoClass"?: boolean;
    "isUnicodeClass"?: boolean;
    "isCOMObject"?: boolean;
    "isContextful"?: boolean;
    "isEnum"?: boolean;
    "isMarshalByRef"?: boolean;
    "isPrimitive"?: boolean;
    "isValueType"?: boolean;
    "isSignatureType"?: boolean;
    "isSecurityCritical"?: boolean;
    "isSecuritySafeCritical"?: boolean;
    "isSecurityTransparent"?: boolean;
    "structLayoutAttribute"?: StructLayoutAttribute;
    "typeInitializer"?: ConstructorInfo;
    "typeHandle"?: RuntimeTypeHandle;
    "guid"?: string;
    "baseType"?: Type;
    "isSerializable"?: boolean;
    "containsGenericParameters"?: boolean;
    "isVisible"?: boolean;
    "genericTypeParameters"?: Array<Type>;
    "declaredConstructors"?: Array<ConstructorInfo>;
    "declaredEvents"?: Array<EventInfo>;
    "declaredFields"?: Array<FieldInfo>;
    "declaredMembers"?: Array<MemberInfo>;
    "declaredMethods"?: Array<MethodInfo>;
    "declaredNestedTypes"?: Array<TypeInfo>;
    "declaredProperties"?: Array<PropertyInfo>;
    "implementedInterfaces"?: Array<Type>;
}

export interface UnenrollEnrollmentsRequest {
    "enrollmentIds": Array<number>;
}

export interface UnenrollEnrollmentsResponse {
    "failedEnrollmentIds"?: Array<number>;
}

export interface UpdateCriticalSpeedRequest {
    "speedThreshold": number;
    "speedTypeEnum"?: SpeedTypeEnum;
}

export interface UpdateEnrollmentTMCRequest {
    "enrollmentId": number;
    "thresholdScore"?: number;
    "dueDate"?: Date;
}

export interface UserAllowedToFlagResponse {
    "id"?: string;
    "fullName"?: string;
}

export interface UserAllowedToFlagResponseIEnumerableResponseBase {
    "success"?: boolean;
    "error"?: Exception;
    "totalCount"?: number;
    "data"?: Array<UserAllowedToFlagResponse>;
}

export interface UserInformationResponse {
    "userId"?: string;
    "firstName"?: string;
    "lastName"?: string;
    "fullName"?: string;
    "email"?: string;
    "isActive"?: boolean;
    "isDeleted"?: boolean;
    "currentFleet"?: FleetResponse;
    "availableFleets"?: Array<FleetResponse>;
    "timezone"?: TimezoneResponse;
    "country"?: CountryResponse;
    "measurementSystem"?: string;
    "roleIds"?: Array<number>;
}

export interface UserInformationResponseResponseBase {
    "success"?: boolean;
    "error"?: Exception;
    "totalCount"?: number;
    "data"?: UserInformationResponse;
}

export interface UserNameResponse {
    "fullName"?: string;
}

export interface UserNameResponseIEnumerableResponseBase {
    "success"?: boolean;
    "error"?: Exception;
    "totalCount"?: number;
    "data"?: Array<UserNameResponse>;
}

export interface UserResponse {
    "id"?: string;
    "integrationProviderSourceId"?: string;
    "displayName"?: string;
    "email"?: string;
    "jobTitle"?: string;
}

export interface UserRolesResponse {
    "userId"?: string;
    "name"?: string;
    "email"?: string;
    "roleIds"?: Array<string>;
}

export interface UserRolesUpdateRequest {
    "userId"?: string;
    "email"?: string;
    "roles"?: Array<number>;
}

export interface UserSettingsRequest {
    "countryId": number;
    "timezoneId": number;
    "measurementSystem": string;
    "notes"?: string;
    "jobTitle"?: string;
}

export interface UsersByFleetResponse {
    "id"?: string;
    "integrationProviderSourceId"?: string;
    "displayName"?: string;
    "email"?: string;
    "jobTitle"?: string;
    "isActive"?: boolean;
    "roleName"?: string;
    "userFleet"?: FleetResponse;
}

export interface UsersByFleetResponseIEnumerableResponseBase {
    "success"?: boolean;
    "error"?: Exception;
    "totalCount"?: number;
    "data"?: Array<UsersByFleetResponse>;
}

export interface VehicleCameraPairingRequest {
    "id"?: number;
    "vehicleId"?: number;
    "cameraDeviceId"?: number;
    "startDate"?: Date;
    "endDate"?: Date;
    "isGpsTrackingEnabled"?: boolean;
    "cameraDevice"?: CameraDeviceRequest;
    "vehicle"?: VehicleRequest;
}

export interface VehicleCameraPairingResponse {
    "id"?: number;
    "vehicleId"?: number;
    "cameraDeviceId"?: number;
    "startDate"?: Date;
    "endDate"?: Date;
    "cameraDevice"?: CameraDeviceResponse;
    "vehicle"?: VehicleResponse;
    "isGpsTrackingEnabled"?: boolean;
    "createdById"?: string;
    "encompassErrorMessage"?: string;
}

export interface VehicleDetailsResponse {
    "id"?: number;
    "name"?: string;
    "vin"?: string;
    "integrationPartnerVehicleId"?: string;
    "telematicDeviceId"?: number;
    "createdOn"?: Date;
    "isDeleted"?: boolean;
    "deviceSerialNumber"?: string;
    "assignedDriverName"?: string;
    "assignedDriverId"?: number;
    "assignedLocationName"?: string;
    "assignedLocationId"?: number;
    "vehicleComments"?: Array<CommentResponse>;
    "lastKnownLocation"?: VideoEventLocationResponse;
}

export interface VehicleDetailsResponseResponseBase {
    "success"?: boolean;
    "error"?: Exception;
    "totalCount"?: number;
    "data"?: VehicleDetailsResponse;
}

export interface VehicleHistoryPoint {
    "vehicleId"?: number;
    "locationPointDateTime"?: Date;
    "address"?: AlkAddress;
    "speed"?: number;
    "latitude"?: number;
    "longitude"?: number;
}

export interface VehicleHistoryResponse {
    "vehicleId"?: number;
    "history"?: Array<VehicleHistoryPoint>;
}

export interface VehicleMapLocationResponse {
    "vehicleId"?: number;
    "angle"?: number;
    "latitude"?: number;
    "longitude"?: number;
    "speed"?: number;
    "cameraSerialNumber"?: string;
    "startDateTime"?: Date;
    "endDateTime"?: Date;
    "locationPointDateTime"?: Date;
}

export interface VehicleRequest {
    "id"?: number;
    "name"?: string;
    "vin"?: string;
    "integrationPartnerVehicleId"?: string;
    "telematicDeviceId"?: number;
    "telematicDevice"?: TelematicDeviceRequest;
    "companyLevelId"?: string;
    "companyLevelName"?: string;
}

export interface VehicleResponse {
    "id"?: number;
    "name"?: string;
    "vin"?: string;
    "integrationPartnerVehicleId"?: string;
    "telematicDeviceId"?: number;
    "telematicDevice"?: TelematicDeviceResponse;
    "createdOn"?: Date;
    "assignedLocationName"?: string;
    "assignedLocationId"?: number;
    "locationAssignedDate"?: Date;
    "assignedDriverName"?: string;
    "assignedDriverId"?: string;
    "isDeleted"?: boolean;
    "deviceSerialNumber"?: string;
    "companyLevelId"?: string;
    "companyLevelName"?: string;
}

export interface VehicleResponseIEnumerableResponseBase {
    "success"?: boolean;
    "error"?: Exception;
    "totalCount"?: number;
    "data"?: Array<VehicleResponse>;
}

export interface VehiclesLocationRequest {
    "locationId"?: number;
    "vehicleIds"?: Array<number>;
}

export interface VideoAssetResponse {
    "id"?: number;
    "creationDate"?: Date;
    "fileUploadExtensionId"?: FileUploadExtensionEnum;
    "fileUploadTypeId"?: FileUploadTypeEnum;
    "fileUploadTypeDisplayName"?: string;
    "fileUploadId"?: number;
    "type"?: VideoAssetTypeEnum;
    "videoAssetStorageId"?: VideoAssetStorageEnum;
    "storageDetailsJson"?: string;
    "status"?: VideoAssetStatusEnum;
    "aspectRatio"?: string;
    "channelNumber"?: number;
    "aivideoAvailable"?: boolean;
    "aiVideoUrl"?: string;
}

export type VideoAssetStatusEnum = "Idle" | "CheckOut" | "Generating" | "CheckIn" | "Success" | "Failed";

export type VideoAssetStorageEnum = "GeotabApi" | "GcpFs" | "Controller";

export type VideoAssetTypeEnum = "Upload" | "Full" | "Thumbnail" | "Transcode" | "Preview";

export interface VideoCommentRequest {
    "comment": string;
}

export interface VideoEventActionResponse {
    "id"?: number;
    "actionType"?: VideoEventActionTypeEnum;
    "actionDescription"?: string;
    "actionDate"?: Date;
    "createdBy"?: UserResponse;
}

export type VideoEventActionTypeEnum = "ScoreChanged" | "EventFlagged" | "VideoDownloaded" | "EventDismissed" | "EventCompleted" | "EventReopened" | "PlayedVideo" | "EventStatusChanged" | "CommentAdded" | "CommentDeleted" | "CommentEdited" | "ActionTakenStatus" | "DriverClickedLink" | "DriverStartedWatchingVideo" | "DriverCompletedWatchingVideo" | "EventUnflagged" | "EmailedDriver" | "TextedDriver" | "VideoRecallPromoted" | "DriverChanged" | "VideosWatched" | "VideoExported" | "TrainingCourseEnrolled";

export type VideoEventAdminResolutionEnum = "ReviewedWithDriver" | "DisciplinedDriver" | "SubmittedToInsurance" | "SavedForFutureReference" | "TerminatedDriver" | "Other" | "FalsePositive" | "Dismissed";

export interface VideoEventCommentResponse {
    "id"?: number;
    "videoEventId"?: number;
    "comment"?: string;
    "createdBy"?: string;
    "createdById"?: string;
    "createdOn"?: Date;
    "editedBy"?: string;
    "editedById"?: string;
    "editedOn"?: Date;
}

export interface VideoEventDeletionResponse {
    "videoEventId"?: Array<number>;
}

export interface VideoEventDriverRequest {
    "id"?: string;
    "firstName"?: string;
    "lastName"?: string;
    "email"?: string;
    "phoneNumber"?: string;
}

export interface VideoEventFilterMultiselectRequest {
    "eventTypes"?: Array<number>;
    "driverNames"?: Array<string>;
    "startDate"?: Date;
    "endDate"?: Date;
    "vehicleIds"?: Array<string>;
    "currentPage"?: number;
    "itemsPerPage"?: number;
    "sortBy"?: string;
    "sortAsc"?: boolean;
    "showFlaggedByUserOnly"?: boolean;
    "showFlaggedOnly"?: boolean;
    "showVideoPipelineSuccessOnly"?: boolean;
    "status"?: Array<VideoEventWorkflowStatusIdEnum>;
    "isNull"?: boolean;
    "groupsFilter"?: string;
    "scoreIds"?: Array<number>;
    "flaggedStatus"?: Array<number>;
    "includeInactiveDrivers"?: boolean;
    "includeInactiveVehicles"?: boolean;
    "companyLevelIds"?: Array<string>;
}

export interface VideoEventFilterRequest {
    "eventType"?: number;
    "driverName"?: Array<string>;
    "startDate"?: Date;
    "endDate"?: Date;
    "vehicleId"?: Array<string>;
    "currentPage"?: number;
    "itemsPerPage"?: number;
    "sortBy"?: string;
    "sortAsc"?: boolean;
    "showVideoPipelineSuccessOnly"?: boolean;
    "status"?: Array<VideoEventWorkflowStatusIdEnum>;
    "groupsFilter"?: string;
    "includeInactiveVehicles"?: boolean;
}

/**
 *   This is the response object for !:GetFullVideoEventIdList
 */
export interface VideoEventFullListResponse {
    /**
     *   The count of all items.
     */
    "count"?: number;
    /**
     *   A list of video event ids from the filter response
     */
    "videoEventIdList"?: Array<number>;
    /**
     *   A list of video event ids from the filter response
     */
    "videoEventDisplayIdList"?: Array<string>;
}

export interface VideoEventHistoryTableResponse {
    "actionDescription"?: string;
    "createdByName"?: string;
    "actionDate"?: Date;
    "videoEventHistoryActionName"?: VideoEventActionTypeEnum;
}

export interface VideoEventHistoryTableResponseIEnumerableResponseBase {
    "success"?: boolean;
    "error"?: Exception;
    "totalCount"?: number;
    "data"?: Array<VideoEventHistoryTableResponse>;
}

export interface VideoEventIdResponse {
    "id"?: number;
    "displayId"?: string;
}

export interface VideoEventIdResponseListResponseBase {
    "success"?: boolean;
    "error"?: Exception;
    "totalCount"?: number;
    "data"?: Array<VideoEventIdResponse>;
}

export type VideoEventInitiatorEnum = "GeotabEventETLProcessor" | "Manual" | "IntegrationTest";

export interface VideoEventLocationResponse {
    "videoEventId"?: number;
    "eventStartDate"?: Date;
    "latitude"?: number;
    "longitude"?: number;
}

export interface VideoEventPipelineStepDescriptionResponse {
    "id"?: number;
    "displayName"?: string;
    "sysName"?: string;
    "description"?: string;
}

export type VideoEventPipelineStepEnum = "Idle" | "CameraRequest" | "UploadWait" | "VideoProcessing" | "Success" | "Failed" | "CameraPrepare" | "PreparedIdle" | "UploadedIdle" | "CameraDownload" | "DownloadedIdle" | "Purged";

export interface VideoEventReportResponse {
    "id"?: number;
    "displayId"?: string;
    "videoEventType"?: Array<number>;
    "videoEventTypePairings"?: Array<VideoEventTypePairingResponse>;
    "driverName"?: string;
    "eventStartDate"?: Date;
    "addressStreetNumber"?: string;
    "addressRegion"?: string;
    "addressStreetName"?: string;
    "addressPostalCode"?: string;
    "addressCityName"?: string;
    "kphStart"?: number;
    "kphEnd"?: number;
    "vehicleDescription"?: string;
    "integrationPartnerVehicleId"?: string;
    "companyLevelName"?: string;
    "actionHistory"?: Array<VideoEventActionResponse>;
    "isFlagged"?: boolean;
    "score"?: number;
    "videoEventStatus"?: VideoEventWorkflowStatusIdEnum;
    "comments"?: Array<VideoEventCommentResponse>;
}

export interface VideoEventReportResponseIEnumerableResponseBase {
    "success"?: boolean;
    "error"?: Exception;
    "totalCount"?: number;
    "data"?: Array<VideoEventReportResponse>;
}

export interface VideoEventResponse {
    "id"?: number;
    "displayId"?: string;
    "geotabEventId"?: string;
    "videoEventInitiator"?: VideoEventInitiatorEnum;
    "videoEventType"?: Array<number>;
    "videoEventTypePairings"?: Array<VideoEventTypePairingResponse>;
    "driverName"?: string;
    "driverId"?: number;
    "driverTmcLearnerId"?: string;
    "driverIntegrationPartnerSourceId"?: string;
    "driverEmail"?: string;
    "driverPhoneNumber"?: string;
    "eventStartDate"?: Date;
    "eventEndDate"?: Date;
    "eventDurationSeconds"?: number;
    "location"?: string;
    "addressStreetNumber"?: string;
    "addressRegion"?: string;
    "addressStreetName"?: string;
    "addressPostalCode"?: string;
    "addressCityName"?: string;
    "kphStart"?: number;
    "kphEnd"?: number;
    "vehicleDescription"?: string;
    "integrationPartnerVehicleId"?: string;
    "companyLevelName"?: string;
    "licensePlateNumber"?: string;
    "licensePlateState"?: string;
    "latitude"?: number;
    "longitude"?: number;
    "workflowStep"?: VideoEventPipelineStepEnum;
    "workflowStepDescription"?: string;
    "requestedBy"?: string;
    "requestedOn"?: Date;
    "videoAsset"?: Array<VideoAssetResponse>;
    "telematicDeviceId"?: number;
    "telematicDeviceSourceId"?: string;
    "telematicDeviceName"?: string;
    "videoEventTypeString"?: string;
    "actionHistory"?: Array<VideoEventActionResponse>;
    "isFlagged"?: boolean;
    "flaggedByUsers"?: Array<UserResponse>;
    "score"?: number;
    "videoEventStatus"?: VideoEventWorkflowStatusIdEnum;
    "adminResolution"?: VideoEventAdminResolutionEnum;
    "cameraRequest"?: CameraRequestResponse;
    "speedGraphPoints"?: Array<SpeedGraphPointResponse>;
    "eventJson"?: string;
    "cameraDeviceSerialNumber"?: string;
    "aiVideoAvailable"?: boolean;
}

export interface VideoEventResponseIEnumerablePagedResponseBase {
    "success"?: boolean;
    "error"?: Exception;
    "totalCount"?: number;
    "data"?: Array<VideoEventResponse>;
    "currentPage"?: number;
    "itemsPerPage"?: number;
    "totalPages"?: number;
}

export interface VideoEventRetentionSettingsResponse {
    "retentionDays"?: number;
    "keepEventData"?: boolean;
    "availableRetentionValues"?: Array<number>;
}

export interface VideoEventScoreResponse {
    "id"?: number;
    "value"?: number;
    "displayName"?: string;
    "isActive"?: boolean;
}

export interface VideoEventTypePairingResponse {
    "videoEventTypeString"?: string;
    "videoEventTypeIconName"?: string;
    "startDate"?: Date;
    "endDate"?: Date;
    "videoEventTypeId"?: number;
}

export interface VideoEventTypeResponse {
    "id"?: number;
    "displayName"?: string;
    "primaryViewId"?: number;
    "iconFileName"?: string;
    "allowNotification"?: boolean;
}

export type VideoEventWorkflowStatusIdEnum = "New" | "In_Progress" | "Dismissed" | "Completed" | "Sent_To_Driver" | "No_Response" | "Driver_Accepted" | "Driver_Disputed" | "Deleted";

export interface VideoRecallResponse {
    "id"?: number;
    "displayId"?: string;
    "eventStartDate"?: Date;
    "eventEndDate"?: Date;
    "eventTime"?: string;
    "eventDurationSeconds"?: number;
    "integrationPartnerVehicleId"?: string;
    "vehicleLocationId"?: number;
    "requestedBy"?: string;
    "requestedOn"?: Date;
    "requestStatus"?: string;
    "requestStepDescriptionId"?: number;
    "videoEventPipelilneStepDescription"?: string;
}

export interface WebsiteVideoEventRetentionRequest {
    "retentionDays"?: number;
    "keepEventData"?: boolean;
}



/**
 * AdministrativeApi - fetch parameter creator
 */
export const AdministrativeApiFetchParamCreator = {
    /** 
     * Get available devices for pairing
     * @param xIntegrationUserCredential 
     * @param groupsFilter Grouping filter query for Geotab
     */
    apiV1AvailabledevicesGet(params: {  "xIntegrationUserCredential": string; "groupsFilter"?: string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1AvailabledevicesGet");
        }
        const baseUrl = `/api/v1/availabledevices`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "groupsFilter": params["groupsFilter"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1CameraDeviceLiveVideoEndPost(params: {  "xIntegrationUserCredential": string; "body"?: LiveVideoEndTimeUpdateRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1CameraDeviceLiveVideoEndPost");
        }
        const baseUrl = `/api/v1/cameraDevice/liveVideoEnd`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1CameraDeviceLiveVideoStartPost(params: {  "xIntegrationUserCredential": string; "body"?: LiveVideoStartTimeRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1CameraDeviceLiveVideoStartPost");
        }
        const baseUrl = `/api/v1/cameraDevice/liveVideoStart`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Returns a URL for live video from Streamax by camera&#39;s serial number
     * @param xIntegrationUserCredential 
     * @param vehicleCameraPairingId Vehicle camera pairing id
     */
    apiV1CameraDeviceLiveVideoUrlGet(params: {  "xIntegrationUserCredential": string; "vehicleCameraPairingId"?: number; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1CameraDeviceLiveVideoUrlGet");
        }
        const baseUrl = `/api/v1/cameraDevice/liveVideoUrl`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "vehicleCameraPairingId": params["vehicleCameraPairingId"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Updates camera device pairing
     * @param xIntegrationUserCredential 
     * @param body values for new vehicle camara pairing
     */
    apiV1CameraDevicePairingPut(params: {  "xIntegrationUserCredential": string; "body"?: EditVehicleCameraPairingRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1CameraDevicePairingPut");
        }
        const baseUrl = `/api/v1/cameraDevicePairing`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "PUT" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Get paired and unpared camera devices
     * @param xIntegrationUserCredential 
     */
    apiV1CameraDevicePairingsGet(params: {  "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1CameraDevicePairingsGet");
        }
        const baseUrl = `/api/v1/cameraDevicePairings`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param serialNumber 
     * @param xIntegrationUserCredential 
     */
    apiV1DeviceassociationsEarliestFootageSerialNumberGet(params: {  "serialNumber": string; "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "serialNumber" is set
        if (params["serialNumber"] == null) {
            throw new Error("Missing required parameter serialNumber when calling apiV1DeviceassociationsEarliestFootageSerialNumberGet");
        }
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1DeviceassociationsEarliestFootageSerialNumberGet");
        }
        const baseUrl = `/api/v1/deviceassociations/earliestFootage/{serialNumber}`
            .replace(`{${"serialNumber"}}`, `${ params["serialNumber"] }`);
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Updates a device association
     * @param xIntegrationUserCredential 
     * @param body new edit pairing info
     */
    apiV1DeviceassociationsEditPut(params: {  "xIntegrationUserCredential": string; "body"?: EditVehicleCameraPairingRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1DeviceassociationsEditPut");
        }
        const baseUrl = `/api/v1/deviceassociations/edit`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "PUT" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Update the end date for a List of Vehicle Camera pairings
     * @param xIntegrationUserCredential 
     * @param body PairingId
     */
    apiV1DeviceassociationsEndPairingsDelete(params: {  "xIntegrationUserCredential": string; "body"?: Array<number>; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1DeviceassociationsEndPairingsDelete");
        }
        const baseUrl = `/api/v1/deviceassociations/endPairings`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "DELETE" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param serialNumber 
     * @param xIntegrationUserCredential 
     */
    apiV1DeviceassociationsFootageDatesSerialNumberGet(params: {  "serialNumber": string; "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "serialNumber" is set
        if (params["serialNumber"] == null) {
            throw new Error("Missing required parameter serialNumber when calling apiV1DeviceassociationsFootageDatesSerialNumberGet");
        }
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1DeviceassociationsFootageDatesSerialNumberGet");
        }
        const baseUrl = `/api/v1/deviceassociations/footageDates/{serialNumber}`
            .replace(`{${"serialNumber"}}`, `${ params["serialNumber"] }`);
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Gets the current status of a preview by Id, including the percentage and the link to the file if it&#39;s ready or a human-readable error message if it&#39;s not
     * @param cameraDeviceRecallPreviewId 
     * @param xIntegrationUserCredential 
     */
    apiV1DeviceassociationsFootageSegmentsProgressCameraDeviceRecallPreviewIdGet(params: {  "cameraDeviceRecallPreviewId": number; "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "cameraDeviceRecallPreviewId" is set
        if (params["cameraDeviceRecallPreviewId"] == null) {
            throw new Error("Missing required parameter cameraDeviceRecallPreviewId when calling apiV1DeviceassociationsFootageSegmentsProgressCameraDeviceRecallPreviewIdGet");
        }
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1DeviceassociationsFootageSegmentsProgressCameraDeviceRecallPreviewIdGet");
        }
        const baseUrl = `/api/v1/deviceassociations/footageSegments/progress/{CameraDeviceRecallPreviewId}`
            .replace(`{${"CameraDeviceRecallPreviewId"}}`, `${ params["cameraDeviceRecallPreviewId"] }`);
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param serialNumber 
     * @param xIntegrationUserCredential 
     * @param lookupDate 
     */
    apiV1DeviceassociationsFootageSegmentsSerialNumberGet(params: {  "serialNumber": string; "xIntegrationUserCredential": string; "lookupDate"?: Date; }, options?: any): FetchArgs {
        // verify required parameter "serialNumber" is set
        if (params["serialNumber"] == null) {
            throw new Error("Missing required parameter serialNumber when calling apiV1DeviceassociationsFootageSegmentsSerialNumberGet");
        }
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1DeviceassociationsFootageSegmentsSerialNumberGet");
        }
        const baseUrl = `/api/v1/deviceassociations/footageSegments/{serialNumber}`
            .replace(`{${"serialNumber"}}`, `${ params["serialNumber"] }`);
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "lookupDate": params["lookupDate"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Get All Go Device Camera Pairings
     * @param xIntegrationUserCredential 
     * @param groupsFilter 
     */
    apiV1DeviceassociationsGet(params: {  "xIntegrationUserCredential": string; "groupsFilter"?: string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1DeviceassociationsGet");
        }
        const baseUrl = `/api/v1/deviceassociations`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "groupsFilter": params["groupsFilter"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Update the end date for a Vehicle Camera pairing
     * @param pairingId PairingId
     * @param xIntegrationUserCredential 
     */
    apiV1DeviceassociationsPairingIdDelete(params: {  "pairingId": number; "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "pairingId" is set
        if (params["pairingId"] == null) {
            throw new Error("Missing required parameter pairingId when calling apiV1DeviceassociationsPairingIdDelete");
        }
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1DeviceassociationsPairingIdDelete");
        }
        const baseUrl = `/api/v1/deviceassociations/{pairingId}`
            .replace(`{${"pairingId"}}`, `${ params["pairingId"] }`);
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "DELETE" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Create a new vehicle camera pairing
     * @param xIntegrationUserCredential 
     * @param body details for the new pairing to create
     */
    apiV1DeviceassociationsPost(params: {  "xIntegrationUserCredential": string; "body"?: VehicleCameraPairingRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1DeviceassociationsPost");
        }
        const baseUrl = `/api/v1/deviceassociations`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Creates a VideoRecallPreview for a specified camera and time range, returns the id of the created preview
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1DeviceassociationsVideorecallpreviewPost(params: {  "xIntegrationUserCredential": string; "body"?: CreateVideoRecallPreviewRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1DeviceassociationsVideorecallpreviewPost");
        }
        const baseUrl = `/api/v1/deviceassociations/videorecallpreview`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Maps any updated names for telematic or camera devices to device association table for display
     * @param xIntegrationUserCredential 
     * @param body List of vehicles and IDs in integrationPlatform to name match
     */
    apiV1DeviceassociationsmapPut(params: {  "xIntegrationUserCredential": string; "body"?: Array<VehicleRequest>; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1DeviceassociationsmapPut");
        }
        const baseUrl = `/api/v1/deviceassociationsmap`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "PUT" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Check device pairings for an active pairing with the specified camera
     * @param cameraId A camera Id to check if an association currently exists
     * @param xIntegrationUserCredential 
     */
    apiV1ExistingCameraAssociationCameraIdGet(params: {  "cameraId": number; "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "cameraId" is set
        if (params["cameraId"] == null) {
            throw new Error("Missing required parameter cameraId when calling apiV1ExistingCameraAssociationCameraIdGet");
        }
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1ExistingCameraAssociationCameraIdGet");
        }
        const baseUrl = `/api/v1/existingCameraAssociation/{cameraId}`
            .replace(`{${"cameraId"}}`, `${ params["cameraId"] }`);
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Checks if exist an association for integrationPartnerVehicleId
     * @param integrationPartnerVehicleId A integrationPartnerVehicleId to check if an association currently exists
     * @param xIntegrationUserCredential 
     */
    apiV1ExistingDeviceAssociationIntegrationPartnerVehicleIdGet(params: {  "integrationPartnerVehicleId": string; "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "integrationPartnerVehicleId" is set
        if (params["integrationPartnerVehicleId"] == null) {
            throw new Error("Missing required parameter integrationPartnerVehicleId when calling apiV1ExistingDeviceAssociationIntegrationPartnerVehicleIdGet");
        }
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1ExistingDeviceAssociationIntegrationPartnerVehicleIdGet");
        }
        const baseUrl = `/api/v1/existingDeviceAssociation/{integrationPartnerVehicleId}`
            .replace(`{${"integrationPartnerVehicleId"}}`, `${ params["integrationPartnerVehicleId"] }`);
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Get All cameras
     * @param xIntegrationUserCredential 
     */
    apiV1UnpairedCamerasGet(params: {  "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1UnpairedCamerasGet");
        }
        const baseUrl = `/api/v1/unpairedCameras`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Returns a list of vehicles not paired to a camera
     * @param xIntegrationUserCredential 
     */
    apiV1UnpairedVehiclesGet(params: {  "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1UnpairedVehiclesGet");
        }
        const baseUrl = `/api/v1/unpairedVehicles`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};

/**
 * AdministrativeApi - functional programming interface
 */
export const AdministrativeApiFp = {
    /** 
     * Get available devices for pairing
     * @param xIntegrationUserCredential 
     * @param groupsFilter Grouping filter query for Geotab
     */
    apiV1AvailabledevicesGet(params: { "xIntegrationUserCredential": string; "groupsFilter"?: string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<VehicleCameraPairingResponse>> {
        const fetchArgs = AdministrativeApiFetchParamCreator.apiV1AvailabledevicesGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1CameraDeviceLiveVideoEndPost(params: { "xIntegrationUserCredential": string; "body"?: LiveVideoEndTimeUpdateRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = AdministrativeApiFetchParamCreator.apiV1CameraDeviceLiveVideoEndPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1CameraDeviceLiveVideoStartPost(params: { "xIntegrationUserCredential": string; "body"?: LiveVideoStartTimeRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<LiveVideoStartResponse> {
        const fetchArgs = AdministrativeApiFetchParamCreator.apiV1CameraDeviceLiveVideoStartPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Returns a URL for live video from Streamax by camera&#39;s serial number
     * @param xIntegrationUserCredential 
     * @param vehicleCameraPairingId Vehicle camera pairing id
     */
    apiV1CameraDeviceLiveVideoUrlGet(params: { "xIntegrationUserCredential": string; "vehicleCameraPairingId"?: number;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<LiveVideoUrlResponse> {
        const fetchArgs = AdministrativeApiFetchParamCreator.apiV1CameraDeviceLiveVideoUrlGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Updates camera device pairing
     * @param xIntegrationUserCredential 
     * @param body values for new vehicle camara pairing
     */
    apiV1CameraDevicePairingPut(params: { "xIntegrationUserCredential": string; "body"?: EditVehicleCameraPairingRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MessageResponse> {
        const fetchArgs = AdministrativeApiFetchParamCreator.apiV1CameraDevicePairingPut(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Get paired and unpared camera devices
     * @param xIntegrationUserCredential 
     */
    apiV1CameraDevicePairingsGet(params: { "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<CameraDevicePairingResponse>> {
        const fetchArgs = AdministrativeApiFetchParamCreator.apiV1CameraDevicePairingsGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param serialNumber 
     * @param xIntegrationUserCredential 
     */
    apiV1DeviceassociationsEarliestFootageSerialNumberGet(params: { "serialNumber": string; "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CameraDeviceEarliestFootageResponse> {
        const fetchArgs = AdministrativeApiFetchParamCreator.apiV1DeviceassociationsEarliestFootageSerialNumberGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Updates a device association
     * @param xIntegrationUserCredential 
     * @param body new edit pairing info
     */
    apiV1DeviceassociationsEditPut(params: { "xIntegrationUserCredential": string; "body"?: EditVehicleCameraPairingRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<VehicleCameraPairingResponse>> {
        const fetchArgs = AdministrativeApiFetchParamCreator.apiV1DeviceassociationsEditPut(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Update the end date for a List of Vehicle Camera pairings
     * @param xIntegrationUserCredential 
     * @param body PairingId
     */
    apiV1DeviceassociationsEndPairingsDelete(params: { "xIntegrationUserCredential": string; "body"?: Array<number>;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<VehicleCameraPairingResponse>> {
        const fetchArgs = AdministrativeApiFetchParamCreator.apiV1DeviceassociationsEndPairingsDelete(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param serialNumber 
     * @param xIntegrationUserCredential 
     */
    apiV1DeviceassociationsFootageDatesSerialNumberGet(params: { "serialNumber": string; "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<Date>> {
        const fetchArgs = AdministrativeApiFetchParamCreator.apiV1DeviceassociationsFootageDatesSerialNumberGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Gets the current status of a preview by Id, including the percentage and the link to the file if it&#39;s ready or a human-readable error message if it&#39;s not
     * @param cameraDeviceRecallPreviewId 
     * @param xIntegrationUserCredential 
     */
    apiV1DeviceassociationsFootageSegmentsProgressCameraDeviceRecallPreviewIdGet(params: { "cameraDeviceRecallPreviewId": number; "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CameraDeviceSegmentProgressResult> {
        const fetchArgs = AdministrativeApiFetchParamCreator.apiV1DeviceassociationsFootageSegmentsProgressCameraDeviceRecallPreviewIdGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param serialNumber 
     * @param xIntegrationUserCredential 
     * @param lookupDate 
     */
    apiV1DeviceassociationsFootageSegmentsSerialNumberGet(params: { "serialNumber": string; "xIntegrationUserCredential": string; "lookupDate"?: Date;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CameraDeviceSegmentsResponse> {
        const fetchArgs = AdministrativeApiFetchParamCreator.apiV1DeviceassociationsFootageSegmentsSerialNumberGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Get All Go Device Camera Pairings
     * @param xIntegrationUserCredential 
     * @param groupsFilter 
     */
    apiV1DeviceassociationsGet(params: { "xIntegrationUserCredential": string; "groupsFilter"?: string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<VehicleCameraPairingResponse>> {
        const fetchArgs = AdministrativeApiFetchParamCreator.apiV1DeviceassociationsGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Update the end date for a Vehicle Camera pairing
     * @param pairingId PairingId
     * @param xIntegrationUserCredential 
     */
    apiV1DeviceassociationsPairingIdDelete(params: { "pairingId": number; "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<VehicleCameraPairingResponse>> {
        const fetchArgs = AdministrativeApiFetchParamCreator.apiV1DeviceassociationsPairingIdDelete(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Create a new vehicle camera pairing
     * @param xIntegrationUserCredential 
     * @param body details for the new pairing to create
     */
    apiV1DeviceassociationsPost(params: { "xIntegrationUserCredential": string; "body"?: VehicleCameraPairingRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<VehicleCameraPairingResponse>> {
        const fetchArgs = AdministrativeApiFetchParamCreator.apiV1DeviceassociationsPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Creates a VideoRecallPreview for a specified camera and time range, returns the id of the created preview
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1DeviceassociationsVideorecallpreviewPost(params: { "xIntegrationUserCredential": string; "body"?: CreateVideoRecallPreviewRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<number> {
        const fetchArgs = AdministrativeApiFetchParamCreator.apiV1DeviceassociationsVideorecallpreviewPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Maps any updated names for telematic or camera devices to device association table for display
     * @param xIntegrationUserCredential 
     * @param body List of vehicles and IDs in integrationPlatform to name match
     */
    apiV1DeviceassociationsmapPut(params: { "xIntegrationUserCredential": string; "body"?: Array<VehicleRequest>;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = AdministrativeApiFetchParamCreator.apiV1DeviceassociationsmapPut(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Check device pairings for an active pairing with the specified camera
     * @param cameraId A camera Id to check if an association currently exists
     * @param xIntegrationUserCredential 
     */
    apiV1ExistingCameraAssociationCameraIdGet(params: { "cameraId": number; "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<VehicleCameraPairingResponse> {
        const fetchArgs = AdministrativeApiFetchParamCreator.apiV1ExistingCameraAssociationCameraIdGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Checks if exist an association for integrationPartnerVehicleId
     * @param integrationPartnerVehicleId A integrationPartnerVehicleId to check if an association currently exists
     * @param xIntegrationUserCredential 
     */
    apiV1ExistingDeviceAssociationIntegrationPartnerVehicleIdGet(params: { "integrationPartnerVehicleId": string; "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<VehicleCameraPairingResponse> {
        const fetchArgs = AdministrativeApiFetchParamCreator.apiV1ExistingDeviceAssociationIntegrationPartnerVehicleIdGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Get All cameras
     * @param xIntegrationUserCredential 
     */
    apiV1UnpairedCamerasGet(params: { "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<CameraDeviceResponse>> {
        const fetchArgs = AdministrativeApiFetchParamCreator.apiV1UnpairedCamerasGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Returns a list of vehicles not paired to a camera
     * @param xIntegrationUserCredential 
     */
    apiV1UnpairedVehiclesGet(params: { "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<VehicleResponseIEnumerableResponseBase> {
        const fetchArgs = AdministrativeApiFetchParamCreator.apiV1UnpairedVehiclesGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
};

/**
 * AdministrativeApi - object-oriented interface
 */
export class AdministrativeApi extends BaseAPI {
    /** 
     * Get available devices for pairing
     * @param xIntegrationUserCredential 
     * @param groupsFilter Grouping filter query for Geotab
     */
    apiV1AvailabledevicesGet(params: {  "xIntegrationUserCredential": string; "groupsFilter"?: string; }, options?: any) {
        return AdministrativeApiFp.apiV1AvailabledevicesGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1CameraDeviceLiveVideoEndPost(params: {  "xIntegrationUserCredential": string; "body"?: LiveVideoEndTimeUpdateRequest; }, options?: any) {
        return AdministrativeApiFp.apiV1CameraDeviceLiveVideoEndPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1CameraDeviceLiveVideoStartPost(params: {  "xIntegrationUserCredential": string; "body"?: LiveVideoStartTimeRequest; }, options?: any) {
        return AdministrativeApiFp.apiV1CameraDeviceLiveVideoStartPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Returns a URL for live video from Streamax by camera&#39;s serial number
     * @param xIntegrationUserCredential 
     * @param vehicleCameraPairingId Vehicle camera pairing id
     */
    apiV1CameraDeviceLiveVideoUrlGet(params: {  "xIntegrationUserCredential": string; "vehicleCameraPairingId"?: number; }, options?: any) {
        return AdministrativeApiFp.apiV1CameraDeviceLiveVideoUrlGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Updates camera device pairing
     * @param xIntegrationUserCredential 
     * @param body values for new vehicle camara pairing
     */
    apiV1CameraDevicePairingPut(params: {  "xIntegrationUserCredential": string; "body"?: EditVehicleCameraPairingRequest; }, options?: any) {
        return AdministrativeApiFp.apiV1CameraDevicePairingPut(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Get paired and unpared camera devices
     * @param xIntegrationUserCredential 
     */
    apiV1CameraDevicePairingsGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
        return AdministrativeApiFp.apiV1CameraDevicePairingsGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param serialNumber 
     * @param xIntegrationUserCredential 
     */
    apiV1DeviceassociationsEarliestFootageSerialNumberGet(params: {  "serialNumber": string; "xIntegrationUserCredential": string; }, options?: any) {
        return AdministrativeApiFp.apiV1DeviceassociationsEarliestFootageSerialNumberGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Updates a device association
     * @param xIntegrationUserCredential 
     * @param body new edit pairing info
     */
    apiV1DeviceassociationsEditPut(params: {  "xIntegrationUserCredential": string; "body"?: EditVehicleCameraPairingRequest; }, options?: any) {
        return AdministrativeApiFp.apiV1DeviceassociationsEditPut(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Update the end date for a List of Vehicle Camera pairings
     * @param xIntegrationUserCredential 
     * @param body PairingId
     */
    apiV1DeviceassociationsEndPairingsDelete(params: {  "xIntegrationUserCredential": string; "body"?: Array<number>; }, options?: any) {
        return AdministrativeApiFp.apiV1DeviceassociationsEndPairingsDelete(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param serialNumber 
     * @param xIntegrationUserCredential 
     */
    apiV1DeviceassociationsFootageDatesSerialNumberGet(params: {  "serialNumber": string; "xIntegrationUserCredential": string; }, options?: any) {
        return AdministrativeApiFp.apiV1DeviceassociationsFootageDatesSerialNumberGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Gets the current status of a preview by Id, including the percentage and the link to the file if it&#39;s ready or a human-readable error message if it&#39;s not
     * @param cameraDeviceRecallPreviewId 
     * @param xIntegrationUserCredential 
     */
    apiV1DeviceassociationsFootageSegmentsProgressCameraDeviceRecallPreviewIdGet(params: {  "cameraDeviceRecallPreviewId": number; "xIntegrationUserCredential": string; }, options?: any) {
        return AdministrativeApiFp.apiV1DeviceassociationsFootageSegmentsProgressCameraDeviceRecallPreviewIdGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param serialNumber 
     * @param xIntegrationUserCredential 
     * @param lookupDate 
     */
    apiV1DeviceassociationsFootageSegmentsSerialNumberGet(params: {  "serialNumber": string; "xIntegrationUserCredential": string; "lookupDate"?: Date; }, options?: any) {
        return AdministrativeApiFp.apiV1DeviceassociationsFootageSegmentsSerialNumberGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Get All Go Device Camera Pairings
     * @param xIntegrationUserCredential 
     * @param groupsFilter 
     */
    apiV1DeviceassociationsGet(params: {  "xIntegrationUserCredential": string; "groupsFilter"?: string; }, options?: any) {
        return AdministrativeApiFp.apiV1DeviceassociationsGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Update the end date for a Vehicle Camera pairing
     * @param pairingId PairingId
     * @param xIntegrationUserCredential 
     */
    apiV1DeviceassociationsPairingIdDelete(params: {  "pairingId": number; "xIntegrationUserCredential": string; }, options?: any) {
        return AdministrativeApiFp.apiV1DeviceassociationsPairingIdDelete(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Create a new vehicle camera pairing
     * @param xIntegrationUserCredential 
     * @param body details for the new pairing to create
     */
    apiV1DeviceassociationsPost(params: {  "xIntegrationUserCredential": string; "body"?: VehicleCameraPairingRequest; }, options?: any) {
        return AdministrativeApiFp.apiV1DeviceassociationsPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Creates a VideoRecallPreview for a specified camera and time range, returns the id of the created preview
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1DeviceassociationsVideorecallpreviewPost(params: {  "xIntegrationUserCredential": string; "body"?: CreateVideoRecallPreviewRequest; }, options?: any) {
        return AdministrativeApiFp.apiV1DeviceassociationsVideorecallpreviewPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Maps any updated names for telematic or camera devices to device association table for display
     * @param xIntegrationUserCredential 
     * @param body List of vehicles and IDs in integrationPlatform to name match
     */
    apiV1DeviceassociationsmapPut(params: {  "xIntegrationUserCredential": string; "body"?: Array<VehicleRequest>; }, options?: any) {
        return AdministrativeApiFp.apiV1DeviceassociationsmapPut(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Check device pairings for an active pairing with the specified camera
     * @param cameraId A camera Id to check if an association currently exists
     * @param xIntegrationUserCredential 
     */
    apiV1ExistingCameraAssociationCameraIdGet(params: {  "cameraId": number; "xIntegrationUserCredential": string; }, options?: any) {
        return AdministrativeApiFp.apiV1ExistingCameraAssociationCameraIdGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Checks if exist an association for integrationPartnerVehicleId
     * @param integrationPartnerVehicleId A integrationPartnerVehicleId to check if an association currently exists
     * @param xIntegrationUserCredential 
     */
    apiV1ExistingDeviceAssociationIntegrationPartnerVehicleIdGet(params: {  "integrationPartnerVehicleId": string; "xIntegrationUserCredential": string; }, options?: any) {
        return AdministrativeApiFp.apiV1ExistingDeviceAssociationIntegrationPartnerVehicleIdGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Get All cameras
     * @param xIntegrationUserCredential 
     */
    apiV1UnpairedCamerasGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
        return AdministrativeApiFp.apiV1UnpairedCamerasGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Returns a list of vehicles not paired to a camera
     * @param xIntegrationUserCredential 
     */
    apiV1UnpairedVehiclesGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
        return AdministrativeApiFp.apiV1UnpairedVehiclesGet(params, options)(this.fetch, this.basePath);
    }
};

/**
 * AdministrativeApi - factory interface
 */
export const AdministrativeApiFactory = function (fetch?: FetchAPI, basePath?: string) {
    return {
        /** 
         * Get available devices for pairing
         * @param xIntegrationUserCredential 
         * @param groupsFilter Grouping filter query for Geotab
         */
        apiV1AvailabledevicesGet(params: {  "xIntegrationUserCredential": string; "groupsFilter"?: string; }, options?: any) {
            return AdministrativeApiFp.apiV1AvailabledevicesGet(params, options)(fetch, basePath);
        },
        /** 
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1CameraDeviceLiveVideoEndPost(params: {  "xIntegrationUserCredential": string; "body"?: LiveVideoEndTimeUpdateRequest; }, options?: any) {
            return AdministrativeApiFp.apiV1CameraDeviceLiveVideoEndPost(params, options)(fetch, basePath);
        },
        /** 
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1CameraDeviceLiveVideoStartPost(params: {  "xIntegrationUserCredential": string; "body"?: LiveVideoStartTimeRequest; }, options?: any) {
            return AdministrativeApiFp.apiV1CameraDeviceLiveVideoStartPost(params, options)(fetch, basePath);
        },
        /** 
         * Returns a URL for live video from Streamax by camera&#39;s serial number
         * @param xIntegrationUserCredential 
         * @param vehicleCameraPairingId Vehicle camera pairing id
         */
        apiV1CameraDeviceLiveVideoUrlGet(params: {  "xIntegrationUserCredential": string; "vehicleCameraPairingId"?: number; }, options?: any) {
            return AdministrativeApiFp.apiV1CameraDeviceLiveVideoUrlGet(params, options)(fetch, basePath);
        },
        /** 
         * Updates camera device pairing
         * @param xIntegrationUserCredential 
         * @param body values for new vehicle camara pairing
         */
        apiV1CameraDevicePairingPut(params: {  "xIntegrationUserCredential": string; "body"?: EditVehicleCameraPairingRequest; }, options?: any) {
            return AdministrativeApiFp.apiV1CameraDevicePairingPut(params, options)(fetch, basePath);
        },
        /** 
         * Get paired and unpared camera devices
         * @param xIntegrationUserCredential 
         */
        apiV1CameraDevicePairingsGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
            return AdministrativeApiFp.apiV1CameraDevicePairingsGet(params, options)(fetch, basePath);
        },
        /** 
         * @param serialNumber 
         * @param xIntegrationUserCredential 
         */
        apiV1DeviceassociationsEarliestFootageSerialNumberGet(params: {  "serialNumber": string; "xIntegrationUserCredential": string; }, options?: any) {
            return AdministrativeApiFp.apiV1DeviceassociationsEarliestFootageSerialNumberGet(params, options)(fetch, basePath);
        },
        /** 
         * Updates a device association
         * @param xIntegrationUserCredential 
         * @param body new edit pairing info
         */
        apiV1DeviceassociationsEditPut(params: {  "xIntegrationUserCredential": string; "body"?: EditVehicleCameraPairingRequest; }, options?: any) {
            return AdministrativeApiFp.apiV1DeviceassociationsEditPut(params, options)(fetch, basePath);
        },
        /** 
         * Update the end date for a List of Vehicle Camera pairings
         * @param xIntegrationUserCredential 
         * @param body PairingId
         */
        apiV1DeviceassociationsEndPairingsDelete(params: {  "xIntegrationUserCredential": string; "body"?: Array<number>; }, options?: any) {
            return AdministrativeApiFp.apiV1DeviceassociationsEndPairingsDelete(params, options)(fetch, basePath);
        },
        /** 
         * @param serialNumber 
         * @param xIntegrationUserCredential 
         */
        apiV1DeviceassociationsFootageDatesSerialNumberGet(params: {  "serialNumber": string; "xIntegrationUserCredential": string; }, options?: any) {
            return AdministrativeApiFp.apiV1DeviceassociationsFootageDatesSerialNumberGet(params, options)(fetch, basePath);
        },
        /** 
         * Gets the current status of a preview by Id, including the percentage and the link to the file if it&#39;s ready or a human-readable error message if it&#39;s not
         * @param cameraDeviceRecallPreviewId 
         * @param xIntegrationUserCredential 
         */
        apiV1DeviceassociationsFootageSegmentsProgressCameraDeviceRecallPreviewIdGet(params: {  "cameraDeviceRecallPreviewId": number; "xIntegrationUserCredential": string; }, options?: any) {
            return AdministrativeApiFp.apiV1DeviceassociationsFootageSegmentsProgressCameraDeviceRecallPreviewIdGet(params, options)(fetch, basePath);
        },
        /** 
         * @param serialNumber 
         * @param xIntegrationUserCredential 
         * @param lookupDate 
         */
        apiV1DeviceassociationsFootageSegmentsSerialNumberGet(params: {  "serialNumber": string; "xIntegrationUserCredential": string; "lookupDate"?: Date; }, options?: any) {
            return AdministrativeApiFp.apiV1DeviceassociationsFootageSegmentsSerialNumberGet(params, options)(fetch, basePath);
        },
        /** 
         * Get All Go Device Camera Pairings
         * @param xIntegrationUserCredential 
         * @param groupsFilter 
         */
        apiV1DeviceassociationsGet(params: {  "xIntegrationUserCredential": string; "groupsFilter"?: string; }, options?: any) {
            return AdministrativeApiFp.apiV1DeviceassociationsGet(params, options)(fetch, basePath);
        },
        /** 
         * Update the end date for a Vehicle Camera pairing
         * @param pairingId PairingId
         * @param xIntegrationUserCredential 
         */
        apiV1DeviceassociationsPairingIdDelete(params: {  "pairingId": number; "xIntegrationUserCredential": string; }, options?: any) {
            return AdministrativeApiFp.apiV1DeviceassociationsPairingIdDelete(params, options)(fetch, basePath);
        },
        /** 
         * Create a new vehicle camera pairing
         * @param xIntegrationUserCredential 
         * @param body details for the new pairing to create
         */
        apiV1DeviceassociationsPost(params: {  "xIntegrationUserCredential": string; "body"?: VehicleCameraPairingRequest; }, options?: any) {
            return AdministrativeApiFp.apiV1DeviceassociationsPost(params, options)(fetch, basePath);
        },
        /** 
         * Creates a VideoRecallPreview for a specified camera and time range, returns the id of the created preview
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1DeviceassociationsVideorecallpreviewPost(params: {  "xIntegrationUserCredential": string; "body"?: CreateVideoRecallPreviewRequest; }, options?: any) {
            return AdministrativeApiFp.apiV1DeviceassociationsVideorecallpreviewPost(params, options)(fetch, basePath);
        },
        /** 
         * Maps any updated names for telematic or camera devices to device association table for display
         * @param xIntegrationUserCredential 
         * @param body List of vehicles and IDs in integrationPlatform to name match
         */
        apiV1DeviceassociationsmapPut(params: {  "xIntegrationUserCredential": string; "body"?: Array<VehicleRequest>; }, options?: any) {
            return AdministrativeApiFp.apiV1DeviceassociationsmapPut(params, options)(fetch, basePath);
        },
        /** 
         * Check device pairings for an active pairing with the specified camera
         * @param cameraId A camera Id to check if an association currently exists
         * @param xIntegrationUserCredential 
         */
        apiV1ExistingCameraAssociationCameraIdGet(params: {  "cameraId": number; "xIntegrationUserCredential": string; }, options?: any) {
            return AdministrativeApiFp.apiV1ExistingCameraAssociationCameraIdGet(params, options)(fetch, basePath);
        },
        /** 
         * Checks if exist an association for integrationPartnerVehicleId
         * @param integrationPartnerVehicleId A integrationPartnerVehicleId to check if an association currently exists
         * @param xIntegrationUserCredential 
         */
        apiV1ExistingDeviceAssociationIntegrationPartnerVehicleIdGet(params: {  "integrationPartnerVehicleId": string; "xIntegrationUserCredential": string; }, options?: any) {
            return AdministrativeApiFp.apiV1ExistingDeviceAssociationIntegrationPartnerVehicleIdGet(params, options)(fetch, basePath);
        },
        /** 
         * Get All cameras
         * @param xIntegrationUserCredential 
         */
        apiV1UnpairedCamerasGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
            return AdministrativeApiFp.apiV1UnpairedCamerasGet(params, options)(fetch, basePath);
        },
        /** 
         * Returns a list of vehicles not paired to a camera
         * @param xIntegrationUserCredential 
         */
        apiV1UnpairedVehiclesGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
            return AdministrativeApiFp.apiV1UnpairedVehiclesGet(params, options)(fetch, basePath);
        },
    };
};


/**
 * AgreementsApi - fetch parameter creator
 */
export const AgreementsApiFetchParamCreator = {
    /** 
     * @param xIntegrationUserCredential 
     */
    apiV1AgreementsHasSignedAgreementsGet(params: {  "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1AgreementsHasSignedAgreementsGet");
        }
        const baseUrl = `/api/v1/agreements/hasSignedAgreements`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1AgreementsSignAgreementsPost(params: {  "xIntegrationUserCredential": string; "body"?: SignedAgreementHistoryRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1AgreementsSignAgreementsPost");
        }
        const baseUrl = `/api/v1/agreements/signAgreements`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};

/**
 * AgreementsApi - functional programming interface
 */
export const AgreementsApiFp = {
    /** 
     * @param xIntegrationUserCredential 
     */
    apiV1AgreementsHasSignedAgreementsGet(params: { "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SignedAgreementHistoryResponse> {
        const fetchArgs = AgreementsApiFetchParamCreator.apiV1AgreementsHasSignedAgreementsGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1AgreementsSignAgreementsPost(params: { "xIntegrationUserCredential": string; "body"?: SignedAgreementHistoryRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = AgreementsApiFetchParamCreator.apiV1AgreementsSignAgreementsPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
};

/**
 * AgreementsApi - object-oriented interface
 */
export class AgreementsApi extends BaseAPI {
    /** 
     * @param xIntegrationUserCredential 
     */
    apiV1AgreementsHasSignedAgreementsGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
        return AgreementsApiFp.apiV1AgreementsHasSignedAgreementsGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1AgreementsSignAgreementsPost(params: {  "xIntegrationUserCredential": string; "body"?: SignedAgreementHistoryRequest; }, options?: any) {
        return AgreementsApiFp.apiV1AgreementsSignAgreementsPost(params, options)(this.fetch, this.basePath);
    }
};

/**
 * AgreementsApi - factory interface
 */
export const AgreementsApiFactory = function (fetch?: FetchAPI, basePath?: string) {
    return {
        /** 
         * @param xIntegrationUserCredential 
         */
        apiV1AgreementsHasSignedAgreementsGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
            return AgreementsApiFp.apiV1AgreementsHasSignedAgreementsGet(params, options)(fetch, basePath);
        },
        /** 
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1AgreementsSignAgreementsPost(params: {  "xIntegrationUserCredential": string; "body"?: SignedAgreementHistoryRequest; }, options?: any) {
            return AgreementsApiFp.apiV1AgreementsSignAgreementsPost(params, options)(fetch, basePath);
        },
    };
};


/**
 * ConfigApi - fetch parameter creator
 */
export const ConfigApiFetchParamCreator = {
    /** 
     * @param xIntegrationUserCredential 
     */
    apiV1ConfigGetClientConfigGet(params: {  "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1ConfigGetClientConfigGet");
        }
        const baseUrl = `/api/v1/config/getClientConfig`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     */
    apiV1ConfigGetFleetIdGet(params: {  "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1ConfigGetFleetIdGet");
        }
        const baseUrl = `/api/v1/config/getFleetId`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};

/**
 * ConfigApi - functional programming interface
 */
export const ConfigApiFp = {
    /** 
     * @param xIntegrationUserCredential 
     */
    apiV1ConfigGetClientConfigGet(params: { "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ClientConfigResponse> {
        const fetchArgs = ConfigApiFetchParamCreator.apiV1ConfigGetClientConfigGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     */
    apiV1ConfigGetFleetIdGet(params: { "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
        const fetchArgs = ConfigApiFetchParamCreator.apiV1ConfigGetFleetIdGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
};

/**
 * ConfigApi - object-oriented interface
 */
export class ConfigApi extends BaseAPI {
    /** 
     * @param xIntegrationUserCredential 
     */
    apiV1ConfigGetClientConfigGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
        return ConfigApiFp.apiV1ConfigGetClientConfigGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param xIntegrationUserCredential 
     */
    apiV1ConfigGetFleetIdGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
        return ConfigApiFp.apiV1ConfigGetFleetIdGet(params, options)(this.fetch, this.basePath);
    }
};

/**
 * ConfigApi - factory interface
 */
export const ConfigApiFactory = function (fetch?: FetchAPI, basePath?: string) {
    return {
        /** 
         * @param xIntegrationUserCredential 
         */
        apiV1ConfigGetClientConfigGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
            return ConfigApiFp.apiV1ConfigGetClientConfigGet(params, options)(fetch, basePath);
        },
        /** 
         * @param xIntegrationUserCredential 
         */
        apiV1ConfigGetFleetIdGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
            return ConfigApiFp.apiV1ConfigGetFleetIdGet(params, options)(fetch, basePath);
        },
    };
};


/**
 * CriticalSpeedApi - fetch parameter creator
 */
export const CriticalSpeedApiFetchParamCreator = {
    /** 
     * @param xIntegrationUserCredential 
     */
    apiV1CriticalSpeedGet(params: {  "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1CriticalSpeedGet");
        }
        const baseUrl = `/api/v1/criticalSpeed`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param speedThreshold 
     */
    apiV1CriticalSpeedPut(params: {  "xIntegrationUserCredential": string; "speedThreshold"?: number; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1CriticalSpeedPut");
        }
        const baseUrl = `/api/v1/criticalSpeed`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "speedThreshold": params["speedThreshold"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "PUT" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Get the critical speed settings for a fleet based on speed type input
     * @param xIntegrationUserCredential 
     * @param speedTypeEnum 
     */
    apiV1CriticalSpeedWithUnitsGet(params: {  "xIntegrationUserCredential": string; "speedTypeEnum"?: string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1CriticalSpeedWithUnitsGet");
        }
        const baseUrl = `/api/v1/criticalSpeed/withUnits`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "speedTypeEnum": params["speedTypeEnum"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Update the critical speed settings for a fleet based on speed type input
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1CriticalSpeedWithUnitsPut(params: {  "xIntegrationUserCredential": string; "body"?: UpdateCriticalSpeedRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1CriticalSpeedWithUnitsPut");
        }
        const baseUrl = `/api/v1/criticalSpeed/withUnits`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "PUT" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};

/**
 * CriticalSpeedApi - functional programming interface
 */
export const CriticalSpeedApiFp = {
    /** 
     * @param xIntegrationUserCredential 
     */
    apiV1CriticalSpeedGet(params: { "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CriticalSpeedResponse> {
        const fetchArgs = CriticalSpeedApiFetchParamCreator.apiV1CriticalSpeedGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param speedThreshold 
     */
    apiV1CriticalSpeedPut(params: { "xIntegrationUserCredential": string; "speedThreshold"?: number;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = CriticalSpeedApiFetchParamCreator.apiV1CriticalSpeedPut(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Get the critical speed settings for a fleet based on speed type input
     * @param xIntegrationUserCredential 
     * @param speedTypeEnum 
     */
    apiV1CriticalSpeedWithUnitsGet(params: { "xIntegrationUserCredential": string; "speedTypeEnum"?: string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CriticalSpeedResponseWithUnits> {
        const fetchArgs = CriticalSpeedApiFetchParamCreator.apiV1CriticalSpeedWithUnitsGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Update the critical speed settings for a fleet based on speed type input
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1CriticalSpeedWithUnitsPut(params: { "xIntegrationUserCredential": string; "body"?: UpdateCriticalSpeedRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = CriticalSpeedApiFetchParamCreator.apiV1CriticalSpeedWithUnitsPut(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
};

/**
 * CriticalSpeedApi - object-oriented interface
 */
export class CriticalSpeedApi extends BaseAPI {
    /** 
     * @param xIntegrationUserCredential 
     */
    apiV1CriticalSpeedGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
        return CriticalSpeedApiFp.apiV1CriticalSpeedGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param xIntegrationUserCredential 
     * @param speedThreshold 
     */
    apiV1CriticalSpeedPut(params: {  "xIntegrationUserCredential": string; "speedThreshold"?: number; }, options?: any) {
        return CriticalSpeedApiFp.apiV1CriticalSpeedPut(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Get the critical speed settings for a fleet based on speed type input
     * @param xIntegrationUserCredential 
     * @param speedTypeEnum 
     */
    apiV1CriticalSpeedWithUnitsGet(params: {  "xIntegrationUserCredential": string; "speedTypeEnum"?: string; }, options?: any) {
        return CriticalSpeedApiFp.apiV1CriticalSpeedWithUnitsGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Update the critical speed settings for a fleet based on speed type input
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1CriticalSpeedWithUnitsPut(params: {  "xIntegrationUserCredential": string; "body"?: UpdateCriticalSpeedRequest; }, options?: any) {
        return CriticalSpeedApiFp.apiV1CriticalSpeedWithUnitsPut(params, options)(this.fetch, this.basePath);
    }
};

/**
 * CriticalSpeedApi - factory interface
 */
export const CriticalSpeedApiFactory = function (fetch?: FetchAPI, basePath?: string) {
    return {
        /** 
         * @param xIntegrationUserCredential 
         */
        apiV1CriticalSpeedGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
            return CriticalSpeedApiFp.apiV1CriticalSpeedGet(params, options)(fetch, basePath);
        },
        /** 
         * @param xIntegrationUserCredential 
         * @param speedThreshold 
         */
        apiV1CriticalSpeedPut(params: {  "xIntegrationUserCredential": string; "speedThreshold"?: number; }, options?: any) {
            return CriticalSpeedApiFp.apiV1CriticalSpeedPut(params, options)(fetch, basePath);
        },
        /** 
         * Get the critical speed settings for a fleet based on speed type input
         * @param xIntegrationUserCredential 
         * @param speedTypeEnum 
         */
        apiV1CriticalSpeedWithUnitsGet(params: {  "xIntegrationUserCredential": string; "speedTypeEnum"?: string; }, options?: any) {
            return CriticalSpeedApiFp.apiV1CriticalSpeedWithUnitsGet(params, options)(fetch, basePath);
        },
        /** 
         * Update the critical speed settings for a fleet based on speed type input
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1CriticalSpeedWithUnitsPut(params: {  "xIntegrationUserCredential": string; "body"?: UpdateCriticalSpeedRequest; }, options?: any) {
            return CriticalSpeedApiFp.apiV1CriticalSpeedWithUnitsPut(params, options)(fetch, basePath);
        },
    };
};


/**
 * DashboardApi - fetch parameter creator
 */
export const DashboardApiFetchParamCreator = {
    /** 
     *   This endpoint retrieves the stats for the dashboard page.    The call requires authentication.    The user &lt;b&gt;MUST&lt;/b&gt; be have either video event view or video event edit permissions.
     * @param xIntegrationUserCredential 
     * @param body VideoPlatform.Website.Core.Model.StatisticsDashboardFilterModel
     */
    apiV1DashboardLivePost(params: {  "xIntegrationUserCredential": string; "body"?: StatisticsDashboardFilterModel; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1DashboardLivePost");
        }
        const baseUrl = `/api/v1/dashboard/live`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};

/**
 * DashboardApi - functional programming interface
 */
export const DashboardApiFp = {
    /** 
     *   This endpoint retrieves the stats for the dashboard page.    The call requires authentication.    The user &lt;b&gt;MUST&lt;/b&gt; be have either video event view or video event edit permissions.
     * @param xIntegrationUserCredential 
     * @param body VideoPlatform.Website.Core.Model.StatisticsDashboardFilterModel
     */
    apiV1DashboardLivePost(params: { "xIntegrationUserCredential": string; "body"?: StatisticsDashboardFilterModel;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DashboardSummaryResponse> {
        const fetchArgs = DashboardApiFetchParamCreator.apiV1DashboardLivePost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
};

/**
 * DashboardApi - object-oriented interface
 */
export class DashboardApi extends BaseAPI {
    /** 
     *   This endpoint retrieves the stats for the dashboard page.    The call requires authentication.    The user &lt;b&gt;MUST&lt;/b&gt; be have either video event view or video event edit permissions.
     * @param xIntegrationUserCredential 
     * @param body VideoPlatform.Website.Core.Model.StatisticsDashboardFilterModel
     */
    apiV1DashboardLivePost(params: {  "xIntegrationUserCredential": string; "body"?: StatisticsDashboardFilterModel; }, options?: any) {
        return DashboardApiFp.apiV1DashboardLivePost(params, options)(this.fetch, this.basePath);
    }
};

/**
 * DashboardApi - factory interface
 */
export const DashboardApiFactory = function (fetch?: FetchAPI, basePath?: string) {
    return {
        /** 
         *   This endpoint retrieves the stats for the dashboard page.    The call requires authentication.    The user &lt;b&gt;MUST&lt;/b&gt; be have either video event view or video event edit permissions.
         * @param xIntegrationUserCredential 
         * @param body VideoPlatform.Website.Core.Model.StatisticsDashboardFilterModel
         */
        apiV1DashboardLivePost(params: {  "xIntegrationUserCredential": string; "body"?: StatisticsDashboardFilterModel; }, options?: any) {
            return DashboardApiFp.apiV1DashboardLivePost(params, options)(fetch, basePath);
        },
    };
};


/**
 * DriverApi - fetch parameter creator
 */
export const DriverApiFetchParamCreator = {
    /** 
     * Create multiple new drivers in the fleet of the logged in user
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1DriversBulkPost(params: {  "xIntegrationUserCredential": string; "body"?: Array<DriverRequest>; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1DriversBulkPost");
        }
        const baseUrl = `/api/v1/drivers/bulk`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Delete driver comment
     * @param id 
     * @param xIntegrationUserCredential 
     */
    apiV1DriversCommentIdDelete(params: {  "id": number; "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling apiV1DriversCommentIdDelete");
        }
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1DriversCommentIdDelete");
        }
        const baseUrl = `/api/v1/drivers/comment/{id}`
            .replace(`{${"id"}}`, `${ params["id"] }`);
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "DELETE" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Update driver comment
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1DriversCommentPut(params: {  "xIntegrationUserCredential": string; "body"?: CommentRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1DriversCommentPut");
        }
        const baseUrl = `/api/v1/drivers/comment`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "PUT" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Update driver(s) to IsDeleted &#x3D; true and end any associated driver/vehicle pairings
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1DriversDeletePut(params: {  "xIntegrationUserCredential": string; "body"?: Array<number>; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1DriversDeletePut");
        }
        const baseUrl = `/api/v1/drivers/delete`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "PUT" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Get driver details information
     * @param xIntegrationUserCredential 
     * @param driverId 
     */
    apiV1DriversDetailsGet(params: {  "xIntegrationUserCredential": string; "driverId"?: number; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1DriversDetailsGet");
        }
        const baseUrl = `/api/v1/drivers/details`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "driverId": params["driverId"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Get all Drivers with the fleetId of logged in user
     * @param xIntegrationUserCredential 
     * @param includeDeleted 
     */
    apiV1DriversGet(params: {  "xIntegrationUserCredential": string; "includeDeleted"?: boolean; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1DriversGet");
        }
        const baseUrl = `/api/v1/drivers`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "includeDeleted": params["includeDeleted"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Create driver comment
     * @param id 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1DriversIdCommentPost(params: {  "id": number; "xIntegrationUserCredential": string; "body"?: CommentRequest; }, options?: any): FetchArgs {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling apiV1DriversIdCommentPost");
        }
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1DriversIdCommentPost");
        }
        const baseUrl = `/api/v1/drivers/{id}/comment`
            .replace(`{${"id"}}`, `${ params["id"] }`);
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Update existing driver info
     * @param id 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1DriversIdPut(params: {  "id": number; "xIntegrationUserCredential": string; "body"?: DriverRequest; }, options?: any): FetchArgs {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling apiV1DriversIdPut");
        }
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1DriversIdPut");
        }
        const baseUrl = `/api/v1/drivers/{id}`
            .replace(`{${"id"}}`, `${ params["id"] }`);
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "PUT" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Update the location for a list of drivers
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1DriversLocationPut(params: {  "xIntegrationUserCredential": string; "body"?: LocationDriverRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1DriversLocationPut");
        }
        const baseUrl = `/api/v1/drivers/location`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "PUT" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Create a new driver in the fleet of the logged in user
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1DriversPost(params: {  "xIntegrationUserCredential": string; "body"?: DriverRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1DriversPost");
        }
        const baseUrl = `/api/v1/drivers`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Get all Drivers with fleetId of logged in user that are not currently assigned a vehicle
     * @param xIntegrationUserCredential 
     */
    apiV1DriversUnpairedGet(params: {  "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1DriversUnpairedGet");
        }
        const baseUrl = `/api/v1/drivers/unpaired`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};

/**
 * DriverApi - functional programming interface
 */
export const DriverApiFp = {
    /** 
     * Create multiple new drivers in the fleet of the logged in user
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1DriversBulkPost(params: { "xIntegrationUserCredential": string; "body"?: Array<DriverRequest>;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MessageResponse> {
        const fetchArgs = DriverApiFetchParamCreator.apiV1DriversBulkPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Delete driver comment
     * @param id 
     * @param xIntegrationUserCredential 
     */
    apiV1DriversCommentIdDelete(params: { "id": number; "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CommentResponseResponseBase> {
        const fetchArgs = DriverApiFetchParamCreator.apiV1DriversCommentIdDelete(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Update driver comment
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1DriversCommentPut(params: { "xIntegrationUserCredential": string; "body"?: CommentRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CommentResponseResponseBase> {
        const fetchArgs = DriverApiFetchParamCreator.apiV1DriversCommentPut(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Update driver(s) to IsDeleted &#x3D; true and end any associated driver/vehicle pairings
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1DriversDeletePut(params: { "xIntegrationUserCredential": string; "body"?: Array<number>;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<DriverResponse>> {
        const fetchArgs = DriverApiFetchParamCreator.apiV1DriversDeletePut(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Get driver details information
     * @param xIntegrationUserCredential 
     * @param driverId 
     */
    apiV1DriversDetailsGet(params: { "xIntegrationUserCredential": string; "driverId"?: number;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DriverDetailsResponseResponseBase> {
        const fetchArgs = DriverApiFetchParamCreator.apiV1DriversDetailsGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Get all Drivers with the fleetId of logged in user
     * @param xIntegrationUserCredential 
     * @param includeDeleted 
     */
    apiV1DriversGet(params: { "xIntegrationUserCredential": string; "includeDeleted"?: boolean;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DriverResponseIEnumerableResponseBase> {
        const fetchArgs = DriverApiFetchParamCreator.apiV1DriversGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Create driver comment
     * @param id 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1DriversIdCommentPost(params: { "id": number; "xIntegrationUserCredential": string; "body"?: CommentRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CommentResponseResponseBase> {
        const fetchArgs = DriverApiFetchParamCreator.apiV1DriversIdCommentPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Update existing driver info
     * @param id 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1DriversIdPut(params: { "id": number; "xIntegrationUserCredential": string; "body"?: DriverRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MessageResponse> {
        const fetchArgs = DriverApiFetchParamCreator.apiV1DriversIdPut(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Update the location for a list of drivers
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1DriversLocationPut(params: { "xIntegrationUserCredential": string; "body"?: LocationDriverRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MessageResponse> {
        const fetchArgs = DriverApiFetchParamCreator.apiV1DriversLocationPut(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Create a new driver in the fleet of the logged in user
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1DriversPost(params: { "xIntegrationUserCredential": string; "body"?: DriverRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DriverResponse> {
        const fetchArgs = DriverApiFetchParamCreator.apiV1DriversPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Get all Drivers with fleetId of logged in user that are not currently assigned a vehicle
     * @param xIntegrationUserCredential 
     */
    apiV1DriversUnpairedGet(params: { "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DriverResponseIEnumerableResponseBase> {
        const fetchArgs = DriverApiFetchParamCreator.apiV1DriversUnpairedGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
};

/**
 * DriverApi - object-oriented interface
 */
export class DriverApi extends BaseAPI {
    /** 
     * Create multiple new drivers in the fleet of the logged in user
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1DriversBulkPost(params: {  "xIntegrationUserCredential": string; "body"?: Array<DriverRequest>; }, options?: any) {
        return DriverApiFp.apiV1DriversBulkPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Delete driver comment
     * @param id 
     * @param xIntegrationUserCredential 
     */
    apiV1DriversCommentIdDelete(params: {  "id": number; "xIntegrationUserCredential": string; }, options?: any) {
        return DriverApiFp.apiV1DriversCommentIdDelete(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Update driver comment
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1DriversCommentPut(params: {  "xIntegrationUserCredential": string; "body"?: CommentRequest; }, options?: any) {
        return DriverApiFp.apiV1DriversCommentPut(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Update driver(s) to IsDeleted &#x3D; true and end any associated driver/vehicle pairings
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1DriversDeletePut(params: {  "xIntegrationUserCredential": string; "body"?: Array<number>; }, options?: any) {
        return DriverApiFp.apiV1DriversDeletePut(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Get driver details information
     * @param xIntegrationUserCredential 
     * @param driverId 
     */
    apiV1DriversDetailsGet(params: {  "xIntegrationUserCredential": string; "driverId"?: number; }, options?: any) {
        return DriverApiFp.apiV1DriversDetailsGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Get all Drivers with the fleetId of logged in user
     * @param xIntegrationUserCredential 
     * @param includeDeleted 
     */
    apiV1DriversGet(params: {  "xIntegrationUserCredential": string; "includeDeleted"?: boolean; }, options?: any) {
        return DriverApiFp.apiV1DriversGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Create driver comment
     * @param id 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1DriversIdCommentPost(params: {  "id": number; "xIntegrationUserCredential": string; "body"?: CommentRequest; }, options?: any) {
        return DriverApiFp.apiV1DriversIdCommentPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Update existing driver info
     * @param id 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1DriversIdPut(params: {  "id": number; "xIntegrationUserCredential": string; "body"?: DriverRequest; }, options?: any) {
        return DriverApiFp.apiV1DriversIdPut(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Update the location for a list of drivers
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1DriversLocationPut(params: {  "xIntegrationUserCredential": string; "body"?: LocationDriverRequest; }, options?: any) {
        return DriverApiFp.apiV1DriversLocationPut(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Create a new driver in the fleet of the logged in user
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1DriversPost(params: {  "xIntegrationUserCredential": string; "body"?: DriverRequest; }, options?: any) {
        return DriverApiFp.apiV1DriversPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Get all Drivers with fleetId of logged in user that are not currently assigned a vehicle
     * @param xIntegrationUserCredential 
     */
    apiV1DriversUnpairedGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
        return DriverApiFp.apiV1DriversUnpairedGet(params, options)(this.fetch, this.basePath);
    }
};

/**
 * DriverApi - factory interface
 */
export const DriverApiFactory = function (fetch?: FetchAPI, basePath?: string) {
    return {
        /** 
         * Create multiple new drivers in the fleet of the logged in user
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1DriversBulkPost(params: {  "xIntegrationUserCredential": string; "body"?: Array<DriverRequest>; }, options?: any) {
            return DriverApiFp.apiV1DriversBulkPost(params, options)(fetch, basePath);
        },
        /** 
         * Delete driver comment
         * @param id 
         * @param xIntegrationUserCredential 
         */
        apiV1DriversCommentIdDelete(params: {  "id": number; "xIntegrationUserCredential": string; }, options?: any) {
            return DriverApiFp.apiV1DriversCommentIdDelete(params, options)(fetch, basePath);
        },
        /** 
         * Update driver comment
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1DriversCommentPut(params: {  "xIntegrationUserCredential": string; "body"?: CommentRequest; }, options?: any) {
            return DriverApiFp.apiV1DriversCommentPut(params, options)(fetch, basePath);
        },
        /** 
         * Update driver(s) to IsDeleted &#x3D; true and end any associated driver/vehicle pairings
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1DriversDeletePut(params: {  "xIntegrationUserCredential": string; "body"?: Array<number>; }, options?: any) {
            return DriverApiFp.apiV1DriversDeletePut(params, options)(fetch, basePath);
        },
        /** 
         * Get driver details information
         * @param xIntegrationUserCredential 
         * @param driverId 
         */
        apiV1DriversDetailsGet(params: {  "xIntegrationUserCredential": string; "driverId"?: number; }, options?: any) {
            return DriverApiFp.apiV1DriversDetailsGet(params, options)(fetch, basePath);
        },
        /** 
         * Get all Drivers with the fleetId of logged in user
         * @param xIntegrationUserCredential 
         * @param includeDeleted 
         */
        apiV1DriversGet(params: {  "xIntegrationUserCredential": string; "includeDeleted"?: boolean; }, options?: any) {
            return DriverApiFp.apiV1DriversGet(params, options)(fetch, basePath);
        },
        /** 
         * Create driver comment
         * @param id 
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1DriversIdCommentPost(params: {  "id": number; "xIntegrationUserCredential": string; "body"?: CommentRequest; }, options?: any) {
            return DriverApiFp.apiV1DriversIdCommentPost(params, options)(fetch, basePath);
        },
        /** 
         * Update existing driver info
         * @param id 
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1DriversIdPut(params: {  "id": number; "xIntegrationUserCredential": string; "body"?: DriverRequest; }, options?: any) {
            return DriverApiFp.apiV1DriversIdPut(params, options)(fetch, basePath);
        },
        /** 
         * Update the location for a list of drivers
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1DriversLocationPut(params: {  "xIntegrationUserCredential": string; "body"?: LocationDriverRequest; }, options?: any) {
            return DriverApiFp.apiV1DriversLocationPut(params, options)(fetch, basePath);
        },
        /** 
         * Create a new driver in the fleet of the logged in user
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1DriversPost(params: {  "xIntegrationUserCredential": string; "body"?: DriverRequest; }, options?: any) {
            return DriverApiFp.apiV1DriversPost(params, options)(fetch, basePath);
        },
        /** 
         * Get all Drivers with fleetId of logged in user that are not currently assigned a vehicle
         * @param xIntegrationUserCredential 
         */
        apiV1DriversUnpairedGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
            return DriverApiFp.apiV1DriversUnpairedGet(params, options)(fetch, basePath);
        },
    };
};


/**
 * DriverCommentApi - fetch parameter creator
 */
export const DriverCommentApiFetchParamCreator = {
    /** 
     * Get all comments for a video
     * @param eventId EventId
     * @param xIntegrationUserCredential 
     */
    apiV1DriverCommentsEventIdGet(params: {  "eventId": number; "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "eventId" is set
        if (params["eventId"] == null) {
            throw new Error("Missing required parameter eventId when calling apiV1DriverCommentsEventIdGet");
        }
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1DriverCommentsEventIdGet");
        }
        const baseUrl = `/api/v1/driverComments/{eventId}`
            .replace(`{${"eventId"}}`, `${ params["eventId"] }`);
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};

/**
 * DriverCommentApi - functional programming interface
 */
export const DriverCommentApiFp = {
    /** 
     * Get all comments for a video
     * @param eventId EventId
     * @param xIntegrationUserCredential 
     */
    apiV1DriverCommentsEventIdGet(params: { "eventId": number; "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<DriverCommentResponse>> {
        const fetchArgs = DriverCommentApiFetchParamCreator.apiV1DriverCommentsEventIdGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
};

/**
 * DriverCommentApi - object-oriented interface
 */
export class DriverCommentApi extends BaseAPI {
    /** 
     * Get all comments for a video
     * @param eventId EventId
     * @param xIntegrationUserCredential 
     */
    apiV1DriverCommentsEventIdGet(params: {  "eventId": number; "xIntegrationUserCredential": string; }, options?: any) {
        return DriverCommentApiFp.apiV1DriverCommentsEventIdGet(params, options)(this.fetch, this.basePath);
    }
};

/**
 * DriverCommentApi - factory interface
 */
export const DriverCommentApiFactory = function (fetch?: FetchAPI, basePath?: string) {
    return {
        /** 
         * Get all comments for a video
         * @param eventId EventId
         * @param xIntegrationUserCredential 
         */
        apiV1DriverCommentsEventIdGet(params: {  "eventId": number; "xIntegrationUserCredential": string; }, options?: any) {
            return DriverCommentApiFp.apiV1DriverCommentsEventIdGet(params, options)(fetch, basePath);
        },
    };
};


/**
 * DriverNotificationApi - fetch parameter creator
 */
export const DriverNotificationApiFetchParamCreator = {
    /** 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1SenddriveremailPost(params: {  "xIntegrationUserCredential": string; "body"?: SendEmailRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1SenddriveremailPost");
        }
        const baseUrl = `/api/v1/senddriveremail`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1SenddrivertextPost(params: {  "xIntegrationUserCredential": string; "body"?: SendTextRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1SenddrivertextPost");
        }
        const baseUrl = `/api/v1/senddrivertext`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};

/**
 * DriverNotificationApi - functional programming interface
 */
export const DriverNotificationApiFp = {
    /** 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1SenddriveremailPost(params: { "xIntegrationUserCredential": string; "body"?: SendEmailRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = DriverNotificationApiFetchParamCreator.apiV1SenddriveremailPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1SenddrivertextPost(params: { "xIntegrationUserCredential": string; "body"?: SendTextRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = DriverNotificationApiFetchParamCreator.apiV1SenddrivertextPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
};

/**
 * DriverNotificationApi - object-oriented interface
 */
export class DriverNotificationApi extends BaseAPI {
    /** 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1SenddriveremailPost(params: {  "xIntegrationUserCredential": string; "body"?: SendEmailRequest; }, options?: any) {
        return DriverNotificationApiFp.apiV1SenddriveremailPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1SenddrivertextPost(params: {  "xIntegrationUserCredential": string; "body"?: SendTextRequest; }, options?: any) {
        return DriverNotificationApiFp.apiV1SenddrivertextPost(params, options)(this.fetch, this.basePath);
    }
};

/**
 * DriverNotificationApi - factory interface
 */
export const DriverNotificationApiFactory = function (fetch?: FetchAPI, basePath?: string) {
    return {
        /** 
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1SenddriveremailPost(params: {  "xIntegrationUserCredential": string; "body"?: SendEmailRequest; }, options?: any) {
            return DriverNotificationApiFp.apiV1SenddriveremailPost(params, options)(fetch, basePath);
        },
        /** 
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1SenddrivertextPost(params: {  "xIntegrationUserCredential": string; "body"?: SendTextRequest; }, options?: any) {
            return DriverNotificationApiFp.apiV1SenddrivertextPost(params, options)(fetch, basePath);
        },
    };
};


/**
 * EventNotificationSettingsApi - fetch parameter creator
 */
export const EventNotificationSettingsApiFetchParamCreator = {
    /** 
     * Get all event notifications
     * @param xIntegrationUserCredential 
     */
    apiV1EventNotificationSettingsGet(params: {  "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1EventNotificationSettingsGet");
        }
        const baseUrl = `/api/v1/eventNotificationSettings`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Update event notification settings
     * @param id 
     * @param xIntegrationUserCredential 
     * @param isActive 
     */
    apiV1EventNotificationSettingsIdPut(params: {  "id": number; "xIntegrationUserCredential": string; "isActive"?: boolean; }, options?: any): FetchArgs {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling apiV1EventNotificationSettingsIdPut");
        }
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1EventNotificationSettingsIdPut");
        }
        const baseUrl = `/api/v1/eventNotificationSettings/{id}`
            .replace(`{${"id"}}`, `${ params["id"] }`);
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "isActive": params["isActive"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "PUT" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param id 
     * @param xIntegrationUserCredential 
     */
    apiV1EventNotificationSettingsSubscriberIdDelete(params: {  "id": number; "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling apiV1EventNotificationSettingsSubscriberIdDelete");
        }
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1EventNotificationSettingsSubscriberIdDelete");
        }
        const baseUrl = `/api/v1/eventNotificationSettings/subscriber/{id}`
            .replace(`{${"id"}}`, `${ params["id"] }`);
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "DELETE" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Update subscriber
     * @param id 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1EventNotificationSettingsSubscriberIdPut(params: {  "id": number; "xIntegrationUserCredential": string; "body"?: SubscriberRequest; }, options?: any): FetchArgs {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling apiV1EventNotificationSettingsSubscriberIdPut");
        }
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1EventNotificationSettingsSubscriberIdPut");
        }
        const baseUrl = `/api/v1/eventNotificationSettings/subscriber/{id}`
            .replace(`{${"id"}}`, `${ params["id"] }`);
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "PUT" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Add new subscriber by fleet id in logged user
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1EventNotificationSettingsSubscriberPost(params: {  "xIntegrationUserCredential": string; "body"?: SubscriberRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1EventNotificationSettingsSubscriberPost");
        }
        const baseUrl = `/api/v1/eventNotificationSettings/subscriber`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Get all subscribers by fleet id in logged user
     * @param xIntegrationUserCredential 
     */
    apiV1EventNotificationSettingsSubscribersGet(params: {  "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1EventNotificationSettingsSubscribersGet");
        }
        const baseUrl = `/api/v1/eventNotificationSettings/subscribers`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Update event notification settings
     * @param id 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1EventNotificationSettingsTelematicProviderEventTypeIdPut(params: {  "id": number; "xIntegrationUserCredential": string; "body"?: boolean; }, options?: any): FetchArgs {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling apiV1EventNotificationSettingsTelematicProviderEventTypeIdPut");
        }
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1EventNotificationSettingsTelematicProviderEventTypeIdPut");
        }
        const baseUrl = `/api/v1/eventNotificationSettings/telematicProviderEventType/{id}`
            .replace(`{${"id"}}`, `${ params["id"] }`);
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "PUT" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};

/**
 * EventNotificationSettingsApi - functional programming interface
 */
export const EventNotificationSettingsApiFp = {
    /** 
     * Get all event notifications
     * @param xIntegrationUserCredential 
     */
    apiV1EventNotificationSettingsGet(params: { "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<EventNotificationResponse>> {
        const fetchArgs = EventNotificationSettingsApiFetchParamCreator.apiV1EventNotificationSettingsGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Update event notification settings
     * @param id 
     * @param xIntegrationUserCredential 
     * @param isActive 
     */
    apiV1EventNotificationSettingsIdPut(params: { "id": number; "xIntegrationUserCredential": string; "isActive"?: boolean;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = EventNotificationSettingsApiFetchParamCreator.apiV1EventNotificationSettingsIdPut(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param id 
     * @param xIntegrationUserCredential 
     */
    apiV1EventNotificationSettingsSubscriberIdDelete(params: { "id": number; "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = EventNotificationSettingsApiFetchParamCreator.apiV1EventNotificationSettingsSubscriberIdDelete(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Update subscriber
     * @param id 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1EventNotificationSettingsSubscriberIdPut(params: { "id": number; "xIntegrationUserCredential": string; "body"?: SubscriberRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = EventNotificationSettingsApiFetchParamCreator.apiV1EventNotificationSettingsSubscriberIdPut(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Add new subscriber by fleet id in logged user
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1EventNotificationSettingsSubscriberPost(params: { "xIntegrationUserCredential": string; "body"?: SubscriberRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = EventNotificationSettingsApiFetchParamCreator.apiV1EventNotificationSettingsSubscriberPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Get all subscribers by fleet id in logged user
     * @param xIntegrationUserCredential 
     */
    apiV1EventNotificationSettingsSubscribersGet(params: { "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<SubscriberResponse>> {
        const fetchArgs = EventNotificationSettingsApiFetchParamCreator.apiV1EventNotificationSettingsSubscribersGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Update event notification settings
     * @param id 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1EventNotificationSettingsTelematicProviderEventTypeIdPut(params: { "id": number; "xIntegrationUserCredential": string; "body"?: boolean;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = EventNotificationSettingsApiFetchParamCreator.apiV1EventNotificationSettingsTelematicProviderEventTypeIdPut(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
};

/**
 * EventNotificationSettingsApi - object-oriented interface
 */
export class EventNotificationSettingsApi extends BaseAPI {
    /** 
     * Get all event notifications
     * @param xIntegrationUserCredential 
     */
    apiV1EventNotificationSettingsGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
        return EventNotificationSettingsApiFp.apiV1EventNotificationSettingsGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Update event notification settings
     * @param id 
     * @param xIntegrationUserCredential 
     * @param isActive 
     */
    apiV1EventNotificationSettingsIdPut(params: {  "id": number; "xIntegrationUserCredential": string; "isActive"?: boolean; }, options?: any) {
        return EventNotificationSettingsApiFp.apiV1EventNotificationSettingsIdPut(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param id 
     * @param xIntegrationUserCredential 
     */
    apiV1EventNotificationSettingsSubscriberIdDelete(params: {  "id": number; "xIntegrationUserCredential": string; }, options?: any) {
        return EventNotificationSettingsApiFp.apiV1EventNotificationSettingsSubscriberIdDelete(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Update subscriber
     * @param id 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1EventNotificationSettingsSubscriberIdPut(params: {  "id": number; "xIntegrationUserCredential": string; "body"?: SubscriberRequest; }, options?: any) {
        return EventNotificationSettingsApiFp.apiV1EventNotificationSettingsSubscriberIdPut(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Add new subscriber by fleet id in logged user
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1EventNotificationSettingsSubscriberPost(params: {  "xIntegrationUserCredential": string; "body"?: SubscriberRequest; }, options?: any) {
        return EventNotificationSettingsApiFp.apiV1EventNotificationSettingsSubscriberPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Get all subscribers by fleet id in logged user
     * @param xIntegrationUserCredential 
     */
    apiV1EventNotificationSettingsSubscribersGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
        return EventNotificationSettingsApiFp.apiV1EventNotificationSettingsSubscribersGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Update event notification settings
     * @param id 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1EventNotificationSettingsTelematicProviderEventTypeIdPut(params: {  "id": number; "xIntegrationUserCredential": string; "body"?: boolean; }, options?: any) {
        return EventNotificationSettingsApiFp.apiV1EventNotificationSettingsTelematicProviderEventTypeIdPut(params, options)(this.fetch, this.basePath);
    }
};

/**
 * EventNotificationSettingsApi - factory interface
 */
export const EventNotificationSettingsApiFactory = function (fetch?: FetchAPI, basePath?: string) {
    return {
        /** 
         * Get all event notifications
         * @param xIntegrationUserCredential 
         */
        apiV1EventNotificationSettingsGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
            return EventNotificationSettingsApiFp.apiV1EventNotificationSettingsGet(params, options)(fetch, basePath);
        },
        /** 
         * Update event notification settings
         * @param id 
         * @param xIntegrationUserCredential 
         * @param isActive 
         */
        apiV1EventNotificationSettingsIdPut(params: {  "id": number; "xIntegrationUserCredential": string; "isActive"?: boolean; }, options?: any) {
            return EventNotificationSettingsApiFp.apiV1EventNotificationSettingsIdPut(params, options)(fetch, basePath);
        },
        /** 
         * @param id 
         * @param xIntegrationUserCredential 
         */
        apiV1EventNotificationSettingsSubscriberIdDelete(params: {  "id": number; "xIntegrationUserCredential": string; }, options?: any) {
            return EventNotificationSettingsApiFp.apiV1EventNotificationSettingsSubscriberIdDelete(params, options)(fetch, basePath);
        },
        /** 
         * Update subscriber
         * @param id 
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1EventNotificationSettingsSubscriberIdPut(params: {  "id": number; "xIntegrationUserCredential": string; "body"?: SubscriberRequest; }, options?: any) {
            return EventNotificationSettingsApiFp.apiV1EventNotificationSettingsSubscriberIdPut(params, options)(fetch, basePath);
        },
        /** 
         * Add new subscriber by fleet id in logged user
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1EventNotificationSettingsSubscriberPost(params: {  "xIntegrationUserCredential": string; "body"?: SubscriberRequest; }, options?: any) {
            return EventNotificationSettingsApiFp.apiV1EventNotificationSettingsSubscriberPost(params, options)(fetch, basePath);
        },
        /** 
         * Get all subscribers by fleet id in logged user
         * @param xIntegrationUserCredential 
         */
        apiV1EventNotificationSettingsSubscribersGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
            return EventNotificationSettingsApiFp.apiV1EventNotificationSettingsSubscribersGet(params, options)(fetch, basePath);
        },
        /** 
         * Update event notification settings
         * @param id 
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1EventNotificationSettingsTelematicProviderEventTypeIdPut(params: {  "id": number; "xIntegrationUserCredential": string; "body"?: boolean; }, options?: any) {
            return EventNotificationSettingsApiFp.apiV1EventNotificationSettingsTelematicProviderEventTypeIdPut(params, options)(fetch, basePath);
        },
    };
};


/**
 * FleetSettingsApi - fetch parameter creator
 */
export const FleetSettingsApiFetchParamCreator = {
    /** 
     * Delete Auto-Score Settings for fleet by videoEventTypeId
     * @param xIntegrationUserCredential 
     * @param videoEventTypeId 
     */
    apiV1FleetSettingsAutoScoreSettingsDelete(params: {  "xIntegrationUserCredential": string; "videoEventTypeId"?: number; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1FleetSettingsAutoScoreSettingsDelete");
        }
        const baseUrl = `/api/v1/fleetSettings/autoScoreSettings`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "videoEventTypeId": params["videoEventTypeId"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "DELETE" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Returns a list of Auto-score settings by fleet
     * @param xIntegrationUserCredential 
     */
    apiV1FleetSettingsAutoScoreSettingsGet(params: {  "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1FleetSettingsAutoScoreSettingsGet");
        }
        const baseUrl = `/api/v1/fleetSettings/autoScoreSettings`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Upsert Auto-Score Settings
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1FleetSettingsAutoScoreSettingsPost(params: {  "xIntegrationUserCredential": string; "body"?: AutoScoreSettingsRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1FleetSettingsAutoScoreSettingsPost");
        }
        const baseUrl = `/api/v1/fleetSettings/autoScoreSettings`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Returns the value for the key and fleet in session from the fleet settings, or in its absence from integration partner settings.
     * @param xIntegrationUserCredential 
     * @param key 
     */
    apiV1FleetSettingsGet(params: {  "xIntegrationUserCredential": string; "key"?: string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1FleetSettingsGet");
        }
        const baseUrl = `/api/v1/fleetSettings`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "key": params["key"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Returns the fleet timezone for the fleet in session. If not set, returns the default timezone.
     * @param xIntegrationUserCredential 
     */
    apiV1FleetSettingsTimezoneGet(params: {  "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1FleetSettingsTimezoneGet");
        }
        const baseUrl = `/api/v1/fleetSettings/timezone`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Upsert the fleet timezone for the fleet in session. If the timezone already exists, it will be updated. If not, a new record will be created.
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1FleetSettingsTimezonePost(params: {  "xIntegrationUserCredential": string; "body"?: FleetTimezoneRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1FleetSettingsTimezonePost");
        }
        const baseUrl = `/api/v1/fleetSettings/timezone`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Deletes the video event retention settings for the fleet in session.
     * @param xIntegrationUserCredential 
     */
    apiV1FleetSettingsVideoEventRetentionDelete(params: {  "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1FleetSettingsVideoEventRetentionDelete");
        }
        const baseUrl = `/api/v1/fleetSettings/videoEventRetention`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "DELETE" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Returns the video event retention settings for the fleet in session.
     * @param xIntegrationUserCredential 
     */
    apiV1FleetSettingsVideoEventRetentionGet(params: {  "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1FleetSettingsVideoEventRetentionGet");
        }
        const baseUrl = `/api/v1/fleetSettings/videoEventRetention`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Updates or creates the video event retention settings for the fleet in session.
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1FleetSettingsVideoEventRetentionPost(params: {  "xIntegrationUserCredential": string; "body"?: WebsiteVideoEventRetentionRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1FleetSettingsVideoEventRetentionPost");
        }
        const baseUrl = `/api/v1/fleetSettings/videoEventRetention`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};

/**
 * FleetSettingsApi - functional programming interface
 */
export const FleetSettingsApiFp = {
    /** 
     * Delete Auto-Score Settings for fleet by videoEventTypeId
     * @param xIntegrationUserCredential 
     * @param videoEventTypeId 
     */
    apiV1FleetSettingsAutoScoreSettingsDelete(params: { "xIntegrationUserCredential": string; "videoEventTypeId"?: number;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MessageResponse> {
        const fetchArgs = FleetSettingsApiFetchParamCreator.apiV1FleetSettingsAutoScoreSettingsDelete(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Returns a list of Auto-score settings by fleet
     * @param xIntegrationUserCredential 
     */
    apiV1FleetSettingsAutoScoreSettingsGet(params: { "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<AutoScoreSettingsResponse>> {
        const fetchArgs = FleetSettingsApiFetchParamCreator.apiV1FleetSettingsAutoScoreSettingsGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Upsert Auto-Score Settings
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1FleetSettingsAutoScoreSettingsPost(params: { "xIntegrationUserCredential": string; "body"?: AutoScoreSettingsRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MessageResponse> {
        const fetchArgs = FleetSettingsApiFetchParamCreator.apiV1FleetSettingsAutoScoreSettingsPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Returns the value for the key and fleet in session from the fleet settings, or in its absence from integration partner settings.
     * @param xIntegrationUserCredential 
     * @param key 
     */
    apiV1FleetSettingsGet(params: { "xIntegrationUserCredential": string; "key"?: string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FleetSettingResponse> {
        const fetchArgs = FleetSettingsApiFetchParamCreator.apiV1FleetSettingsGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Returns the fleet timezone for the fleet in session. If not set, returns the default timezone.
     * @param xIntegrationUserCredential 
     */
    apiV1FleetSettingsTimezoneGet(params: { "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FleetTimezoneResponse> {
        const fetchArgs = FleetSettingsApiFetchParamCreator.apiV1FleetSettingsTimezoneGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Upsert the fleet timezone for the fleet in session. If the timezone already exists, it will be updated. If not, a new record will be created.
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1FleetSettingsTimezonePost(params: { "xIntegrationUserCredential": string; "body"?: FleetTimezoneRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = FleetSettingsApiFetchParamCreator.apiV1FleetSettingsTimezonePost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Deletes the video event retention settings for the fleet in session.
     * @param xIntegrationUserCredential 
     */
    apiV1FleetSettingsVideoEventRetentionDelete(params: { "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MessageResponse> {
        const fetchArgs = FleetSettingsApiFetchParamCreator.apiV1FleetSettingsVideoEventRetentionDelete(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Returns the video event retention settings for the fleet in session.
     * @param xIntegrationUserCredential 
     */
    apiV1FleetSettingsVideoEventRetentionGet(params: { "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<VideoEventRetentionSettingsResponse> {
        const fetchArgs = FleetSettingsApiFetchParamCreator.apiV1FleetSettingsVideoEventRetentionGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Updates or creates the video event retention settings for the fleet in session.
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1FleetSettingsVideoEventRetentionPost(params: { "xIntegrationUserCredential": string; "body"?: WebsiteVideoEventRetentionRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MessageResponse> {
        const fetchArgs = FleetSettingsApiFetchParamCreator.apiV1FleetSettingsVideoEventRetentionPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
};

/**
 * FleetSettingsApi - object-oriented interface
 */
export class FleetSettingsApi extends BaseAPI {
    /** 
     * Delete Auto-Score Settings for fleet by videoEventTypeId
     * @param xIntegrationUserCredential 
     * @param videoEventTypeId 
     */
    apiV1FleetSettingsAutoScoreSettingsDelete(params: {  "xIntegrationUserCredential": string; "videoEventTypeId"?: number; }, options?: any) {
        return FleetSettingsApiFp.apiV1FleetSettingsAutoScoreSettingsDelete(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Returns a list of Auto-score settings by fleet
     * @param xIntegrationUserCredential 
     */
    apiV1FleetSettingsAutoScoreSettingsGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
        return FleetSettingsApiFp.apiV1FleetSettingsAutoScoreSettingsGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Upsert Auto-Score Settings
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1FleetSettingsAutoScoreSettingsPost(params: {  "xIntegrationUserCredential": string; "body"?: AutoScoreSettingsRequest; }, options?: any) {
        return FleetSettingsApiFp.apiV1FleetSettingsAutoScoreSettingsPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Returns the value for the key and fleet in session from the fleet settings, or in its absence from integration partner settings.
     * @param xIntegrationUserCredential 
     * @param key 
     */
    apiV1FleetSettingsGet(params: {  "xIntegrationUserCredential": string; "key"?: string; }, options?: any) {
        return FleetSettingsApiFp.apiV1FleetSettingsGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Returns the fleet timezone for the fleet in session. If not set, returns the default timezone.
     * @param xIntegrationUserCredential 
     */
    apiV1FleetSettingsTimezoneGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
        return FleetSettingsApiFp.apiV1FleetSettingsTimezoneGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Upsert the fleet timezone for the fleet in session. If the timezone already exists, it will be updated. If not, a new record will be created.
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1FleetSettingsTimezonePost(params: {  "xIntegrationUserCredential": string; "body"?: FleetTimezoneRequest; }, options?: any) {
        return FleetSettingsApiFp.apiV1FleetSettingsTimezonePost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Deletes the video event retention settings for the fleet in session.
     * @param xIntegrationUserCredential 
     */
    apiV1FleetSettingsVideoEventRetentionDelete(params: {  "xIntegrationUserCredential": string; }, options?: any) {
        return FleetSettingsApiFp.apiV1FleetSettingsVideoEventRetentionDelete(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Returns the video event retention settings for the fleet in session.
     * @param xIntegrationUserCredential 
     */
    apiV1FleetSettingsVideoEventRetentionGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
        return FleetSettingsApiFp.apiV1FleetSettingsVideoEventRetentionGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Updates or creates the video event retention settings for the fleet in session.
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1FleetSettingsVideoEventRetentionPost(params: {  "xIntegrationUserCredential": string; "body"?: WebsiteVideoEventRetentionRequest; }, options?: any) {
        return FleetSettingsApiFp.apiV1FleetSettingsVideoEventRetentionPost(params, options)(this.fetch, this.basePath);
    }
};

/**
 * FleetSettingsApi - factory interface
 */
export const FleetSettingsApiFactory = function (fetch?: FetchAPI, basePath?: string) {
    return {
        /** 
         * Delete Auto-Score Settings for fleet by videoEventTypeId
         * @param xIntegrationUserCredential 
         * @param videoEventTypeId 
         */
        apiV1FleetSettingsAutoScoreSettingsDelete(params: {  "xIntegrationUserCredential": string; "videoEventTypeId"?: number; }, options?: any) {
            return FleetSettingsApiFp.apiV1FleetSettingsAutoScoreSettingsDelete(params, options)(fetch, basePath);
        },
        /** 
         * Returns a list of Auto-score settings by fleet
         * @param xIntegrationUserCredential 
         */
        apiV1FleetSettingsAutoScoreSettingsGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
            return FleetSettingsApiFp.apiV1FleetSettingsAutoScoreSettingsGet(params, options)(fetch, basePath);
        },
        /** 
         * Upsert Auto-Score Settings
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1FleetSettingsAutoScoreSettingsPost(params: {  "xIntegrationUserCredential": string; "body"?: AutoScoreSettingsRequest; }, options?: any) {
            return FleetSettingsApiFp.apiV1FleetSettingsAutoScoreSettingsPost(params, options)(fetch, basePath);
        },
        /** 
         * Returns the value for the key and fleet in session from the fleet settings, or in its absence from integration partner settings.
         * @param xIntegrationUserCredential 
         * @param key 
         */
        apiV1FleetSettingsGet(params: {  "xIntegrationUserCredential": string; "key"?: string; }, options?: any) {
            return FleetSettingsApiFp.apiV1FleetSettingsGet(params, options)(fetch, basePath);
        },
        /** 
         * Returns the fleet timezone for the fleet in session. If not set, returns the default timezone.
         * @param xIntegrationUserCredential 
         */
        apiV1FleetSettingsTimezoneGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
            return FleetSettingsApiFp.apiV1FleetSettingsTimezoneGet(params, options)(fetch, basePath);
        },
        /** 
         * Upsert the fleet timezone for the fleet in session. If the timezone already exists, it will be updated. If not, a new record will be created.
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1FleetSettingsTimezonePost(params: {  "xIntegrationUserCredential": string; "body"?: FleetTimezoneRequest; }, options?: any) {
            return FleetSettingsApiFp.apiV1FleetSettingsTimezonePost(params, options)(fetch, basePath);
        },
        /** 
         * Deletes the video event retention settings for the fleet in session.
         * @param xIntegrationUserCredential 
         */
        apiV1FleetSettingsVideoEventRetentionDelete(params: {  "xIntegrationUserCredential": string; }, options?: any) {
            return FleetSettingsApiFp.apiV1FleetSettingsVideoEventRetentionDelete(params, options)(fetch, basePath);
        },
        /** 
         * Returns the video event retention settings for the fleet in session.
         * @param xIntegrationUserCredential 
         */
        apiV1FleetSettingsVideoEventRetentionGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
            return FleetSettingsApiFp.apiV1FleetSettingsVideoEventRetentionGet(params, options)(fetch, basePath);
        },
        /** 
         * Updates or creates the video event retention settings for the fleet in session.
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1FleetSettingsVideoEventRetentionPost(params: {  "xIntegrationUserCredential": string; "body"?: WebsiteVideoEventRetentionRequest; }, options?: any) {
            return FleetSettingsApiFp.apiV1FleetSettingsVideoEventRetentionPost(params, options)(fetch, basePath);
        },
    };
};


/**
 * HealthyApi - fetch parameter creator
 */
export const HealthyApiFetchParamCreator = {
    /** 
     * Create an empty response to allow external actors to verify if application is online
     * @param xIntegrationUserCredential 
     */
    apiV1HealthMygeotabGet(params: {  "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1HealthMygeotabGet");
        }
        const baseUrl = `/api/v1/health/mygeotab`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};

/**
 * HealthyApi - functional programming interface
 */
export const HealthyApiFp = {
    /** 
     * Create an empty response to allow external actors to verify if application is online
     * @param xIntegrationUserCredential 
     */
    apiV1HealthMygeotabGet(params: { "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<HealthCheckResponseResponseBase> {
        const fetchArgs = HealthyApiFetchParamCreator.apiV1HealthMygeotabGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
};

/**
 * HealthyApi - object-oriented interface
 */
export class HealthyApi extends BaseAPI {
    /** 
     * Create an empty response to allow external actors to verify if application is online
     * @param xIntegrationUserCredential 
     */
    apiV1HealthMygeotabGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
        return HealthyApiFp.apiV1HealthMygeotabGet(params, options)(this.fetch, this.basePath);
    }
};

/**
 * HealthyApi - factory interface
 */
export const HealthyApiFactory = function (fetch?: FetchAPI, basePath?: string) {
    return {
        /** 
         * Create an empty response to allow external actors to verify if application is online
         * @param xIntegrationUserCredential 
         */
        apiV1HealthMygeotabGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
            return HealthyApiFp.apiV1HealthMygeotabGet(params, options)(fetch, basePath);
        },
    };
};


/**
 * ImpersonateUserApi - fetch parameter creator
 */
export const ImpersonateUserApiFetchParamCreator = {
    /** 
     * This is strictly for testing and verifying the encrypted string can be decrypted
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1ImpersonateDecryptPost(params: {  "xIntegrationUserCredential": string; "body"?: string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1ImpersonateDecryptPost");
        }
        const baseUrl = `/api/v1/impersonate/decrypt`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * End an impersonation session
     * @param xIntegrationUserCredential 
     */
    apiV1ImpersonateEndPost(params: {  "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1ImpersonateEndPost");
        }
        const baseUrl = `/api/v1/impersonate/end`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Begin an impersonation session
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1ImpersonateStartPost(params: {  "xIntegrationUserCredential": string; "body"?: ImpersonateUserRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1ImpersonateStartPost");
        }
        const baseUrl = `/api/v1/impersonate/start`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};

/**
 * ImpersonateUserApi - functional programming interface
 */
export const ImpersonateUserApiFp = {
    /** 
     * This is strictly for testing and verifying the encrypted string can be decrypted
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1ImpersonateDecryptPost(params: { "xIntegrationUserCredential": string; "body"?: string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
        const fetchArgs = ImpersonateUserApiFetchParamCreator.apiV1ImpersonateDecryptPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * End an impersonation session
     * @param xIntegrationUserCredential 
     */
    apiV1ImpersonateEndPost(params: { "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<boolean> {
        const fetchArgs = ImpersonateUserApiFetchParamCreator.apiV1ImpersonateEndPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Begin an impersonation session
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1ImpersonateStartPost(params: { "xIntegrationUserCredential": string; "body"?: ImpersonateUserRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ImpersonateUserResponse> {
        const fetchArgs = ImpersonateUserApiFetchParamCreator.apiV1ImpersonateStartPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
};

/**
 * ImpersonateUserApi - object-oriented interface
 */
export class ImpersonateUserApi extends BaseAPI {
    /** 
     * This is strictly for testing and verifying the encrypted string can be decrypted
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1ImpersonateDecryptPost(params: {  "xIntegrationUserCredential": string; "body"?: string; }, options?: any) {
        return ImpersonateUserApiFp.apiV1ImpersonateDecryptPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * End an impersonation session
     * @param xIntegrationUserCredential 
     */
    apiV1ImpersonateEndPost(params: {  "xIntegrationUserCredential": string; }, options?: any) {
        return ImpersonateUserApiFp.apiV1ImpersonateEndPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Begin an impersonation session
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1ImpersonateStartPost(params: {  "xIntegrationUserCredential": string; "body"?: ImpersonateUserRequest; }, options?: any) {
        return ImpersonateUserApiFp.apiV1ImpersonateStartPost(params, options)(this.fetch, this.basePath);
    }
};

/**
 * ImpersonateUserApi - factory interface
 */
export const ImpersonateUserApiFactory = function (fetch?: FetchAPI, basePath?: string) {
    return {
        /** 
         * This is strictly for testing and verifying the encrypted string can be decrypted
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1ImpersonateDecryptPost(params: {  "xIntegrationUserCredential": string; "body"?: string; }, options?: any) {
            return ImpersonateUserApiFp.apiV1ImpersonateDecryptPost(params, options)(fetch, basePath);
        },
        /** 
         * End an impersonation session
         * @param xIntegrationUserCredential 
         */
        apiV1ImpersonateEndPost(params: {  "xIntegrationUserCredential": string; }, options?: any) {
            return ImpersonateUserApiFp.apiV1ImpersonateEndPost(params, options)(fetch, basePath);
        },
        /** 
         * Begin an impersonation session
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1ImpersonateStartPost(params: {  "xIntegrationUserCredential": string; "body"?: ImpersonateUserRequest; }, options?: any) {
            return ImpersonateUserApiFp.apiV1ImpersonateStartPost(params, options)(fetch, basePath);
        },
    };
};


/**
 * InstallersApi - fetch parameter creator
 */
export const InstallersApiFetchParamCreator = {
    /** 
     * Get users with the installer role
     * @param xIntegrationUserCredential 
     */
    apiV1InstallersGet(params: {  "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1InstallersGet");
        }
        const baseUrl = `/api/v1/installers`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Send an email to the given installer user:  - If they have not verified their email, ask them to (re)set their password  - If they have verified their email, resend a relevant fleet assignment update email
     * @param id The installer user&#39;s ID
     * @param xIntegrationUserCredential 
     */
    apiV1InstallersIdEmailGet(params: {  "id": string; "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling apiV1InstallersIdEmailGet");
        }
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1InstallersIdEmailGet");
        }
        const baseUrl = `/api/v1/installers/{id}/email`
            .replace(`{${"id"}}`, `${ params["id"] }`);
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Update an installer user&#39;s active dates on the fleet
     * @param id The installer user&#39;s ID
     * @param xIntegrationUserCredential 
     * @param body The new start and end date
     */
    apiV1InstallersIdPut(params: {  "id": string; "xIntegrationUserCredential": string; "body"?: InstallerUserDatesUpdateRequest; }, options?: any): FetchArgs {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling apiV1InstallersIdPut");
        }
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1InstallersIdPut");
        }
        const baseUrl = `/api/v1/installers/{id}`
            .replace(`{${"id"}}`, `${ params["id"] }`);
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "PUT" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Create a user with the installer role
     * @param xIntegrationUserCredential 
     * @param body The installer&#39;s details
     */
    apiV1InstallersPost(params: {  "xIntegrationUserCredential": string; "body"?: InstallerUserRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1InstallersPost");
        }
        const baseUrl = `/api/v1/installers`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};

/**
 * InstallersApi - functional programming interface
 */
export const InstallersApiFp = {
    /** 
     * Get users with the installer role
     * @param xIntegrationUserCredential 
     */
    apiV1InstallersGet(params: { "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<InstallerUserResponse>> {
        const fetchArgs = InstallersApiFetchParamCreator.apiV1InstallersGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Send an email to the given installer user:  - If they have not verified their email, ask them to (re)set their password  - If they have verified their email, resend a relevant fleet assignment update email
     * @param id The installer user&#39;s ID
     * @param xIntegrationUserCredential 
     */
    apiV1InstallersIdEmailGet(params: { "id": string; "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = InstallersApiFetchParamCreator.apiV1InstallersIdEmailGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Update an installer user&#39;s active dates on the fleet
     * @param id The installer user&#39;s ID
     * @param xIntegrationUserCredential 
     * @param body The new start and end date
     */
    apiV1InstallersIdPut(params: { "id": string; "xIntegrationUserCredential": string; "body"?: InstallerUserDatesUpdateRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = InstallersApiFetchParamCreator.apiV1InstallersIdPut(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Create a user with the installer role
     * @param xIntegrationUserCredential 
     * @param body The installer&#39;s details
     */
    apiV1InstallersPost(params: { "xIntegrationUserCredential": string; "body"?: InstallerUserRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = InstallersApiFetchParamCreator.apiV1InstallersPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
};

/**
 * InstallersApi - object-oriented interface
 */
export class InstallersApi extends BaseAPI {
    /** 
     * Get users with the installer role
     * @param xIntegrationUserCredential 
     */
    apiV1InstallersGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
        return InstallersApiFp.apiV1InstallersGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Send an email to the given installer user:  - If they have not verified their email, ask them to (re)set their password  - If they have verified their email, resend a relevant fleet assignment update email
     * @param id The installer user&#39;s ID
     * @param xIntegrationUserCredential 
     */
    apiV1InstallersIdEmailGet(params: {  "id": string; "xIntegrationUserCredential": string; }, options?: any) {
        return InstallersApiFp.apiV1InstallersIdEmailGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Update an installer user&#39;s active dates on the fleet
     * @param id The installer user&#39;s ID
     * @param xIntegrationUserCredential 
     * @param body The new start and end date
     */
    apiV1InstallersIdPut(params: {  "id": string; "xIntegrationUserCredential": string; "body"?: InstallerUserDatesUpdateRequest; }, options?: any) {
        return InstallersApiFp.apiV1InstallersIdPut(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Create a user with the installer role
     * @param xIntegrationUserCredential 
     * @param body The installer&#39;s details
     */
    apiV1InstallersPost(params: {  "xIntegrationUserCredential": string; "body"?: InstallerUserRequest; }, options?: any) {
        return InstallersApiFp.apiV1InstallersPost(params, options)(this.fetch, this.basePath);
    }
};

/**
 * InstallersApi - factory interface
 */
export const InstallersApiFactory = function (fetch?: FetchAPI, basePath?: string) {
    return {
        /** 
         * Get users with the installer role
         * @param xIntegrationUserCredential 
         */
        apiV1InstallersGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
            return InstallersApiFp.apiV1InstallersGet(params, options)(fetch, basePath);
        },
        /** 
         * Send an email to the given installer user:  - If they have not verified their email, ask them to (re)set their password  - If they have verified their email, resend a relevant fleet assignment update email
         * @param id The installer user&#39;s ID
         * @param xIntegrationUserCredential 
         */
        apiV1InstallersIdEmailGet(params: {  "id": string; "xIntegrationUserCredential": string; }, options?: any) {
            return InstallersApiFp.apiV1InstallersIdEmailGet(params, options)(fetch, basePath);
        },
        /** 
         * Update an installer user&#39;s active dates on the fleet
         * @param id The installer user&#39;s ID
         * @param xIntegrationUserCredential 
         * @param body The new start and end date
         */
        apiV1InstallersIdPut(params: {  "id": string; "xIntegrationUserCredential": string; "body"?: InstallerUserDatesUpdateRequest; }, options?: any) {
            return InstallersApiFp.apiV1InstallersIdPut(params, options)(fetch, basePath);
        },
        /** 
         * Create a user with the installer role
         * @param xIntegrationUserCredential 
         * @param body The installer&#39;s details
         */
        apiV1InstallersPost(params: {  "xIntegrationUserCredential": string; "body"?: InstallerUserRequest; }, options?: any) {
            return InstallersApiFp.apiV1InstallersPost(params, options)(fetch, basePath);
        },
    };
};


/**
 * IntegrationPartnerDataApi - fetch parameter creator
 */
export const IntegrationPartnerDataApiFetchParamCreator = {
    /**
     * @param xIntegrationUserCredential
     * @param groupsFilter 
     * @param includeCameraPairings 
     */
    apiV1IntegrationDevicesGet(params: {  "xIntegrationUserCredential": string; "groupsFilter"?: string; "includeCameraPairings"?: boolean; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1IntegrationDevicesGet");
        }
        const baseUrl = `/api/v1/integration/devices`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "groupsFilter": params["groupsFilter"],
            "includeCameraPairings": params["includeCameraPairings"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param groupsFilter 
     */
    apiV1IntegrationDriversGet(params: {  "xIntegrationUserCredential": string; "groupsFilter"?: string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1IntegrationDriversGet");
        }
        const baseUrl = `/api/v1/integration/drivers`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "groupsFilter": params["groupsFilter"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     */
    apiV1IntegrationUserGet(params: {  "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1IntegrationUserGet");
        }
        const baseUrl = `/api/v1/integration/user`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};

/**
 * IntegrationPartnerDataApi - functional programming interface
 */
export const IntegrationPartnerDataApiFp = {
    /**
     * @param xIntegrationUserCredential
     * @param groupsFilter 
     * @param includeCameraPairings 
     */
    apiV1IntegrationDevicesGet(params: { "xIntegrationUserCredential": string; "groupsFilter"?: string; "includeCameraPairings"?: boolean;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<TelematicProviderVehicleResponse>> {
        const fetchArgs = IntegrationPartnerDataApiFetchParamCreator.apiV1IntegrationDevicesGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param groupsFilter 
     */
    apiV1IntegrationDriversGet(params: { "xIntegrationUserCredential": string; "groupsFilter"?: string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<TelematicProviderDriverResponse>> {
        const fetchArgs = IntegrationPartnerDataApiFetchParamCreator.apiV1IntegrationDriversGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     */
    apiV1IntegrationUserGet(params: { "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TelematicProviderUserResponse> {
        const fetchArgs = IntegrationPartnerDataApiFetchParamCreator.apiV1IntegrationUserGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
};

/**
 * IntegrationPartnerDataApi - object-oriented interface
 */
export class IntegrationPartnerDataApi extends BaseAPI {
    /**
     * @param xIntegrationUserCredential 
     * @param groupsFilter 
     * @param includeCameraPairings 
     */
    apiV1IntegrationDevicesGet(params: {  "xIntegrationUserCredential": string; "groupsFilter"?: string; "includeCameraPairings"?: boolean; }, options?: any) {
        return IntegrationPartnerDataApiFp.apiV1IntegrationDevicesGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param xIntegrationUserCredential 
     * @param groupsFilter 
     */
    apiV1IntegrationDriversGet(params: {  "xIntegrationUserCredential": string; "groupsFilter"?: string; }, options?: any) {
        return IntegrationPartnerDataApiFp.apiV1IntegrationDriversGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param xIntegrationUserCredential 
     */
    apiV1IntegrationUserGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
        return IntegrationPartnerDataApiFp.apiV1IntegrationUserGet(params, options)(this.fetch, this.basePath);
    }
};

/**
 * IntegrationPartnerDataApi - factory interface
 */
export const IntegrationPartnerDataApiFactory = function (fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * @param xIntegrationUserCredential
         * @param groupsFilter 
         * @param includeCameraPairings 
         */
        apiV1IntegrationDevicesGet(params: {  "xIntegrationUserCredential": string; "groupsFilter"?: string; "includeCameraPairings"?: boolean; }, options?: any) {
            return IntegrationPartnerDataApiFp.apiV1IntegrationDevicesGet(params, options)(fetch, basePath);
        },
        /** 
         * @param xIntegrationUserCredential 
         * @param groupsFilter 
         */
        apiV1IntegrationDriversGet(params: {  "xIntegrationUserCredential": string; "groupsFilter"?: string; }, options?: any) {
            return IntegrationPartnerDataApiFp.apiV1IntegrationDriversGet(params, options)(fetch, basePath);
        },
        /** 
         * @param xIntegrationUserCredential 
         */
        apiV1IntegrationUserGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
            return IntegrationPartnerDataApiFp.apiV1IntegrationUserGet(params, options)(fetch, basePath);
        },
    };
};


/**
 * LocationApi - fetch parameter creator
 */
export const LocationApiFetchParamCreator = {
    /** 
     * Delete location by locationId
     * @param xIntegrationUserCredential 
     * @param locationId 
     */
    apiV1LocationsDelete(params: {  "xIntegrationUserCredential": string; "locationId"?: number; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1LocationsDelete");
        }
        const baseUrl = `/api/v1/locations`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "locationId": params["locationId"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "DELETE" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Get location details by Id
     * @param xIntegrationUserCredential 
     * @param locationId 
     */
    apiV1LocationsDetailsGet(params: {  "xIntegrationUserCredential": string; "locationId"?: number; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1LocationsDetailsGet");
        }
        const baseUrl = `/api/v1/locations/details`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "locationId": params["locationId"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Get locations from LocationFilter by user and fleet.
     * @param xIntegrationUserCredential 
     */
    apiV1LocationsFilterGet(params: {  "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1LocationsFilterGet");
        }
        const baseUrl = `/api/v1/locations/filter`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Update location filter
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1LocationsFilterPost(params: {  "xIntegrationUserCredential": string; "body"?: LocationFilterRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1LocationsFilterPost");
        }
        const baseUrl = `/api/v1/locations/filter`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Get all locations for fleet
     * @param xIntegrationUserCredential 
     */
    apiV1LocationsGet(params: {  "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1LocationsGet");
        }
        const baseUrl = `/api/v1/locations`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Update Location for fleet
     * @param id 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1LocationsIdPut(params: {  "id": number; "xIntegrationUserCredential": string; "body"?: LocationRequest; }, options?: any): FetchArgs {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling apiV1LocationsIdPut");
        }
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1LocationsIdPut");
        }
        const baseUrl = `/api/v1/locations/{id}`
            .replace(`{${"id"}}`, `${ params["id"] }`);
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "PUT" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Create Location for fleet
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1LocationsPost(params: {  "xIntegrationUserCredential": string; "body"?: LocationRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1LocationsPost");
        }
        const baseUrl = `/api/v1/locations`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};

/**
 * LocationApi - functional programming interface
 */
export const LocationApiFp = {
    /** 
     * Delete location by locationId
     * @param xIntegrationUserCredential 
     * @param locationId 
     */
    apiV1LocationsDelete(params: { "xIntegrationUserCredential": string; "locationId"?: number;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MessageResponse> {
        const fetchArgs = LocationApiFetchParamCreator.apiV1LocationsDelete(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Get location details by Id
     * @param xIntegrationUserCredential 
     * @param locationId 
     */
    apiV1LocationsDetailsGet(params: { "xIntegrationUserCredential": string; "locationId"?: number;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<LocationDetailsResponseResponseBase> {
        const fetchArgs = LocationApiFetchParamCreator.apiV1LocationsDetailsGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Get locations from LocationFilter by user and fleet.
     * @param xIntegrationUserCredential 
     */
    apiV1LocationsFilterGet(params: { "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<LocationFilterResponse>> {
        const fetchArgs = LocationApiFetchParamCreator.apiV1LocationsFilterGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Update location filter
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1LocationsFilterPost(params: { "xIntegrationUserCredential": string; "body"?: LocationFilterRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MessageResponse> {
        const fetchArgs = LocationApiFetchParamCreator.apiV1LocationsFilterPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Get all locations for fleet
     * @param xIntegrationUserCredential 
     */
    apiV1LocationsGet(params: { "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<LocationsResponseResponseBase> {
        const fetchArgs = LocationApiFetchParamCreator.apiV1LocationsGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Update Location for fleet
     * @param id 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1LocationsIdPut(params: { "id": number; "xIntegrationUserCredential": string; "body"?: LocationRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MessageResponse> {
        const fetchArgs = LocationApiFetchParamCreator.apiV1LocationsIdPut(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Create Location for fleet
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1LocationsPost(params: { "xIntegrationUserCredential": string; "body"?: LocationRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MessageResponse> {
        const fetchArgs = LocationApiFetchParamCreator.apiV1LocationsPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
};

/**
 * LocationApi - object-oriented interface
 */
export class LocationApi extends BaseAPI {
    /** 
     * Delete location by locationId
     * @param xIntegrationUserCredential 
     * @param locationId 
     */
    apiV1LocationsDelete(params: {  "xIntegrationUserCredential": string; "locationId"?: number; }, options?: any) {
        return LocationApiFp.apiV1LocationsDelete(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Get location details by Id
     * @param xIntegrationUserCredential 
     * @param locationId 
     */
    apiV1LocationsDetailsGet(params: {  "xIntegrationUserCredential": string; "locationId"?: number; }, options?: any) {
        return LocationApiFp.apiV1LocationsDetailsGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Get locations from LocationFilter by user and fleet.
     * @param xIntegrationUserCredential 
     */
    apiV1LocationsFilterGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
        return LocationApiFp.apiV1LocationsFilterGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Update location filter
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1LocationsFilterPost(params: {  "xIntegrationUserCredential": string; "body"?: LocationFilterRequest; }, options?: any) {
        return LocationApiFp.apiV1LocationsFilterPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Get all locations for fleet
     * @param xIntegrationUserCredential 
     */
    apiV1LocationsGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
        return LocationApiFp.apiV1LocationsGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Update Location for fleet
     * @param id 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1LocationsIdPut(params: {  "id": number; "xIntegrationUserCredential": string; "body"?: LocationRequest; }, options?: any) {
        return LocationApiFp.apiV1LocationsIdPut(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Create Location for fleet
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1LocationsPost(params: {  "xIntegrationUserCredential": string; "body"?: LocationRequest; }, options?: any) {
        return LocationApiFp.apiV1LocationsPost(params, options)(this.fetch, this.basePath);
    }
};

/**
 * LocationApi - factory interface
 */
export const LocationApiFactory = function (fetch?: FetchAPI, basePath?: string) {
    return {
        /** 
         * Delete location by locationId
         * @param xIntegrationUserCredential 
         * @param locationId 
         */
        apiV1LocationsDelete(params: {  "xIntegrationUserCredential": string; "locationId"?: number; }, options?: any) {
            return LocationApiFp.apiV1LocationsDelete(params, options)(fetch, basePath);
        },
        /** 
         * Get location details by Id
         * @param xIntegrationUserCredential 
         * @param locationId 
         */
        apiV1LocationsDetailsGet(params: {  "xIntegrationUserCredential": string; "locationId"?: number; }, options?: any) {
            return LocationApiFp.apiV1LocationsDetailsGet(params, options)(fetch, basePath);
        },
        /** 
         * Get locations from LocationFilter by user and fleet.
         * @param xIntegrationUserCredential 
         */
        apiV1LocationsFilterGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
            return LocationApiFp.apiV1LocationsFilterGet(params, options)(fetch, basePath);
        },
        /** 
         * Update location filter
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1LocationsFilterPost(params: {  "xIntegrationUserCredential": string; "body"?: LocationFilterRequest; }, options?: any) {
            return LocationApiFp.apiV1LocationsFilterPost(params, options)(fetch, basePath);
        },
        /** 
         * Get all locations for fleet
         * @param xIntegrationUserCredential 
         */
        apiV1LocationsGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
            return LocationApiFp.apiV1LocationsGet(params, options)(fetch, basePath);
        },
        /** 
         * Update Location for fleet
         * @param id 
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1LocationsIdPut(params: {  "id": number; "xIntegrationUserCredential": string; "body"?: LocationRequest; }, options?: any) {
            return LocationApiFp.apiV1LocationsIdPut(params, options)(fetch, basePath);
        },
        /** 
         * Create Location for fleet
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1LocationsPost(params: {  "xIntegrationUserCredential": string; "body"?: LocationRequest; }, options?: any) {
            return LocationApiFp.apiV1LocationsPost(params, options)(fetch, basePath);
        },
    };
};


/**
 * MapApi - fetch parameter creator
 */
export const MapApiFetchParamCreator = {
    /** 
     * @param xIntegrationUserCredential 
     * @param vehiclesIds 
     */
    apiV1MapVehiclesLastlocationGet(params: {  "xIntegrationUserCredential": string; "vehiclesIds"?: Array<number>; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1MapVehiclesLastlocationGet");
        }
        const baseUrl = `/api/v1/map/vehicles/lastlocation`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "VehiclesIds": params["vehiclesIds"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param vehicleId 
     * @param fromDateTime 
     * @param toDateTime 
     * @param minimumSecondsBetweenPoints 
     * @param xIntegrationUserCredential 
     */
    apiV1MapVehiclesVehicleIdHistoryGet(params: {  "vehicleId": number; "fromDateTime": Date; "toDateTime": Date; "minimumSecondsBetweenPoints": number; "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "vehicleId" is set
        if (params["vehicleId"] == null) {
            throw new Error("Missing required parameter vehicleId when calling apiV1MapVehiclesVehicleIdHistoryGet");
        }
        // verify required parameter "fromDateTime" is set
        if (params["fromDateTime"] == null) {
            throw new Error("Missing required parameter fromDateTime when calling apiV1MapVehiclesVehicleIdHistoryGet");
        }
        // verify required parameter "toDateTime" is set
        if (params["toDateTime"] == null) {
            throw new Error("Missing required parameter toDateTime when calling apiV1MapVehiclesVehicleIdHistoryGet");
        }
        // verify required parameter "minimumSecondsBetweenPoints" is set
        if (params["minimumSecondsBetweenPoints"] == null) {
            throw new Error("Missing required parameter minimumSecondsBetweenPoints when calling apiV1MapVehiclesVehicleIdHistoryGet");
        }
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1MapVehiclesVehicleIdHistoryGet");
        }
        const baseUrl = `/api/v1/map/vehicles/{vehicleId}/history`
            .replace(`{${"vehicleId"}}`, `${ params["vehicleId"] }`);
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "FromDateTime": params["fromDateTime"],
            "ToDateTime": params["toDateTime"],
            "MinimumSecondsBetweenPoints": params["minimumSecondsBetweenPoints"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};

/**
 * MapApi - functional programming interface
 */
export const MapApiFp = {
    /** 
     * @param xIntegrationUserCredential 
     * @param vehiclesIds 
     */
    apiV1MapVehiclesLastlocationGet(params: { "xIntegrationUserCredential": string; "vehiclesIds"?: Array<number>;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<VehicleMapLocationResponse>> {
        const fetchArgs = MapApiFetchParamCreator.apiV1MapVehiclesLastlocationGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param vehicleId 
     * @param fromDateTime 
     * @param toDateTime 
     * @param minimumSecondsBetweenPoints 
     * @param xIntegrationUserCredential 
     */
    apiV1MapVehiclesVehicleIdHistoryGet(params: { "vehicleId": number; "fromDateTime": Date; "toDateTime": Date; "minimumSecondsBetweenPoints": number; "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<VehicleHistoryResponse> {
        const fetchArgs = MapApiFetchParamCreator.apiV1MapVehiclesVehicleIdHistoryGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
};

/**
 * MapApi - object-oriented interface
 */
export class MapApi extends BaseAPI {
    /** 
     * @param xIntegrationUserCredential 
     * @param vehiclesIds 
     */
    apiV1MapVehiclesLastlocationGet(params: {  "xIntegrationUserCredential": string; "vehiclesIds"?: Array<number>; }, options?: any) {
        return MapApiFp.apiV1MapVehiclesLastlocationGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param vehicleId 
     * @param fromDateTime 
     * @param toDateTime 
     * @param minimumSecondsBetweenPoints 
     * @param xIntegrationUserCredential 
     */
    apiV1MapVehiclesVehicleIdHistoryGet(params: {  "vehicleId": number; "fromDateTime": Date; "toDateTime": Date; "minimumSecondsBetweenPoints": number; "xIntegrationUserCredential": string; }, options?: any) {
        return MapApiFp.apiV1MapVehiclesVehicleIdHistoryGet(params, options)(this.fetch, this.basePath);
    }
};

/**
 * MapApi - factory interface
 */
export const MapApiFactory = function (fetch?: FetchAPI, basePath?: string) {
    return {
        /** 
         * @param xIntegrationUserCredential 
         * @param vehiclesIds 
         */
        apiV1MapVehiclesLastlocationGet(params: {  "xIntegrationUserCredential": string; "vehiclesIds"?: Array<number>; }, options?: any) {
            return MapApiFp.apiV1MapVehiclesLastlocationGet(params, options)(fetch, basePath);
        },
        /** 
         * @param vehicleId 
         * @param fromDateTime 
         * @param toDateTime 
         * @param minimumSecondsBetweenPoints 
         * @param xIntegrationUserCredential 
         */
        apiV1MapVehiclesVehicleIdHistoryGet(params: {  "vehicleId": number; "fromDateTime": Date; "toDateTime": Date; "minimumSecondsBetweenPoints": number; "xIntegrationUserCredential": string; }, options?: any) {
            return MapApiFp.apiV1MapVehiclesVehicleIdHistoryGet(params, options)(fetch, basePath);
        },
    };
};


/**
 * PricingPlanApi - fetch parameter creator
 */
export const PricingPlanApiFetchParamCreator = {
    /** 
     * @param xIntegrationUserCredential 
     */
    apiV1PricingplanGet(params: {  "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1PricingplanGet");
        }
        const baseUrl = `/api/v1/pricingplan`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};

/**
 * PricingPlanApi - functional programming interface
 */
export const PricingPlanApiFp = {
    /** 
     * @param xIntegrationUserCredential 
     */
    apiV1PricingplanGet(params: { "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PricingPlanResponse> {
        const fetchArgs = PricingPlanApiFetchParamCreator.apiV1PricingplanGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
};

/**
 * PricingPlanApi - object-oriented interface
 */
export class PricingPlanApi extends BaseAPI {
    /** 
     * @param xIntegrationUserCredential 
     */
    apiV1PricingplanGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
        return PricingPlanApiFp.apiV1PricingplanGet(params, options)(this.fetch, this.basePath);
    }
};

/**
 * PricingPlanApi - factory interface
 */
export const PricingPlanApiFactory = function (fetch?: FetchAPI, basePath?: string) {
    return {
        /** 
         * @param xIntegrationUserCredential 
         */
        apiV1PricingplanGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
            return PricingPlanApiFp.apiV1PricingplanGet(params, options)(fetch, basePath);
        },
    };
};


/**
 * SplitIoApi - fetch parameter creator
 */
export const SplitIoApiFetchParamCreator = {
    /** 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1SplitioFeaturetogglePost(params: {  "xIntegrationUserCredential": string; "body"?: SplitTreatmentOptions; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1SplitioFeaturetogglePost");
        }
        const baseUrl = `/api/v1/splitio/featuretoggle`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};

/**
 * SplitIoApi - functional programming interface
 */
export const SplitIoApiFp = {
    /** 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1SplitioFeaturetogglePost(params: { "xIntegrationUserCredential": string; "body"?: SplitTreatmentOptions;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SplitFeatureToggle> {
        const fetchArgs = SplitIoApiFetchParamCreator.apiV1SplitioFeaturetogglePost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
};

/**
 * SplitIoApi - object-oriented interface
 */
export class SplitIoApi extends BaseAPI {
    /** 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1SplitioFeaturetogglePost(params: {  "xIntegrationUserCredential": string; "body"?: SplitTreatmentOptions; }, options?: any) {
        return SplitIoApiFp.apiV1SplitioFeaturetogglePost(params, options)(this.fetch, this.basePath);
    }
};

/**
 * SplitIoApi - factory interface
 */
export const SplitIoApiFactory = function (fetch?: FetchAPI, basePath?: string) {
    return {
        /** 
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1SplitioFeaturetogglePost(params: {  "xIntegrationUserCredential": string; "body"?: SplitTreatmentOptions; }, options?: any) {
            return SplitIoApiFp.apiV1SplitioFeaturetogglePost(params, options)(fetch, basePath);
        },
    };
};


/**
 * TmcApi - fetch parameter creator
 */
export const TmcApiFetchParamCreator = {
    /** 
     * @param xIntegrationUserCredential 
     */
    apiV1TmcContactInformationGet(params: {  "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1TmcContactInformationGet");
        }
        const baseUrl = `/api/v1/tmc/contactInformation`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1TmcContactInformationPost(params: {  "xIntegrationUserCredential": string; "body"?: ContactInformationTMCRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1TmcContactInformationPost");
        }
        const baseUrl = `/api/v1/tmc/contactInformation`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1TmcContactInformationPut(params: {  "xIntegrationUserCredential": string; "body"?: ContactInformationTMCRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1TmcContactInformationPut");
        }
        const baseUrl = `/api/v1/tmc/contactInformation`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "PUT" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Get course details for specified courseId
     * @param xIntegrationUserCredential 
     * @param courseId 
     */
    apiV1TmcCourseDetailsGet(params: {  "xIntegrationUserCredential": string; "courseId"?: number; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1TmcCourseDetailsGet");
        }
        const baseUrl = `/api/v1/tmc/courseDetails`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "courseId": params["courseId"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Get the courses with enrollment counts for the user fleet. Sorting and filtering optional
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1TmcCoursesEnrollmentsPost(params: {  "xIntegrationUserCredential": string; "body"?: CourseRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1TmcCoursesEnrollmentsPost");
        }
        const baseUrl = `/api/v1/tmc/courses/enrollments`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Get the recommended courses for the given event type Ids, and the given learner&#39;s current enrollments for those courses
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1TmcCoursesEventtypePost(params: {  "xIntegrationUserCredential": string; "body"?: CourseEventTypeRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1TmcCoursesEventtypePost");
        }
        const baseUrl = `/api/v1/tmc/courses/eventtype`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Get all the courses for the user fleet
     * @param xIntegrationUserCredential 
     */
    apiV1TmcCoursesGet(params: {  "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1TmcCoursesGet");
        }
        const baseUrl = `/api/v1/tmc/courses`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Create enrollments for drivers with the given courseIds in the user fleet,  Use for new enrollments or reenroll
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1TmcEnrollmentsPost(params: {  "xIntegrationUserCredential": string; "body"?: EnrollmentLearnersTMCRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1TmcEnrollmentsPost");
        }
        const baseUrl = `/api/v1/tmc/enrollments`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Update enrollments for the fleet
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1TmcEnrollmentsPut(params: {  "xIntegrationUserCredential": string; "body"?: Array<UpdateEnrollmentTMCRequest>; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1TmcEnrollmentsPut");
        }
        const baseUrl = `/api/v1/tmc/enrollments`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "PUT" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Reminder Notifications for a list of enrollment ids in the user fleet
     * @param xIntegrationUserCredential 
     * @param body List of enrollment Ids
     */
    apiV1TmcEnrollmentsReminderNotificationPost(params: {  "xIntegrationUserCredential": string; "body"?: ReminderNotificationTMCRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1TmcEnrollmentsReminderNotificationPost");
        }
        const baseUrl = `/api/v1/tmc/enrollments/reminderNotification`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Unenroll a list of enrollments by ids
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1TmcEnrollmentsUnenrollPut(params: {  "xIntegrationUserCredential": string; "body"?: UnenrollEnrollmentsRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1TmcEnrollmentsUnenrollPut");
        }
        const baseUrl = `/api/v1/tmc/enrollments/unenroll`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "PUT" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Get the learners with enrollments for fleet
     * @param xIntegrationUserCredential 
     */
    apiV1TmcLearnersGet(params: {  "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1TmcLearnersGet");
        }
        const baseUrl = `/api/v1/tmc/learners`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};

/**
 * TmcApi - functional programming interface
 */
export const TmcApiFp = {
    /** 
     * @param xIntegrationUserCredential 
     */
    apiV1TmcContactInformationGet(params: { "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ContactInformationTMCResponse> {
        const fetchArgs = TmcApiFetchParamCreator.apiV1TmcContactInformationGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1TmcContactInformationPost(params: { "xIntegrationUserCredential": string; "body"?: ContactInformationTMCRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = TmcApiFetchParamCreator.apiV1TmcContactInformationPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1TmcContactInformationPut(params: { "xIntegrationUserCredential": string; "body"?: ContactInformationTMCRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = TmcApiFetchParamCreator.apiV1TmcContactInformationPut(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Get course details for specified courseId
     * @param xIntegrationUserCredential 
     * @param courseId 
     */
    apiV1TmcCourseDetailsGet(params: { "xIntegrationUserCredential": string; "courseId"?: number;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CourseDetailsResponse> {
        const fetchArgs = TmcApiFetchParamCreator.apiV1TmcCourseDetailsGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Get the courses with enrollment counts for the user fleet. Sorting and filtering optional
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1TmcCoursesEnrollmentsPost(params: { "xIntegrationUserCredential": string; "body"?: CourseRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<CourseEnrollmentTMCResponse>> {
        const fetchArgs = TmcApiFetchParamCreator.apiV1TmcCoursesEnrollmentsPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Get the recommended courses for the given event type Ids, and the given learner&#39;s current enrollments for those courses
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1TmcCoursesEventtypePost(params: { "xIntegrationUserCredential": string; "body"?: CourseEventTypeRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<CourseEnrollmentResponse>> {
        const fetchArgs = TmcApiFetchParamCreator.apiV1TmcCoursesEventtypePost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Get all the courses for the user fleet
     * @param xIntegrationUserCredential 
     */
    apiV1TmcCoursesGet(params: { "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<CourseResponse>> {
        const fetchArgs = TmcApiFetchParamCreator.apiV1TmcCoursesGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Create enrollments for drivers with the given courseIds in the user fleet,  Use for new enrollments or reenroll
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1TmcEnrollmentsPost(params: { "xIntegrationUserCredential": string; "body"?: EnrollmentLearnersTMCRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = TmcApiFetchParamCreator.apiV1TmcEnrollmentsPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Update enrollments for the fleet
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1TmcEnrollmentsPut(params: { "xIntegrationUserCredential": string; "body"?: Array<UpdateEnrollmentTMCRequest>;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = TmcApiFetchParamCreator.apiV1TmcEnrollmentsPut(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Reminder Notifications for a list of enrollment ids in the user fleet
     * @param xIntegrationUserCredential 
     * @param body List of enrollment Ids
     */
    apiV1TmcEnrollmentsReminderNotificationPost(params: { "xIntegrationUserCredential": string; "body"?: ReminderNotificationTMCRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = TmcApiFetchParamCreator.apiV1TmcEnrollmentsReminderNotificationPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Unenroll a list of enrollments by ids
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1TmcEnrollmentsUnenrollPut(params: { "xIntegrationUserCredential": string; "body"?: UnenrollEnrollmentsRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UnenrollEnrollmentsResponse> {
        const fetchArgs = TmcApiFetchParamCreator.apiV1TmcEnrollmentsUnenrollPut(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Get the learners with enrollments for fleet
     * @param xIntegrationUserCredential 
     */
    apiV1TmcLearnersGet(params: { "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<LearnerEnrollmentsTMCResponse>> {
        const fetchArgs = TmcApiFetchParamCreator.apiV1TmcLearnersGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
};

/**
 * TmcApi - object-oriented interface
 */
export class TmcApi extends BaseAPI {
    /** 
     * @param xIntegrationUserCredential 
     */
    apiV1TmcContactInformationGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
        return TmcApiFp.apiV1TmcContactInformationGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1TmcContactInformationPost(params: {  "xIntegrationUserCredential": string; "body"?: ContactInformationTMCRequest; }, options?: any) {
        return TmcApiFp.apiV1TmcContactInformationPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1TmcContactInformationPut(params: {  "xIntegrationUserCredential": string; "body"?: ContactInformationTMCRequest; }, options?: any) {
        return TmcApiFp.apiV1TmcContactInformationPut(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Get course details for specified courseId
     * @param xIntegrationUserCredential 
     * @param courseId 
     */
    apiV1TmcCourseDetailsGet(params: {  "xIntegrationUserCredential": string; "courseId"?: number; }, options?: any) {
        return TmcApiFp.apiV1TmcCourseDetailsGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Get the courses with enrollment counts for the user fleet. Sorting and filtering optional
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1TmcCoursesEnrollmentsPost(params: {  "xIntegrationUserCredential": string; "body"?: CourseRequest; }, options?: any) {
        return TmcApiFp.apiV1TmcCoursesEnrollmentsPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Get the recommended courses for the given event type Ids, and the given learner&#39;s current enrollments for those courses
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1TmcCoursesEventtypePost(params: {  "xIntegrationUserCredential": string; "body"?: CourseEventTypeRequest; }, options?: any) {
        return TmcApiFp.apiV1TmcCoursesEventtypePost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Get all the courses for the user fleet
     * @param xIntegrationUserCredential 
     */
    apiV1TmcCoursesGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
        return TmcApiFp.apiV1TmcCoursesGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Create enrollments for drivers with the given courseIds in the user fleet,  Use for new enrollments or reenroll
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1TmcEnrollmentsPost(params: {  "xIntegrationUserCredential": string; "body"?: EnrollmentLearnersTMCRequest; }, options?: any) {
        return TmcApiFp.apiV1TmcEnrollmentsPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Update enrollments for the fleet
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1TmcEnrollmentsPut(params: {  "xIntegrationUserCredential": string; "body"?: Array<UpdateEnrollmentTMCRequest>; }, options?: any) {
        return TmcApiFp.apiV1TmcEnrollmentsPut(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Reminder Notifications for a list of enrollment ids in the user fleet
     * @param xIntegrationUserCredential 
     * @param body List of enrollment Ids
     */
    apiV1TmcEnrollmentsReminderNotificationPost(params: {  "xIntegrationUserCredential": string; "body"?: ReminderNotificationTMCRequest; }, options?: any) {
        return TmcApiFp.apiV1TmcEnrollmentsReminderNotificationPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Unenroll a list of enrollments by ids
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1TmcEnrollmentsUnenrollPut(params: {  "xIntegrationUserCredential": string; "body"?: UnenrollEnrollmentsRequest; }, options?: any) {
        return TmcApiFp.apiV1TmcEnrollmentsUnenrollPut(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Get the learners with enrollments for fleet
     * @param xIntegrationUserCredential 
     */
    apiV1TmcLearnersGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
        return TmcApiFp.apiV1TmcLearnersGet(params, options)(this.fetch, this.basePath);
    }
};

/**
 * TmcApi - factory interface
 */
export const TmcApiFactory = function (fetch?: FetchAPI, basePath?: string) {
    return {
        /** 
         * @param xIntegrationUserCredential 
         */
        apiV1TmcContactInformationGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
            return TmcApiFp.apiV1TmcContactInformationGet(params, options)(fetch, basePath);
        },
        /** 
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1TmcContactInformationPost(params: {  "xIntegrationUserCredential": string; "body"?: ContactInformationTMCRequest; }, options?: any) {
            return TmcApiFp.apiV1TmcContactInformationPost(params, options)(fetch, basePath);
        },
        /** 
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1TmcContactInformationPut(params: {  "xIntegrationUserCredential": string; "body"?: ContactInformationTMCRequest; }, options?: any) {
            return TmcApiFp.apiV1TmcContactInformationPut(params, options)(fetch, basePath);
        },
        /** 
         * Get course details for specified courseId
         * @param xIntegrationUserCredential 
         * @param courseId 
         */
        apiV1TmcCourseDetailsGet(params: {  "xIntegrationUserCredential": string; "courseId"?: number; }, options?: any) {
            return TmcApiFp.apiV1TmcCourseDetailsGet(params, options)(fetch, basePath);
        },
        /** 
         * Get the courses with enrollment counts for the user fleet. Sorting and filtering optional
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1TmcCoursesEnrollmentsPost(params: {  "xIntegrationUserCredential": string; "body"?: CourseRequest; }, options?: any) {
            return TmcApiFp.apiV1TmcCoursesEnrollmentsPost(params, options)(fetch, basePath);
        },
        /** 
         * Get the recommended courses for the given event type Ids, and the given learner&#39;s current enrollments for those courses
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1TmcCoursesEventtypePost(params: {  "xIntegrationUserCredential": string; "body"?: CourseEventTypeRequest; }, options?: any) {
            return TmcApiFp.apiV1TmcCoursesEventtypePost(params, options)(fetch, basePath);
        },
        /** 
         * Get all the courses for the user fleet
         * @param xIntegrationUserCredential 
         */
        apiV1TmcCoursesGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
            return TmcApiFp.apiV1TmcCoursesGet(params, options)(fetch, basePath);
        },
        /** 
         * Create enrollments for drivers with the given courseIds in the user fleet,  Use for new enrollments or reenroll
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1TmcEnrollmentsPost(params: {  "xIntegrationUserCredential": string; "body"?: EnrollmentLearnersTMCRequest; }, options?: any) {
            return TmcApiFp.apiV1TmcEnrollmentsPost(params, options)(fetch, basePath);
        },
        /** 
         * Update enrollments for the fleet
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1TmcEnrollmentsPut(params: {  "xIntegrationUserCredential": string; "body"?: Array<UpdateEnrollmentTMCRequest>; }, options?: any) {
            return TmcApiFp.apiV1TmcEnrollmentsPut(params, options)(fetch, basePath);
        },
        /** 
         * Reminder Notifications for a list of enrollment ids in the user fleet
         * @param xIntegrationUserCredential 
         * @param body List of enrollment Ids
         */
        apiV1TmcEnrollmentsReminderNotificationPost(params: {  "xIntegrationUserCredential": string; "body"?: ReminderNotificationTMCRequest; }, options?: any) {
            return TmcApiFp.apiV1TmcEnrollmentsReminderNotificationPost(params, options)(fetch, basePath);
        },
        /** 
         * Unenroll a list of enrollments by ids
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1TmcEnrollmentsUnenrollPut(params: {  "xIntegrationUserCredential": string; "body"?: UnenrollEnrollmentsRequest; }, options?: any) {
            return TmcApiFp.apiV1TmcEnrollmentsUnenrollPut(params, options)(fetch, basePath);
        },
        /** 
         * Get the learners with enrollments for fleet
         * @param xIntegrationUserCredential 
         */
        apiV1TmcLearnersGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
            return TmcApiFp.apiV1TmcLearnersGet(params, options)(fetch, basePath);
        },
    };
};


/**
 * UserApi - fetch parameter creator
 */
export const UserApiFetchParamCreator = {
    /** 
     * @param xIntegrationUserCredential 
     */
    apiV1UsersCurrentGet(params: {  "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1UsersCurrentGet");
        }
        const baseUrl = `/api/v1/users/current`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Update the given aspNetUserId to IntegrationPartnerUserStatusEnum.Deleted
     * @param xIntegrationUserCredential 
     * @param aspNetUserId 
     */
    apiV1UsersDelete(params: {  "xIntegrationUserCredential": string; "aspNetUserId"?: string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1UsersDelete");
        }
        const baseUrl = `/api/v1/users`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "aspNetUserId": params["aspNetUserId"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "DELETE" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Get all User Names for the fleet id of the logged in user
     * @param xIntegrationUserCredential 
     */
    apiV1UsersFullNamesGet(params: {  "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1UsersFullNamesGet");
        }
        const baseUrl = `/api/v1/users/fullNames`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Get all Users for the fleet id of the logged in user
     * @param xIntegrationUserCredential 
     */
    apiV1UsersGet(params: {  "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1UsersGet");
        }
        const baseUrl = `/api/v1/users`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1UsersPost(params: {  "xIntegrationUserCredential": string; "body"?: CreateUserRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1UsersPost");
        }
        const baseUrl = `/api/v1/users`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Edits an existing user&#39;s details.
     * @param xIntegrationUserCredential 
     * @param body The request object containing the details of the user to be edited.
     */
    apiV1UsersPut(params: {  "xIntegrationUserCredential": string; "body"?: EditUserRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1UsersPut");
        }
        const baseUrl = `/api/v1/users`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "PUT" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param rosterPageEnum 
     */
    apiV1UsersRosterViewDelete(params: {  "xIntegrationUserCredential": string; "rosterPageEnum"?: number; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1UsersRosterViewDelete");
        }
        const baseUrl = `/api/v1/users/rosterView`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "rosterPageEnum": params["rosterPageEnum"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "DELETE" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param rosterPageEnum 
     */
    apiV1UsersRosterViewGet(params: {  "xIntegrationUserCredential": string; "rosterPageEnum"?: number; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1UsersRosterViewGet");
        }
        const baseUrl = `/api/v1/users/rosterView`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "rosterPageEnum": params["rosterPageEnum"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1UsersRosterViewPost(params: {  "xIntegrationUserCredential": string; "body"?: RosterViewRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1UsersRosterViewPost");
        }
        const baseUrl = `/api/v1/users/rosterView`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     */
    apiV1UsersSettingsCountriesGet(params: {  "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1UsersSettingsCountriesGet");
        }
        const baseUrl = `/api/v1/users/settings/countries`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Deactivates a given user
     * @param xIntegrationUserCredential 
     * @param aspNetUserId 
     */
    apiV1UsersSettingsDeactivatePut(params: {  "xIntegrationUserCredential": string; "aspNetUserId"?: string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1UsersSettingsDeactivatePut");
        }
        const baseUrl = `/api/v1/users/settings/deactivate`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "aspNetUserId": params["aspNetUserId"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "PUT" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Reactivates a given user
     * @param xIntegrationUserCredential 
     * @param aspNetUserId 
     */
    apiV1UsersSettingsReactivatePut(params: {  "xIntegrationUserCredential": string; "aspNetUserId"?: string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1UsersSettingsReactivatePut");
        }
        const baseUrl = `/api/v1/users/settings/reactivate`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "aspNetUserId": params["aspNetUserId"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "PUT" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     */
    apiV1UsersSettingsTimezonesGet(params: {  "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1UsersSettingsTimezonesGet");
        }
        const baseUrl = `/api/v1/users/settings/timezones`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Retrieves the details of a user by their ASP.NET User ID.
     * @param xIntegrationUserCredential 
     * @param aspNetUserId The ASP.NET User ID of the user whose details are to be fetched.
     */
    apiV1UsersUserDetailsGet(params: {  "xIntegrationUserCredential": string; "aspNetUserId"?: string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1UsersUserDetailsGet");
        }
        const baseUrl = `/api/v1/users/user/details`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "aspNetUserId": params["aspNetUserId"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Get all the fleets associated with a user&#39;s email address
     * @param xIntegrationUserCredential 
     * @param userEmail 
     */
    apiV1UsersUserFleetsGet(params: {  "xIntegrationUserCredential": string; "userEmail"?: string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1UsersUserFleetsGet");
        }
        const baseUrl = `/api/v1/users/user/fleets`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "userEmail": params["userEmail"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Ends the current Okta session server-side: blocklists the presented access token and records a  per-user logout timestamp so every token from this authentication (including rotated access  tokens and tokens re-minted from the refresh token) is rejected on subsequent requests.  Uses TelematicAuthorizationOnly so a user who has not yet signed agreements can still log out.
     * @param xIntegrationUserCredential 
     */
    apiV1UsersUserLogoutPost(params: {  "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1UsersUserLogoutPost");
        }
        const baseUrl = `/api/v1/users/user/logout`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Edits the current user&#39;s profile, which is a small subset of user details.
     * @param xIntegrationUserCredential 
     * @param body The request object containing the details of the user to be edited.
     */
    apiV1UsersUserProfilePut(params: {  "xIntegrationUserCredential": string; "body"?: EditUserProfileRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1UsersUserProfilePut");
        }
        const baseUrl = `/api/v1/users/user/profile`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "PUT" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Get all Users for the fleet id of the logged in user
     * @param xIntegrationUserCredential 
     */
    apiV1UsersUsersAllowedToFlagGet(params: {  "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1UsersUsersAllowedToFlagGet");
        }
        const baseUrl = `/api/v1/users/usersAllowedToFlag`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};

/**
 * UserApi - functional programming interface
 */
export const UserApiFp = {
    /** 
     * @param xIntegrationUserCredential 
     */
    apiV1UsersCurrentGet(params: { "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserInformationResponseResponseBase> {
        const fetchArgs = UserApiFetchParamCreator.apiV1UsersCurrentGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Update the given aspNetUserId to IntegrationPartnerUserStatusEnum.Deleted
     * @param xIntegrationUserCredential 
     * @param aspNetUserId 
     */
    apiV1UsersDelete(params: { "xIntegrationUserCredential": string; "aspNetUserId"?: string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = UserApiFetchParamCreator.apiV1UsersDelete(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Get all User Names for the fleet id of the logged in user
     * @param xIntegrationUserCredential 
     */
    apiV1UsersFullNamesGet(params: { "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserNameResponseIEnumerableResponseBase> {
        const fetchArgs = UserApiFetchParamCreator.apiV1UsersFullNamesGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Get all Users for the fleet id of the logged in user
     * @param xIntegrationUserCredential 
     */
    apiV1UsersGet(params: { "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UsersByFleetResponseIEnumerableResponseBase> {
        const fetchArgs = UserApiFetchParamCreator.apiV1UsersGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1UsersPost(params: { "xIntegrationUserCredential": string; "body"?: CreateUserRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MessageResponse> {
        const fetchArgs = UserApiFetchParamCreator.apiV1UsersPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Edits an existing user&#39;s details.
     * @param xIntegrationUserCredential 
     * @param body The request object containing the details of the user to be edited.
     */
    apiV1UsersPut(params: { "xIntegrationUserCredential": string; "body"?: EditUserRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = UserApiFetchParamCreator.apiV1UsersPut(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param rosterPageEnum 
     */
    apiV1UsersRosterViewDelete(params: { "xIntegrationUserCredential": string; "rosterPageEnum"?: number;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = UserApiFetchParamCreator.apiV1UsersRosterViewDelete(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param rosterPageEnum 
     */
    apiV1UsersRosterViewGet(params: { "xIntegrationUserCredential": string; "rosterPageEnum"?: number;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<RosterViewResponseResponseBase> {
        const fetchArgs = UserApiFetchParamCreator.apiV1UsersRosterViewGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1UsersRosterViewPost(params: { "xIntegrationUserCredential": string; "body"?: RosterViewRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = UserApiFetchParamCreator.apiV1UsersRosterViewPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     */
    apiV1UsersSettingsCountriesGet(params: { "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CountryResponseIEnumerableResponseBase> {
        const fetchArgs = UserApiFetchParamCreator.apiV1UsersSettingsCountriesGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Deactivates a given user
     * @param xIntegrationUserCredential 
     * @param aspNetUserId 
     */
    apiV1UsersSettingsDeactivatePut(params: { "xIntegrationUserCredential": string; "aspNetUserId"?: string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = UserApiFetchParamCreator.apiV1UsersSettingsDeactivatePut(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Reactivates a given user
     * @param xIntegrationUserCredential 
     * @param aspNetUserId 
     */
    apiV1UsersSettingsReactivatePut(params: { "xIntegrationUserCredential": string; "aspNetUserId"?: string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = UserApiFetchParamCreator.apiV1UsersSettingsReactivatePut(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     */
    apiV1UsersSettingsTimezonesGet(params: { "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TimezoneResponseIEnumerableResponseBase> {
        const fetchArgs = UserApiFetchParamCreator.apiV1UsersSettingsTimezonesGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Retrieves the details of a user by their ASP.NET User ID.
     * @param xIntegrationUserCredential 
     * @param aspNetUserId The ASP.NET User ID of the user whose details are to be fetched.
     */
    apiV1UsersUserDetailsGet(params: { "xIntegrationUserCredential": string; "aspNetUserId"?: string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<EditUserRequestResponseBase> {
        const fetchArgs = UserApiFetchParamCreator.apiV1UsersUserDetailsGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Get all the fleets associated with a user&#39;s email address
     * @param xIntegrationUserCredential 
     * @param userEmail 
     */
    apiV1UsersUserFleetsGet(params: { "xIntegrationUserCredential": string; "userEmail"?: string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<FleetResponse>> {
        const fetchArgs = UserApiFetchParamCreator.apiV1UsersUserFleetsGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Ends the current Okta session server-side: blocklists the presented access token and records a  per-user logout timestamp so every token from this authentication (including rotated access  tokens and tokens re-minted from the refresh token) is rejected on subsequent requests.  Uses TelematicAuthorizationOnly so a user who has not yet signed agreements can still log out.
     * @param xIntegrationUserCredential 
     */
    apiV1UsersUserLogoutPost(params: { "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = UserApiFetchParamCreator.apiV1UsersUserLogoutPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Edits the current user&#39;s profile, which is a small subset of user details.
     * @param xIntegrationUserCredential 
     * @param body The request object containing the details of the user to be edited.
     */
    apiV1UsersUserProfilePut(params: { "xIntegrationUserCredential": string; "body"?: EditUserProfileRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = UserApiFetchParamCreator.apiV1UsersUserProfilePut(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Get all Users for the fleet id of the logged in user
     * @param xIntegrationUserCredential 
     */
    apiV1UsersUsersAllowedToFlagGet(params: { "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserAllowedToFlagResponseIEnumerableResponseBase> {
        const fetchArgs = UserApiFetchParamCreator.apiV1UsersUsersAllowedToFlagGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
};

/**
 * UserApi - object-oriented interface
 */
export class UserApi extends BaseAPI {
    /** 
     * @param xIntegrationUserCredential 
     */
    apiV1UsersCurrentGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
        return UserApiFp.apiV1UsersCurrentGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Update the given aspNetUserId to IntegrationPartnerUserStatusEnum.Deleted
     * @param xIntegrationUserCredential 
     * @param aspNetUserId 
     */
    apiV1UsersDelete(params: {  "xIntegrationUserCredential": string; "aspNetUserId"?: string; }, options?: any) {
        return UserApiFp.apiV1UsersDelete(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Get all User Names for the fleet id of the logged in user
     * @param xIntegrationUserCredential 
     */
    apiV1UsersFullNamesGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
        return UserApiFp.apiV1UsersFullNamesGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Get all Users for the fleet id of the logged in user
     * @param xIntegrationUserCredential 
     */
    apiV1UsersGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
        return UserApiFp.apiV1UsersGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1UsersPost(params: {  "xIntegrationUserCredential": string; "body"?: CreateUserRequest; }, options?: any) {
        return UserApiFp.apiV1UsersPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Edits an existing user&#39;s details.
     * @param xIntegrationUserCredential 
     * @param body The request object containing the details of the user to be edited.
     */
    apiV1UsersPut(params: {  "xIntegrationUserCredential": string; "body"?: EditUserRequest; }, options?: any) {
        return UserApiFp.apiV1UsersPut(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param xIntegrationUserCredential 
     * @param rosterPageEnum 
     */
    apiV1UsersRosterViewDelete(params: {  "xIntegrationUserCredential": string; "rosterPageEnum"?: number; }, options?: any) {
        return UserApiFp.apiV1UsersRosterViewDelete(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param xIntegrationUserCredential 
     * @param rosterPageEnum 
     */
    apiV1UsersRosterViewGet(params: {  "xIntegrationUserCredential": string; "rosterPageEnum"?: number; }, options?: any) {
        return UserApiFp.apiV1UsersRosterViewGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1UsersRosterViewPost(params: {  "xIntegrationUserCredential": string; "body"?: RosterViewRequest; }, options?: any) {
        return UserApiFp.apiV1UsersRosterViewPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param xIntegrationUserCredential 
     */
    apiV1UsersSettingsCountriesGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
        return UserApiFp.apiV1UsersSettingsCountriesGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Deactivates a given user
     * @param xIntegrationUserCredential 
     * @param aspNetUserId 
     */
    apiV1UsersSettingsDeactivatePut(params: {  "xIntegrationUserCredential": string; "aspNetUserId"?: string; }, options?: any) {
        return UserApiFp.apiV1UsersSettingsDeactivatePut(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Reactivates a given user
     * @param xIntegrationUserCredential 
     * @param aspNetUserId 
     */
    apiV1UsersSettingsReactivatePut(params: {  "xIntegrationUserCredential": string; "aspNetUserId"?: string; }, options?: any) {
        return UserApiFp.apiV1UsersSettingsReactivatePut(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param xIntegrationUserCredential 
     */
    apiV1UsersSettingsTimezonesGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
        return UserApiFp.apiV1UsersSettingsTimezonesGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Retrieves the details of a user by their ASP.NET User ID.
     * @param xIntegrationUserCredential 
     * @param aspNetUserId The ASP.NET User ID of the user whose details are to be fetched.
     */
    apiV1UsersUserDetailsGet(params: {  "xIntegrationUserCredential": string; "aspNetUserId"?: string; }, options?: any) {
        return UserApiFp.apiV1UsersUserDetailsGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Get all the fleets associated with a user&#39;s email address
     * @param xIntegrationUserCredential 
     * @param userEmail 
     */
    apiV1UsersUserFleetsGet(params: {  "xIntegrationUserCredential": string; "userEmail"?: string; }, options?: any) {
        return UserApiFp.apiV1UsersUserFleetsGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Ends the current Okta session server-side: blocklists the presented access token and records a  per-user logout timestamp so every token from this authentication (including rotated access  tokens and tokens re-minted from the refresh token) is rejected on subsequent requests.  Uses TelematicAuthorizationOnly so a user who has not yet signed agreements can still log out.
     * @param xIntegrationUserCredential 
     */
    apiV1UsersUserLogoutPost(params: {  "xIntegrationUserCredential": string; }, options?: any) {
        return UserApiFp.apiV1UsersUserLogoutPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Edits the current user&#39;s profile, which is a small subset of user details.
     * @param xIntegrationUserCredential 
     * @param body The request object containing the details of the user to be edited.
     */
    apiV1UsersUserProfilePut(params: {  "xIntegrationUserCredential": string; "body"?: EditUserProfileRequest; }, options?: any) {
        return UserApiFp.apiV1UsersUserProfilePut(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Get all Users for the fleet id of the logged in user
     * @param xIntegrationUserCredential 
     */
    apiV1UsersUsersAllowedToFlagGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
        return UserApiFp.apiV1UsersUsersAllowedToFlagGet(params, options)(this.fetch, this.basePath);
    }
};

/**
 * UserApi - factory interface
 */
export const UserApiFactory = function (fetch?: FetchAPI, basePath?: string) {
    return {
        /** 
         * @param xIntegrationUserCredential 
         */
        apiV1UsersCurrentGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
            return UserApiFp.apiV1UsersCurrentGet(params, options)(fetch, basePath);
        },
        /** 
         * Update the given aspNetUserId to IntegrationPartnerUserStatusEnum.Deleted
         * @param xIntegrationUserCredential 
         * @param aspNetUserId 
         */
        apiV1UsersDelete(params: {  "xIntegrationUserCredential": string; "aspNetUserId"?: string; }, options?: any) {
            return UserApiFp.apiV1UsersDelete(params, options)(fetch, basePath);
        },
        /** 
         * Get all User Names for the fleet id of the logged in user
         * @param xIntegrationUserCredential 
         */
        apiV1UsersFullNamesGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
            return UserApiFp.apiV1UsersFullNamesGet(params, options)(fetch, basePath);
        },
        /** 
         * Get all Users for the fleet id of the logged in user
         * @param xIntegrationUserCredential 
         */
        apiV1UsersGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
            return UserApiFp.apiV1UsersGet(params, options)(fetch, basePath);
        },
        /** 
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1UsersPost(params: {  "xIntegrationUserCredential": string; "body"?: CreateUserRequest; }, options?: any) {
            return UserApiFp.apiV1UsersPost(params, options)(fetch, basePath);
        },
        /** 
         * Edits an existing user&#39;s details.
         * @param xIntegrationUserCredential 
         * @param body The request object containing the details of the user to be edited.
         */
        apiV1UsersPut(params: {  "xIntegrationUserCredential": string; "body"?: EditUserRequest; }, options?: any) {
            return UserApiFp.apiV1UsersPut(params, options)(fetch, basePath);
        },
        /** 
         * @param xIntegrationUserCredential 
         * @param rosterPageEnum 
         */
        apiV1UsersRosterViewDelete(params: {  "xIntegrationUserCredential": string; "rosterPageEnum"?: number; }, options?: any) {
            return UserApiFp.apiV1UsersRosterViewDelete(params, options)(fetch, basePath);
        },
        /** 
         * @param xIntegrationUserCredential 
         * @param rosterPageEnum 
         */
        apiV1UsersRosterViewGet(params: {  "xIntegrationUserCredential": string; "rosterPageEnum"?: number; }, options?: any) {
            return UserApiFp.apiV1UsersRosterViewGet(params, options)(fetch, basePath);
        },
        /** 
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1UsersRosterViewPost(params: {  "xIntegrationUserCredential": string; "body"?: RosterViewRequest; }, options?: any) {
            return UserApiFp.apiV1UsersRosterViewPost(params, options)(fetch, basePath);
        },
        /** 
         * @param xIntegrationUserCredential 
         */
        apiV1UsersSettingsCountriesGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
            return UserApiFp.apiV1UsersSettingsCountriesGet(params, options)(fetch, basePath);
        },
        /** 
         * Deactivates a given user
         * @param xIntegrationUserCredential 
         * @param aspNetUserId 
         */
        apiV1UsersSettingsDeactivatePut(params: {  "xIntegrationUserCredential": string; "aspNetUserId"?: string; }, options?: any) {
            return UserApiFp.apiV1UsersSettingsDeactivatePut(params, options)(fetch, basePath);
        },
        /** 
         * Reactivates a given user
         * @param xIntegrationUserCredential 
         * @param aspNetUserId 
         */
        apiV1UsersSettingsReactivatePut(params: {  "xIntegrationUserCredential": string; "aspNetUserId"?: string; }, options?: any) {
            return UserApiFp.apiV1UsersSettingsReactivatePut(params, options)(fetch, basePath);
        },
        /** 
         * @param xIntegrationUserCredential 
         */
        apiV1UsersSettingsTimezonesGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
            return UserApiFp.apiV1UsersSettingsTimezonesGet(params, options)(fetch, basePath);
        },
        /** 
         * Retrieves the details of a user by their ASP.NET User ID.
         * @param xIntegrationUserCredential 
         * @param aspNetUserId The ASP.NET User ID of the user whose details are to be fetched.
         */
        apiV1UsersUserDetailsGet(params: {  "xIntegrationUserCredential": string; "aspNetUserId"?: string; }, options?: any) {
            return UserApiFp.apiV1UsersUserDetailsGet(params, options)(fetch, basePath);
        },
        /** 
         * Get all the fleets associated with a user&#39;s email address
         * @param xIntegrationUserCredential 
         * @param userEmail 
         */
        apiV1UsersUserFleetsGet(params: {  "xIntegrationUserCredential": string; "userEmail"?: string; }, options?: any) {
            return UserApiFp.apiV1UsersUserFleetsGet(params, options)(fetch, basePath);
        },
        /** 
         * Ends the current Okta session server-side: blocklists the presented access token and records a  per-user logout timestamp so every token from this authentication (including rotated access  tokens and tokens re-minted from the refresh token) is rejected on subsequent requests.  Uses TelematicAuthorizationOnly so a user who has not yet signed agreements can still log out.
         * @param xIntegrationUserCredential 
         */
        apiV1UsersUserLogoutPost(params: {  "xIntegrationUserCredential": string; }, options?: any) {
            return UserApiFp.apiV1UsersUserLogoutPost(params, options)(fetch, basePath);
        },
        /** 
         * Edits the current user&#39;s profile, which is a small subset of user details.
         * @param xIntegrationUserCredential 
         * @param body The request object containing the details of the user to be edited.
         */
        apiV1UsersUserProfilePut(params: {  "xIntegrationUserCredential": string; "body"?: EditUserProfileRequest; }, options?: any) {
            return UserApiFp.apiV1UsersUserProfilePut(params, options)(fetch, basePath);
        },
        /** 
         * Get all Users for the fleet id of the logged in user
         * @param xIntegrationUserCredential 
         */
        apiV1UsersUsersAllowedToFlagGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
            return UserApiFp.apiV1UsersUsersAllowedToFlagGet(params, options)(fetch, basePath);
        },
    };
};


/**
 * UserRolesApi - fetch parameter creator
 */
export const UserRolesApiFetchParamCreator = {
    /** 
     * Get the User Roles of the current user
     * @param xIntegrationUserCredential 
     */
    apiV1UserRolesGet(params: {  "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1UserRolesGet");
        }
        const baseUrl = `/api/v1/userRoles`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Update the roles of the loged user
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1UserRolesPut(params: {  "xIntegrationUserCredential": string; "body"?: UserRolesUpdateRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1UserRolesPut");
        }
        const baseUrl = `/api/v1/userRoles`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "PUT" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Get all Users roles for the fleet id of the loged user
     * @param xIntegrationUserCredential 
     */
    apiV1UsersRolesByFleetGet(params: {  "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1UsersRolesByFleetGet");
        }
        const baseUrl = `/api/v1/usersRolesByFleet`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};

/**
 * UserRolesApi - functional programming interface
 */
export const UserRolesApiFp = {
    /** 
     * Get the User Roles of the current user
     * @param xIntegrationUserCredential 
     */
    apiV1UserRolesGet(params: { "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<number>> {
        const fetchArgs = UserRolesApiFetchParamCreator.apiV1UserRolesGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Update the roles of the loged user
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1UserRolesPut(params: { "xIntegrationUserCredential": string; "body"?: UserRolesUpdateRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<boolean> {
        const fetchArgs = UserRolesApiFetchParamCreator.apiV1UserRolesPut(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Get all Users roles for the fleet id of the loged user
     * @param xIntegrationUserCredential 
     */
    apiV1UsersRolesByFleetGet(params: { "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<UserRolesResponse>> {
        const fetchArgs = UserRolesApiFetchParamCreator.apiV1UsersRolesByFleetGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
};

/**
 * UserRolesApi - object-oriented interface
 */
export class UserRolesApi extends BaseAPI {
    /** 
     * Get the User Roles of the current user
     * @param xIntegrationUserCredential 
     */
    apiV1UserRolesGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
        return UserRolesApiFp.apiV1UserRolesGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Update the roles of the loged user
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1UserRolesPut(params: {  "xIntegrationUserCredential": string; "body"?: UserRolesUpdateRequest; }, options?: any) {
        return UserRolesApiFp.apiV1UserRolesPut(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Get all Users roles for the fleet id of the loged user
     * @param xIntegrationUserCredential 
     */
    apiV1UsersRolesByFleetGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
        return UserRolesApiFp.apiV1UsersRolesByFleetGet(params, options)(this.fetch, this.basePath);
    }
};

/**
 * UserRolesApi - factory interface
 */
export const UserRolesApiFactory = function (fetch?: FetchAPI, basePath?: string) {
    return {
        /** 
         * Get the User Roles of the current user
         * @param xIntegrationUserCredential 
         */
        apiV1UserRolesGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
            return UserRolesApiFp.apiV1UserRolesGet(params, options)(fetch, basePath);
        },
        /** 
         * Update the roles of the loged user
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1UserRolesPut(params: {  "xIntegrationUserCredential": string; "body"?: UserRolesUpdateRequest; }, options?: any) {
            return UserRolesApiFp.apiV1UserRolesPut(params, options)(fetch, basePath);
        },
        /** 
         * Get all Users roles for the fleet id of the loged user
         * @param xIntegrationUserCredential 
         */
        apiV1UsersRolesByFleetGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
            return UserRolesApiFp.apiV1UsersRolesByFleetGet(params, options)(fetch, basePath);
        },
    };
};


/**
 * VehicleApi - fetch parameter creator
 */
export const VehicleApiFetchParamCreator = {
    /** 
     * Insert a list of vehicles (bulk action for import vehicles feat)
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VehiclesBulkPost(params: {  "xIntegrationUserCredential": string; "body"?: Array<CreateVehicleRequest>; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1VehiclesBulkPost");
        }
        const baseUrl = `/api/v1/vehicles/bulk`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Delete a vehicle comment
     * @param id 
     * @param xIntegrationUserCredential 
     */
    apiV1VehiclesCommentIdDelete(params: {  "id": number; "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling apiV1VehiclesCommentIdDelete");
        }
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1VehiclesCommentIdDelete");
        }
        const baseUrl = `/api/v1/vehicles/comment/{id}`
            .replace(`{${"id"}}`, `${ params["id"] }`);
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "DELETE" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Update a vehicle comment
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VehiclesCommentPut(params: {  "xIntegrationUserCredential": string; "body"?: CommentRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1VehiclesCommentPut");
        }
        const baseUrl = `/api/v1/vehicles/comment`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "PUT" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Update vehicle(s) to IsDeleted &#x3D; true and end any associated driver/vehicle pairings
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VehiclesDeletePut(params: {  "xIntegrationUserCredential": string; "body"?: Array<number>; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1VehiclesDeletePut");
        }
        const baseUrl = `/api/v1/vehicles/delete`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "PUT" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Get vehicle details information
     * @param xIntegrationUserCredential 
     * @param vehicleId 
     */
    apiV1VehiclesDetailsGet(params: {  "xIntegrationUserCredential": string; "vehicleId"?: number; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1VehiclesDetailsGet");
        }
        const baseUrl = `/api/v1/vehicles/details`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "vehicleId": params["vehicleId"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Get all Vehicles with the fleetId of logged in user
     * @param xIntegrationUserCredential 
     * @param includeDeleted 
     */
    apiV1VehiclesGet(params: {  "xIntegrationUserCredential": string; "includeDeleted"?: boolean; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1VehiclesGet");
        }
        const baseUrl = `/api/v1/vehicles`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "includeDeleted": params["includeDeleted"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Create a new vehicle comment
     * @param id 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VehiclesIdCommentPost(params: {  "id": number; "xIntegrationUserCredential": string; "body"?: CommentRequest; }, options?: any): FetchArgs {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling apiV1VehiclesIdCommentPost");
        }
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1VehiclesIdCommentPost");
        }
        const baseUrl = `/api/v1/vehicles/{id}/comment`
            .replace(`{${"id"}}`, `${ params["id"] }`);
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Update existing vehicle info
     * @param id 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VehiclesIdPut(params: {  "id": number; "xIntegrationUserCredential": string; "body"?: CreateVehicleRequest; }, options?: any): FetchArgs {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling apiV1VehiclesIdPut");
        }
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1VehiclesIdPut");
        }
        const baseUrl = `/api/v1/vehicles/{id}`
            .replace(`{${"id"}}`, `${ params["id"] }`);
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "PUT" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Check if a telematic device is paired to a camera
     * @param xIntegrationUserCredential 
     * @param telematicDeviceId 
     */
    apiV1VehiclesIsTelematicDevicePairedGet(params: {  "xIntegrationUserCredential": string; "telematicDeviceId"?: string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1VehiclesIsTelematicDevicePairedGet");
        }
        const baseUrl = `/api/v1/vehicles/isTelematicDevicePaired`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "telematicDeviceId": params["telematicDeviceId"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Update location for a list of vehicles
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VehiclesLocationPut(params: {  "xIntegrationUserCredential": string; "body"?: VehiclesLocationRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1VehiclesLocationPut");
        }
        const baseUrl = `/api/v1/vehicles/location`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "PUT" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Creates a new vehicle in the fleet of the logged in user
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VehiclesPost(params: {  "xIntegrationUserCredential": string; "body"?: CreateVehicleRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1VehiclesPost");
        }
        const baseUrl = `/api/v1/vehicles`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Get all Vehicles with fleetId of logged in user that are not currently assigned a driver
     * @param xIntegrationUserCredential 
     */
    apiV1VehiclesUnpairedGet(params: {  "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1VehiclesUnpairedGet");
        }
        const baseUrl = `/api/v1/vehicles/unpaired`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};

/**
 * VehicleApi - functional programming interface
 */
export const VehicleApiFp = {
    /** 
     * Insert a list of vehicles (bulk action for import vehicles feat)
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VehiclesBulkPost(params: { "xIntegrationUserCredential": string; "body"?: Array<CreateVehicleRequest>;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MessageResponse> {
        const fetchArgs = VehicleApiFetchParamCreator.apiV1VehiclesBulkPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Delete a vehicle comment
     * @param id 
     * @param xIntegrationUserCredential 
     */
    apiV1VehiclesCommentIdDelete(params: { "id": number; "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CommentResponseResponseBase> {
        const fetchArgs = VehicleApiFetchParamCreator.apiV1VehiclesCommentIdDelete(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Update a vehicle comment
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VehiclesCommentPut(params: { "xIntegrationUserCredential": string; "body"?: CommentRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CommentResponseResponseBase> {
        const fetchArgs = VehicleApiFetchParamCreator.apiV1VehiclesCommentPut(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Update vehicle(s) to IsDeleted &#x3D; true and end any associated driver/vehicle pairings
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VehiclesDeletePut(params: { "xIntegrationUserCredential": string; "body"?: Array<number>;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<VehicleResponseIEnumerableResponseBase> {
        const fetchArgs = VehicleApiFetchParamCreator.apiV1VehiclesDeletePut(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Get vehicle details information
     * @param xIntegrationUserCredential 
     * @param vehicleId 
     */
    apiV1VehiclesDetailsGet(params: { "xIntegrationUserCredential": string; "vehicleId"?: number;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<VehicleDetailsResponseResponseBase> {
        const fetchArgs = VehicleApiFetchParamCreator.apiV1VehiclesDetailsGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Get all Vehicles with the fleetId of logged in user
     * @param xIntegrationUserCredential 
     * @param includeDeleted 
     */
    apiV1VehiclesGet(params: { "xIntegrationUserCredential": string; "includeDeleted"?: boolean;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<VehicleResponseIEnumerableResponseBase> {
        const fetchArgs = VehicleApiFetchParamCreator.apiV1VehiclesGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Create a new vehicle comment
     * @param id 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VehiclesIdCommentPost(params: { "id": number; "xIntegrationUserCredential": string; "body"?: CommentRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CommentResponseResponseBase> {
        const fetchArgs = VehicleApiFetchParamCreator.apiV1VehiclesIdCommentPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Update existing vehicle info
     * @param id 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VehiclesIdPut(params: { "id": number; "xIntegrationUserCredential": string; "body"?: CreateVehicleRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MessageResponse> {
        const fetchArgs = VehicleApiFetchParamCreator.apiV1VehiclesIdPut(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Check if a telematic device is paired to a camera
     * @param xIntegrationUserCredential 
     * @param telematicDeviceId 
     */
    apiV1VehiclesIsTelematicDevicePairedGet(params: { "xIntegrationUserCredential": string; "telematicDeviceId"?: string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<boolean> {
        const fetchArgs = VehicleApiFetchParamCreator.apiV1VehiclesIsTelematicDevicePairedGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Update location for a list of vehicles
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VehiclesLocationPut(params: { "xIntegrationUserCredential": string; "body"?: VehiclesLocationRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MessageResponse> {
        const fetchArgs = VehicleApiFetchParamCreator.apiV1VehiclesLocationPut(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Creates a new vehicle in the fleet of the logged in user
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VehiclesPost(params: { "xIntegrationUserCredential": string; "body"?: CreateVehicleRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<VehicleResponse> {
        const fetchArgs = VehicleApiFetchParamCreator.apiV1VehiclesPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Get all Vehicles with fleetId of logged in user that are not currently assigned a driver
     * @param xIntegrationUserCredential 
     */
    apiV1VehiclesUnpairedGet(params: { "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<VehicleResponseIEnumerableResponseBase> {
        const fetchArgs = VehicleApiFetchParamCreator.apiV1VehiclesUnpairedGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
};

/**
 * VehicleApi - object-oriented interface
 */
export class VehicleApi extends BaseAPI {
    /** 
     * Insert a list of vehicles (bulk action for import vehicles feat)
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VehiclesBulkPost(params: {  "xIntegrationUserCredential": string; "body"?: Array<CreateVehicleRequest>; }, options?: any) {
        return VehicleApiFp.apiV1VehiclesBulkPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Delete a vehicle comment
     * @param id 
     * @param xIntegrationUserCredential 
     */
    apiV1VehiclesCommentIdDelete(params: {  "id": number; "xIntegrationUserCredential": string; }, options?: any) {
        return VehicleApiFp.apiV1VehiclesCommentIdDelete(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Update a vehicle comment
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VehiclesCommentPut(params: {  "xIntegrationUserCredential": string; "body"?: CommentRequest; }, options?: any) {
        return VehicleApiFp.apiV1VehiclesCommentPut(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Update vehicle(s) to IsDeleted &#x3D; true and end any associated driver/vehicle pairings
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VehiclesDeletePut(params: {  "xIntegrationUserCredential": string; "body"?: Array<number>; }, options?: any) {
        return VehicleApiFp.apiV1VehiclesDeletePut(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Get vehicle details information
     * @param xIntegrationUserCredential 
     * @param vehicleId 
     */
    apiV1VehiclesDetailsGet(params: {  "xIntegrationUserCredential": string; "vehicleId"?: number; }, options?: any) {
        return VehicleApiFp.apiV1VehiclesDetailsGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Get all Vehicles with the fleetId of logged in user
     * @param xIntegrationUserCredential 
     * @param includeDeleted 
     */
    apiV1VehiclesGet(params: {  "xIntegrationUserCredential": string; "includeDeleted"?: boolean; }, options?: any) {
        return VehicleApiFp.apiV1VehiclesGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Create a new vehicle comment
     * @param id 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VehiclesIdCommentPost(params: {  "id": number; "xIntegrationUserCredential": string; "body"?: CommentRequest; }, options?: any) {
        return VehicleApiFp.apiV1VehiclesIdCommentPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Update existing vehicle info
     * @param id 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VehiclesIdPut(params: {  "id": number; "xIntegrationUserCredential": string; "body"?: CreateVehicleRequest; }, options?: any) {
        return VehicleApiFp.apiV1VehiclesIdPut(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Check if a telematic device is paired to a camera
     * @param xIntegrationUserCredential 
     * @param telematicDeviceId 
     */
    apiV1VehiclesIsTelematicDevicePairedGet(params: {  "xIntegrationUserCredential": string; "telematicDeviceId"?: string; }, options?: any) {
        return VehicleApiFp.apiV1VehiclesIsTelematicDevicePairedGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Update location for a list of vehicles
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VehiclesLocationPut(params: {  "xIntegrationUserCredential": string; "body"?: VehiclesLocationRequest; }, options?: any) {
        return VehicleApiFp.apiV1VehiclesLocationPut(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Creates a new vehicle in the fleet of the logged in user
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VehiclesPost(params: {  "xIntegrationUserCredential": string; "body"?: CreateVehicleRequest; }, options?: any) {
        return VehicleApiFp.apiV1VehiclesPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Get all Vehicles with fleetId of logged in user that are not currently assigned a driver
     * @param xIntegrationUserCredential 
     */
    apiV1VehiclesUnpairedGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
        return VehicleApiFp.apiV1VehiclesUnpairedGet(params, options)(this.fetch, this.basePath);
    }
};

/**
 * VehicleApi - factory interface
 */
export const VehicleApiFactory = function (fetch?: FetchAPI, basePath?: string) {
    return {
        /** 
         * Insert a list of vehicles (bulk action for import vehicles feat)
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1VehiclesBulkPost(params: {  "xIntegrationUserCredential": string; "body"?: Array<CreateVehicleRequest>; }, options?: any) {
            return VehicleApiFp.apiV1VehiclesBulkPost(params, options)(fetch, basePath);
        },
        /** 
         * Delete a vehicle comment
         * @param id 
         * @param xIntegrationUserCredential 
         */
        apiV1VehiclesCommentIdDelete(params: {  "id": number; "xIntegrationUserCredential": string; }, options?: any) {
            return VehicleApiFp.apiV1VehiclesCommentIdDelete(params, options)(fetch, basePath);
        },
        /** 
         * Update a vehicle comment
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1VehiclesCommentPut(params: {  "xIntegrationUserCredential": string; "body"?: CommentRequest; }, options?: any) {
            return VehicleApiFp.apiV1VehiclesCommentPut(params, options)(fetch, basePath);
        },
        /** 
         * Update vehicle(s) to IsDeleted &#x3D; true and end any associated driver/vehicle pairings
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1VehiclesDeletePut(params: {  "xIntegrationUserCredential": string; "body"?: Array<number>; }, options?: any) {
            return VehicleApiFp.apiV1VehiclesDeletePut(params, options)(fetch, basePath);
        },
        /** 
         * Get vehicle details information
         * @param xIntegrationUserCredential 
         * @param vehicleId 
         */
        apiV1VehiclesDetailsGet(params: {  "xIntegrationUserCredential": string; "vehicleId"?: number; }, options?: any) {
            return VehicleApiFp.apiV1VehiclesDetailsGet(params, options)(fetch, basePath);
        },
        /** 
         * Get all Vehicles with the fleetId of logged in user
         * @param xIntegrationUserCredential 
         * @param includeDeleted 
         */
        apiV1VehiclesGet(params: {  "xIntegrationUserCredential": string; "includeDeleted"?: boolean; }, options?: any) {
            return VehicleApiFp.apiV1VehiclesGet(params, options)(fetch, basePath);
        },
        /** 
         * Create a new vehicle comment
         * @param id 
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1VehiclesIdCommentPost(params: {  "id": number; "xIntegrationUserCredential": string; "body"?: CommentRequest; }, options?: any) {
            return VehicleApiFp.apiV1VehiclesIdCommentPost(params, options)(fetch, basePath);
        },
        /** 
         * Update existing vehicle info
         * @param id 
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1VehiclesIdPut(params: {  "id": number; "xIntegrationUserCredential": string; "body"?: CreateVehicleRequest; }, options?: any) {
            return VehicleApiFp.apiV1VehiclesIdPut(params, options)(fetch, basePath);
        },
        /** 
         * Check if a telematic device is paired to a camera
         * @param xIntegrationUserCredential 
         * @param telematicDeviceId 
         */
        apiV1VehiclesIsTelematicDevicePairedGet(params: {  "xIntegrationUserCredential": string; "telematicDeviceId"?: string; }, options?: any) {
            return VehicleApiFp.apiV1VehiclesIsTelematicDevicePairedGet(params, options)(fetch, basePath);
        },
        /** 
         * Update location for a list of vehicles
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1VehiclesLocationPut(params: {  "xIntegrationUserCredential": string; "body"?: VehiclesLocationRequest; }, options?: any) {
            return VehicleApiFp.apiV1VehiclesLocationPut(params, options)(fetch, basePath);
        },
        /** 
         * Creates a new vehicle in the fleet of the logged in user
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1VehiclesPost(params: {  "xIntegrationUserCredential": string; "body"?: CreateVehicleRequest; }, options?: any) {
            return VehicleApiFp.apiV1VehiclesPost(params, options)(fetch, basePath);
        },
        /** 
         * Get all Vehicles with fleetId of logged in user that are not currently assigned a driver
         * @param xIntegrationUserCredential 
         */
        apiV1VehiclesUnpairedGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
            return VehicleApiFp.apiV1VehiclesUnpairedGet(params, options)(fetch, basePath);
        },
    };
};


/**
 * VideoEventApi - fetch parameter creator
 */
export const VideoEventApiFetchParamCreator = {
    /** 
     * @param xIntegrationUserCredential 
     * @param eventId 
     * @param videoEventHistoryAction 
     * @param actionDescription 
     * @param driverId 
     */
    apiV1AddvideoeventactionrecordPost(params: {  "xIntegrationUserCredential": string; "eventId"?: number; "videoEventHistoryAction"?: string; "actionDescription"?: string; "driverId"?: number; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1AddvideoeventactionrecordPost");
        }
        const baseUrl = `/api/v1/addvideoeventactionrecord`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "eventId": params["eventId"],
            "videoEventHistoryAction": params["videoEventHistoryAction"],
            "actionDescription": params["actionDescription"],
            "driverId": params["driverId"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1AssignDriverToEventsPost(params: {  "xIntegrationUserCredential": string; "body"?: AssignDriverToEventsRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1AssignDriverToEventsPost");
        }
        const baseUrl = `/api/v1/assignDriverToEvents`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * This endpoint dismisses multiple events more efficiently. This takes a list of all the video events to be dismissed. It also will update monthly driver score.
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1BulkDismissRangePost(params: {  "xIntegrationUserCredential": string; "body"?: BulkRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1BulkDismissRangePost");
        }
        const baseUrl = `/api/v1/BulkDismissRange`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1BulkPromoteVideoRecallsPost(params: {  "xIntegrationUserCredential": string; "body"?: Array<number>; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1BulkPromoteVideoRecallsPost");
        }
        const baseUrl = `/api/v1/BulkPromoteVideoRecalls`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     *   This endpoint allows a user to apply the same rating (\&quot;Score\&quot;) to multiple Video Events, Unique endopint for Standalone and Core.
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1BulkScoreVideoEventsPost(params: {  "xIntegrationUserCredential": string; "body"?: BulkRatingRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1BulkScoreVideoEventsPost");
        }
        const baseUrl = `/api/v1/BulkScoreVideoEvents`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param eventId 
     * @param actionTaken 
     */
    apiV1CompletevideoPost(params: {  "xIntegrationUserCredential": string; "eventId"?: number; "actionTaken"?: string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1CompletevideoPost");
        }
        const baseUrl = `/api/v1/completevideo`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "eventId": params["eventId"],
            "actionTaken": params["actionTaken"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     *   Gets all the id/value parings for the Video Event Ratings control.
     * @param xIntegrationUserCredential 
     */
    apiV1ControlsVideoEventRatingsGet(params: {  "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1ControlsVideoEventRatingsGet");
        }
        const baseUrl = `/api/v1/Controls/VideoEventRatings`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * delete a list of video recalls by eventId. Created for Stand alone
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1DeletevideorecallsPut(params: {  "xIntegrationUserCredential": string; "body"?: Array<number>; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1DeletevideorecallsPut");
        }
        const baseUrl = `/api/v1/deletevideorecalls`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "PUT" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     *   This endpoint dismisses multiple events.  This takes a list of all the video events to be dismissed.
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1DismissMultipleVideoEventPost(params: {  "xIntegrationUserCredential": string; "body"?: BulkRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1DismissMultipleVideoEventPost");
        }
        const baseUrl = `/api/v1/DismissMultipleVideoEvent`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     *   This endpoint dismisses a single event.
     * The muliple dismiss functionality is based off of this.
     * @param xIntegrationUserCredential 
     * @param eventId 
     * @param actionTaken 
     */
    apiV1DismissVideoPost(params: {  "xIntegrationUserCredential": string; "eventId"?: number; "actionTaken"?: string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1DismissVideoPost");
        }
        const baseUrl = `/api/v1/dismissVideo`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "EventId": params["eventId"],
            "ActionTaken": params["actionTaken"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param eventId 
     * @param videoType 
     */
    apiV1DownloadvideoPost(params: {  "xIntegrationUserCredential": string; "eventId"?: number; "videoType"?: string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1DownloadvideoPost");
        }
        const baseUrl = `/api/v1/downloadvideo`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "eventId": params["eventId"],
            "videoType": params["videoType"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param eventId 
     */
    apiV1FlagvideoPost(params: {  "xIntegrationUserCredential": string; "eventId"?: number; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1FlagvideoPost");
        }
        const baseUrl = `/api/v1/flagvideo`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "eventId": params["eventId"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1GetFullVideoEventIdListPost(params: {  "xIntegrationUserCredential": string; "body"?: VideoEventFilterMultiselectRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1GetFullVideoEventIdListPost");
        }
        const baseUrl = `/api/v1/GetFullVideoEventIdList`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Gets all video event Ids for a given filter without mapping to a VideoEventResponse
     * @param xIntegrationUserCredential 
     * @param body VideoPlatform.DataService.Postgres.Models.Requests.VideoEventFilterMultiselectRequest - The filter object
     */
    apiV1GetVideoEventIdsPost(params: {  "xIntegrationUserCredential": string; "body"?: StandaloneVideoEventFilterMultiselectRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1GetVideoEventIdsPost");
        }
        const baseUrl = `/api/v1/GetVideoEventIds`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param eventId 
     */
    apiV1GetvideoeventhistoryGet(params: {  "xIntegrationUserCredential": string; "eventId"?: number; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1GetvideoeventhistoryGet");
        }
        const baseUrl = `/api/v1/getvideoeventhistory`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "eventId": params["eventId"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param eventId 
     */
    apiV1PromotevideorecallPost(params: {  "xIntegrationUserCredential": string; "eventId"?: number; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1PromotevideorecallPost");
        }
        const baseUrl = `/api/v1/promotevideorecall`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "eventId": params["eventId"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Request a new recalled video
     * @param xIntegrationUserCredential 
     * @param integrationPartnerVehicleId Vehicle to fetch video from
     * @param startDate Start of recording
     * @param endDate End of Recording
     */
    apiV1RecallvideoPost(params: {  "xIntegrationUserCredential": string; "integrationPartnerVehicleId"?: string; "startDate"?: string; "endDate"?: string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1RecallvideoPost");
        }
        const baseUrl = `/api/v1/recallvideo`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "integrationPartnerVehicleId": params["integrationPartnerVehicleId"],
            "startDate": params["startDate"],
            "endDate": params["endDate"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param eventId 
     */
    apiV1RemovedriverPost(params: {  "xIntegrationUserCredential": string; "eventId"?: number; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1RemovedriverPost");
        }
        const baseUrl = `/api/v1/removedriver`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "eventId": params["eventId"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param eventId 
     */
    apiV1ReopeneventPost(params: {  "xIntegrationUserCredential": string; "eventId"?: number; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1ReopeneventPost");
        }
        const baseUrl = `/api/v1/reopenevent`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "eventId": params["eventId"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Completely unflag a video event (removes all flags unlike the flagvideo endpoint)
     * @param xIntegrationUserCredential 
     * @param eventId 
     */
    apiV1UnflagvideoPost(params: {  "xIntegrationUserCredential": string; "eventId"?: number; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1UnflagvideoPost");
        }
        const baseUrl = `/api/v1/unflagvideo`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "eventId": params["eventId"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Update the assigned driver for a list of video events
     * @param xIntegrationUserCredential 
     * @param driverId Id of Driver that should be assigned
     * @param body List of VideoEvents to update
     */
    apiV1UpdateAssignedDriverForListOfVideoEventsPost(params: {  "xIntegrationUserCredential": string; "driverId"?: number; "body"?: Array<number>; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1UpdateAssignedDriverForListOfVideoEventsPost");
        }
        const baseUrl = `/api/v1/updateAssignedDriverForListOfVideoEvents`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "driverId": params["driverId"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param eventId 
     * @param body 
     */
    apiV1UpdatedriverPost(params: {  "xIntegrationUserCredential": string; "eventId"?: number; "body"?: VideoEventDriverRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1UpdatedriverPost");
        }
        const baseUrl = `/api/v1/updatedriver`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "eventId": params["eventId"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param eventId 
     * @param status 
     */
    apiV1UpdatevideoeventPost(params: {  "xIntegrationUserCredential": string; "eventId"?: number; "status"?: string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1UpdatevideoeventPost");
        }
        const baseUrl = `/api/v1/updatevideoevent`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "eventId": params["eventId"],
            "status": params["status"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     *   The M:Website.Core.Controllers.VideoEventController.DeleteVideoEvent(VideoPlatform.DataService.Website.Models.Requests.BulkRequest) endpoint flags video events as \&quot;soft deleted\&quot;.  This means that                         the data is still there, but flagged in such a manner that it will not be displayed in any data                        set.  It will later, after a determined length of time, be \&quot;hard delted\&quot; and will not be                        recoverable.
     *   This works on one or more video event delete request.    If no video event ids are passed in, it will return a bad request stating it requires at least one                        video event ID.    If video event IDs are passed in, but none of them get updated (video Event doesn&#39;t exist for example)                        it returns a bad request as well saying no matching video events were found.    If multiple video event IDs are passed in and one or more of those are not found, but at least one is,                        it returns OK.    If all Video events are found, it returns OK.    When it returns OK, it will return with a JSON object that contains all the Video Events found for that list.                        Any video event ID that was invalid is not included.  Therefore, you can compare request list with response                        list and tell if it was a partial success, and if diffing, you can tell which ones.
     * @param xIntegrationUserCredential 
     * @param body An array of integers representing the video event ids that need to be deleted.
     */
    apiV1VideoEventDeleteDelete(params: {  "xIntegrationUserCredential": string; "body"?: BulkRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1VideoEventDeleteDelete");
        }
        const baseUrl = `/api/v1/video-event/delete`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "DELETE" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Returns whether AI overlay video is available for all assets of a video event.  Intended to be polled by the client after calling requestAiOverlay.
     * @param id VideoEvent display ID
     * @param xIntegrationUserCredential 
     */
    apiV1VideoEventIdAiVideoAvailableGet(params: {  "id": string; "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling apiV1VideoEventIdAiVideoAvailableGet");
        }
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1VideoEventIdAiVideoAvailableGet");
        }
        const baseUrl = `/api/v1/videoEvent/{id}/aiVideoAvailable`
            .replace(`{${"id"}}`, `${ params["id"] }`);
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Get Event by Id
     * @param id VideoEventId
     * @param xIntegrationUserCredential 
     */
    apiV1VideoEventIdGet(params: {  "id": string; "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling apiV1VideoEventIdGet");
        }
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1VideoEventIdGet");
        }
        const baseUrl = `/api/v1/videoEvent/{id}`
            .replace(`{${"id"}}`, `${ params["id"] }`);
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Request AI overlay transcoding for a video event
     * @param id VideoEvent display ID
     * @param xIntegrationUserCredential 
     */
    apiV1VideoEventIdRequestAiOverlayPost(params: {  "id": string; "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "id" is set
        if (params["id"] == null) {
            throw new Error("Missing required parameter id when calling apiV1VideoEventIdRequestAiOverlayPost");
        }
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1VideoEventIdRequestAiOverlayPost");
        }
        const baseUrl = `/api/v1/videoEvent/{id}/requestAiOverlay`
            .replace(`{${"id"}}`, `${ params["id"] }`);
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     *   This endpoint restores a soft deleted video event.    The process simply sets the VideoEvent.SoftDeleteDate to null.
     *   &lt;b&gt;Note:&lt;/b&gt; This should only be done if the video event is not hard deleted.
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VideoEventRestorePut(params: {  "xIntegrationUserCredential": string; "body"?: BulkRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1VideoEventRestorePut");
        }
        const baseUrl = `/api/v1/video-event/restore`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "PUT" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Event Types
     * @param xIntegrationUserCredential 
     */
    apiV1VideoEventTypesGet(params: {  "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1VideoEventTypesGet");
        }
        const baseUrl = `/api/v1/videoEventTypes`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Filter events with based on multiselect filter inputs
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VideoEventsFilteredEventsMultiselectPost(params: {  "xIntegrationUserCredential": string; "body"?: VideoEventFilterMultiselectRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1VideoEventsFilteredEventsMultiselectPost");
        }
        const baseUrl = `/api/v1/videoEvents/filteredEventsMultiselect`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Filter events with based on multiselect filter inputs
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VideoEventsFilteredEventsReportMultiselectPost(params: {  "xIntegrationUserCredential": string; "body"?: VideoEventFilterMultiselectRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1VideoEventsFilteredEventsReportMultiselectPost");
        }
        const baseUrl = `/api/v1/videoEvents/filteredEventsReportMultiselect`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Get All Video Events
     * @param xIntegrationUserCredential 
     * @param currentPage 
     * @param itemsPerPage 
     */
    apiV1VideoEventsGet(params: {  "xIntegrationUserCredential": string; "currentPage"?: number; "itemsPerPage"?: number; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1VideoEventsGet");
        }
        const baseUrl = `/api/v1/videoEvents`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "currentPage": params["currentPage"],
            "itemsPerPage": params["itemsPerPage"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * log the export action of one video event to the SpiLogVideoEvent and VideoEventActions tables
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VideoEventsLogexportPost(params: {  "xIntegrationUserCredential": string; "body"?: LogRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1VideoEventsLogexportPost");
        }
        const baseUrl = `/api/v1/videoEvents/logexport`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Filter events for standalone specific purposes
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VideoEventsStandaloneFilteredEventsMultiselectPost(params: {  "xIntegrationUserCredential": string; "body"?: StandaloneVideoEventFilterMultiselectRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1VideoEventsStandaloneFilteredEventsMultiselectPost");
        }
        const baseUrl = `/api/v1/videoEvents/standaloneFilteredEventsMultiselect`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Filter events for standalone specific purposes
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VideoEventsStandaloneReportPost(params: {  "xIntegrationUserCredential": string; "body"?: StandaloneVideoEventFilterMultiselectRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1VideoEventsStandaloneReportPost");
        }
        const baseUrl = `/api/v1/videoEvents/standalone/report`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * delete video recall
     * @param xIntegrationUserCredential 
     * @param eventId 
     */
    apiV1VideorecallDeletevideorecallPost(params: {  "xIntegrationUserCredential": string; "eventId"?: number; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1VideorecallDeletevideorecallPost");
        }
        const baseUrl = `/api/v1/videorecall/deletevideorecall`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "eventId": params["eventId"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Get All Recalled Videos
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VideorecallFilteredeventsPost(params: {  "xIntegrationUserCredential": string; "body"?: VideoEventFilterRequest; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1VideorecallFilteredeventsPost");
        }
        const baseUrl = `/api/v1/videorecall/filteredevents`;
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Get All Recalled Videos
     * @param xIntegrationUserCredential 
     * @param startDate 
     * @param endDate 
     */
    apiV1VideorecallsGet(params: {  "xIntegrationUserCredential": string; "startDate"?: Date; "endDate"?: Date; }, options?: any): FetchArgs {
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1VideorecallsGet");
        }
        const baseUrl = `/api/v1/videorecalls`;
        let urlObj = url.parse(baseUrl, true);
        urlObj.query = assign({}, urlObj.query, {
            "startDate": params["startDate"],
            "endDate": params["endDate"],
        });
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};

/**
 * VideoEventApi - functional programming interface
 */
export const VideoEventApiFp = {
    /** 
     * @param xIntegrationUserCredential 
     * @param eventId 
     * @param videoEventHistoryAction 
     * @param actionDescription 
     * @param driverId 
     */
    apiV1AddvideoeventactionrecordPost(params: { "xIntegrationUserCredential": string; "eventId"?: number; "videoEventHistoryAction"?: string; "actionDescription"?: string; "driverId"?: number;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = VideoEventApiFetchParamCreator.apiV1AddvideoeventactionrecordPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1AssignDriverToEventsPost(params: { "xIntegrationUserCredential": string; "body"?: AssignDriverToEventsRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = VideoEventApiFetchParamCreator.apiV1AssignDriverToEventsPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * This endpoint dismisses multiple events more efficiently. This takes a list of all the video events to be dismissed. It also will update monthly driver score.
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1BulkDismissRangePost(params: { "xIntegrationUserCredential": string; "body"?: BulkRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MessageResponse> {
        const fetchArgs = VideoEventApiFetchParamCreator.apiV1BulkDismissRangePost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1BulkPromoteVideoRecallsPost(params: { "xIntegrationUserCredential": string; "body"?: Array<number>;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = VideoEventApiFetchParamCreator.apiV1BulkPromoteVideoRecallsPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     *   This endpoint allows a user to apply the same rating (\&quot;Score\&quot;) to multiple Video Events, Unique endopint for Standalone and Core.
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1BulkScoreVideoEventsPost(params: { "xIntegrationUserCredential": string; "body"?: BulkRatingRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = VideoEventApiFetchParamCreator.apiV1BulkScoreVideoEventsPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param eventId 
     * @param actionTaken 
     */
    apiV1CompletevideoPost(params: { "xIntegrationUserCredential": string; "eventId"?: number; "actionTaken"?: string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = VideoEventApiFetchParamCreator.apiV1CompletevideoPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     *   Gets all the id/value parings for the Video Event Ratings control.
     * @param xIntegrationUserCredential 
     */
    apiV1ControlsVideoEventRatingsGet(params: { "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<VideoEventScoreResponse>> {
        const fetchArgs = VideoEventApiFetchParamCreator.apiV1ControlsVideoEventRatingsGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * delete a list of video recalls by eventId. Created for Stand alone
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1DeletevideorecallsPut(params: { "xIntegrationUserCredential": string; "body"?: Array<number>;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = VideoEventApiFetchParamCreator.apiV1DeletevideorecallsPut(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     *   This endpoint dismisses multiple events.  This takes a list of all the video events to be dismissed.
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1DismissMultipleVideoEventPost(params: { "xIntegrationUserCredential": string; "body"?: BulkRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = VideoEventApiFetchParamCreator.apiV1DismissMultipleVideoEventPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     *   This endpoint dismisses a single event.
     * The muliple dismiss functionality is based off of this.
     * @param xIntegrationUserCredential 
     * @param eventId 
     * @param actionTaken 
     */
    apiV1DismissVideoPost(params: { "xIntegrationUserCredential": string; "eventId"?: number; "actionTaken"?: string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = VideoEventApiFetchParamCreator.apiV1DismissVideoPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param eventId 
     * @param videoType 
     */
    apiV1DownloadvideoPost(params: { "xIntegrationUserCredential": string; "eventId"?: number; "videoType"?: string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = VideoEventApiFetchParamCreator.apiV1DownloadvideoPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param eventId 
     */
    apiV1FlagvideoPost(params: { "xIntegrationUserCredential": string; "eventId"?: number;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = VideoEventApiFetchParamCreator.apiV1FlagvideoPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1GetFullVideoEventIdListPost(params: { "xIntegrationUserCredential": string; "body"?: VideoEventFilterMultiselectRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<VideoEventFullListResponse> {
        const fetchArgs = VideoEventApiFetchParamCreator.apiV1GetFullVideoEventIdListPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Gets all video event Ids for a given filter without mapping to a VideoEventResponse
     * @param xIntegrationUserCredential 
     * @param body VideoPlatform.DataService.Postgres.Models.Requests.VideoEventFilterMultiselectRequest - The filter object
     */
    apiV1GetVideoEventIdsPost(params: { "xIntegrationUserCredential": string; "body"?: StandaloneVideoEventFilterMultiselectRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<VideoEventIdResponseListResponseBase> {
        const fetchArgs = VideoEventApiFetchParamCreator.apiV1GetVideoEventIdsPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param eventId 
     */
    apiV1GetvideoeventhistoryGet(params: { "xIntegrationUserCredential": string; "eventId"?: number;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<VideoEventHistoryTableResponseIEnumerableResponseBase> {
        const fetchArgs = VideoEventApiFetchParamCreator.apiV1GetvideoeventhistoryGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param eventId 
     */
    apiV1PromotevideorecallPost(params: { "xIntegrationUserCredential": string; "eventId"?: number;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = VideoEventApiFetchParamCreator.apiV1PromotevideorecallPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Request a new recalled video
     * @param xIntegrationUserCredential 
     * @param integrationPartnerVehicleId Vehicle to fetch video from
     * @param startDate Start of recording
     * @param endDate End of Recording
     */
    apiV1RecallvideoPost(params: { "xIntegrationUserCredential": string; "integrationPartnerVehicleId"?: string; "startDate"?: string; "endDate"?: string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = VideoEventApiFetchParamCreator.apiV1RecallvideoPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param eventId 
     */
    apiV1RemovedriverPost(params: { "xIntegrationUserCredential": string; "eventId"?: number;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = VideoEventApiFetchParamCreator.apiV1RemovedriverPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param eventId 
     */
    apiV1ReopeneventPost(params: { "xIntegrationUserCredential": string; "eventId"?: number;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = VideoEventApiFetchParamCreator.apiV1ReopeneventPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Completely unflag a video event (removes all flags unlike the flagvideo endpoint)
     * @param xIntegrationUserCredential 
     * @param eventId 
     */
    apiV1UnflagvideoPost(params: { "xIntegrationUserCredential": string; "eventId"?: number;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = VideoEventApiFetchParamCreator.apiV1UnflagvideoPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Update the assigned driver for a list of video events
     * @param xIntegrationUserCredential 
     * @param driverId Id of Driver that should be assigned
     * @param body List of VideoEvents to update
     */
    apiV1UpdateAssignedDriverForListOfVideoEventsPost(params: { "xIntegrationUserCredential": string; "driverId"?: number; "body"?: Array<number>;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = VideoEventApiFetchParamCreator.apiV1UpdateAssignedDriverForListOfVideoEventsPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param eventId 
     * @param body 
     */
    apiV1UpdatedriverPost(params: { "xIntegrationUserCredential": string; "eventId"?: number; "body"?: VideoEventDriverRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = VideoEventApiFetchParamCreator.apiV1UpdatedriverPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * @param xIntegrationUserCredential 
     * @param eventId 
     * @param status 
     */
    apiV1UpdatevideoeventPost(params: { "xIntegrationUserCredential": string; "eventId"?: number; "status"?: string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = VideoEventApiFetchParamCreator.apiV1UpdatevideoeventPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     *   The M:Website.Core.Controllers.VideoEventController.DeleteVideoEvent(VideoPlatform.DataService.Website.Models.Requests.BulkRequest) endpoint flags video events as \&quot;soft deleted\&quot;.  This means that                         the data is still there, but flagged in such a manner that it will not be displayed in any data                        set.  It will later, after a determined length of time, be \&quot;hard delted\&quot; and will not be                        recoverable.
     *   This works on one or more video event delete request.    If no video event ids are passed in, it will return a bad request stating it requires at least one                        video event ID.    If video event IDs are passed in, but none of them get updated (video Event doesn&#39;t exist for example)                        it returns a bad request as well saying no matching video events were found.    If multiple video event IDs are passed in and one or more of those are not found, but at least one is,                        it returns OK.    If all Video events are found, it returns OK.    When it returns OK, it will return with a JSON object that contains all the Video Events found for that list.                        Any video event ID that was invalid is not included.  Therefore, you can compare request list with response                        list and tell if it was a partial success, and if diffing, you can tell which ones.
     * @param xIntegrationUserCredential 
     * @param body An array of integers representing the video event ids that need to be deleted.
     */
    apiV1VideoEventDeleteDelete(params: { "xIntegrationUserCredential": string; "body"?: BulkRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<VideoEventDeletionResponse> {
        const fetchArgs = VideoEventApiFetchParamCreator.apiV1VideoEventDeleteDelete(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Returns whether AI overlay video is available for all assets of a video event.  Intended to be polled by the client after calling requestAiOverlay.
     * @param id VideoEvent display ID
     * @param xIntegrationUserCredential 
     */
    apiV1VideoEventIdAiVideoAvailableGet(params: { "id": string; "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<boolean> {
        const fetchArgs = VideoEventApiFetchParamCreator.apiV1VideoEventIdAiVideoAvailableGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Get Event by Id
     * @param id VideoEventId
     * @param xIntegrationUserCredential 
     */
    apiV1VideoEventIdGet(params: { "id": string; "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<VideoEventResponse> {
        const fetchArgs = VideoEventApiFetchParamCreator.apiV1VideoEventIdGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Request AI overlay transcoding for a video event
     * @param id VideoEvent display ID
     * @param xIntegrationUserCredential 
     */
    apiV1VideoEventIdRequestAiOverlayPost(params: { "id": string; "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = VideoEventApiFetchParamCreator.apiV1VideoEventIdRequestAiOverlayPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     *   This endpoint restores a soft deleted video event.    The process simply sets the VideoEvent.SoftDeleteDate to null.
     *   &lt;b&gt;Note:&lt;/b&gt; This should only be done if the video event is not hard deleted.
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VideoEventRestorePut(params: { "xIntegrationUserCredential": string; "body"?: BulkRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<VideoEventDeletionResponse> {
        const fetchArgs = VideoEventApiFetchParamCreator.apiV1VideoEventRestorePut(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Event Types
     * @param xIntegrationUserCredential 
     */
    apiV1VideoEventTypesGet(params: { "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<VideoEventTypeResponse>> {
        const fetchArgs = VideoEventApiFetchParamCreator.apiV1VideoEventTypesGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Filter events with based on multiselect filter inputs
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VideoEventsFilteredEventsMultiselectPost(params: { "xIntegrationUserCredential": string; "body"?: VideoEventFilterMultiselectRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<VideoEventResponseIEnumerablePagedResponseBase> {
        const fetchArgs = VideoEventApiFetchParamCreator.apiV1VideoEventsFilteredEventsMultiselectPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Filter events with based on multiselect filter inputs
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VideoEventsFilteredEventsReportMultiselectPost(params: { "xIntegrationUserCredential": string; "body"?: VideoEventFilterMultiselectRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<VideoEventReportResponseIEnumerableResponseBase> {
        const fetchArgs = VideoEventApiFetchParamCreator.apiV1VideoEventsFilteredEventsReportMultiselectPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Get All Video Events
     * @param xIntegrationUserCredential 
     * @param currentPage 
     * @param itemsPerPage 
     */
    apiV1VideoEventsGet(params: { "xIntegrationUserCredential": string; "currentPage"?: number; "itemsPerPage"?: number;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<VideoEventResponseIEnumerablePagedResponseBase> {
        const fetchArgs = VideoEventApiFetchParamCreator.apiV1VideoEventsGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * log the export action of one video event to the SpiLogVideoEvent and VideoEventActions tables
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VideoEventsLogexportPost(params: { "xIntegrationUserCredential": string; "body"?: LogRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = VideoEventApiFetchParamCreator.apiV1VideoEventsLogexportPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Filter events for standalone specific purposes
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VideoEventsStandaloneFilteredEventsMultiselectPost(params: { "xIntegrationUserCredential": string; "body"?: StandaloneVideoEventFilterMultiselectRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<StandaloneVideoEventResponseIEnumerablePagedResponseBase> {
        const fetchArgs = VideoEventApiFetchParamCreator.apiV1VideoEventsStandaloneFilteredEventsMultiselectPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Filter events for standalone specific purposes
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VideoEventsStandaloneReportPost(params: { "xIntegrationUserCredential": string; "body"?: StandaloneVideoEventFilterMultiselectRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<StandaloneVideoEventResponseIEnumerableResponseBase> {
        const fetchArgs = VideoEventApiFetchParamCreator.apiV1VideoEventsStandaloneReportPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * delete video recall
     * @param xIntegrationUserCredential 
     * @param eventId 
     */
    apiV1VideorecallDeletevideorecallPost(params: { "xIntegrationUserCredential": string; "eventId"?: number;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
        const fetchArgs = VideoEventApiFetchParamCreator.apiV1VideorecallDeletevideorecallPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Get All Recalled Videos
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VideorecallFilteredeventsPost(params: { "xIntegrationUserCredential": string; "body"?: VideoEventFilterRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<VideoEventResponseIEnumerablePagedResponseBase> {
        const fetchArgs = VideoEventApiFetchParamCreator.apiV1VideorecallFilteredeventsPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Get All Recalled Videos
     * @param xIntegrationUserCredential 
     * @param startDate 
     * @param endDate 
     */
    apiV1VideorecallsGet(params: { "xIntegrationUserCredential": string; "startDate"?: Date; "endDate"?: Date;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<VideoRecallResponse>> {
        const fetchArgs = VideoEventApiFetchParamCreator.apiV1VideorecallsGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
};

/**
 * VideoEventApi - object-oriented interface
 */
export class VideoEventApi extends BaseAPI {
    /** 
     * @param xIntegrationUserCredential 
     * @param eventId 
     * @param videoEventHistoryAction 
     * @param actionDescription 
     * @param driverId 
     */
    apiV1AddvideoeventactionrecordPost(params: {  "xIntegrationUserCredential": string; "eventId"?: number; "videoEventHistoryAction"?: string; "actionDescription"?: string; "driverId"?: number; }, options?: any) {
        return VideoEventApiFp.apiV1AddvideoeventactionrecordPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1AssignDriverToEventsPost(params: {  "xIntegrationUserCredential": string; "body"?: AssignDriverToEventsRequest; }, options?: any) {
        return VideoEventApiFp.apiV1AssignDriverToEventsPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * This endpoint dismisses multiple events more efficiently. This takes a list of all the video events to be dismissed. It also will update monthly driver score.
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1BulkDismissRangePost(params: {  "xIntegrationUserCredential": string; "body"?: BulkRequest; }, options?: any) {
        return VideoEventApiFp.apiV1BulkDismissRangePost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1BulkPromoteVideoRecallsPost(params: {  "xIntegrationUserCredential": string; "body"?: Array<number>; }, options?: any) {
        return VideoEventApiFp.apiV1BulkPromoteVideoRecallsPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     *   This endpoint allows a user to apply the same rating (\&quot;Score\&quot;) to multiple Video Events, Unique endopint for Standalone and Core.
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1BulkScoreVideoEventsPost(params: {  "xIntegrationUserCredential": string; "body"?: BulkRatingRequest; }, options?: any) {
        return VideoEventApiFp.apiV1BulkScoreVideoEventsPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param xIntegrationUserCredential 
     * @param eventId 
     * @param actionTaken 
     */
    apiV1CompletevideoPost(params: {  "xIntegrationUserCredential": string; "eventId"?: number; "actionTaken"?: string; }, options?: any) {
        return VideoEventApiFp.apiV1CompletevideoPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     *   Gets all the id/value parings for the Video Event Ratings control.
     * @param xIntegrationUserCredential 
     */
    apiV1ControlsVideoEventRatingsGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
        return VideoEventApiFp.apiV1ControlsVideoEventRatingsGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * delete a list of video recalls by eventId. Created for Stand alone
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1DeletevideorecallsPut(params: {  "xIntegrationUserCredential": string; "body"?: Array<number>; }, options?: any) {
        return VideoEventApiFp.apiV1DeletevideorecallsPut(params, options)(this.fetch, this.basePath);
    }
    /** 
     *   This endpoint dismisses multiple events.  This takes a list of all the video events to be dismissed.
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1DismissMultipleVideoEventPost(params: {  "xIntegrationUserCredential": string; "body"?: BulkRequest; }, options?: any) {
        return VideoEventApiFp.apiV1DismissMultipleVideoEventPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     *   This endpoint dismisses a single event.
     * The muliple dismiss functionality is based off of this.
     * @param xIntegrationUserCredential 
     * @param eventId 
     * @param actionTaken 
     */
    apiV1DismissVideoPost(params: {  "xIntegrationUserCredential": string; "eventId"?: number; "actionTaken"?: string; }, options?: any) {
        return VideoEventApiFp.apiV1DismissVideoPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param xIntegrationUserCredential 
     * @param eventId 
     * @param videoType 
     */
    apiV1DownloadvideoPost(params: {  "xIntegrationUserCredential": string; "eventId"?: number; "videoType"?: string; }, options?: any) {
        return VideoEventApiFp.apiV1DownloadvideoPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param xIntegrationUserCredential 
     * @param eventId 
     */
    apiV1FlagvideoPost(params: {  "xIntegrationUserCredential": string; "eventId"?: number; }, options?: any) {
        return VideoEventApiFp.apiV1FlagvideoPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1GetFullVideoEventIdListPost(params: {  "xIntegrationUserCredential": string; "body"?: VideoEventFilterMultiselectRequest; }, options?: any) {
        return VideoEventApiFp.apiV1GetFullVideoEventIdListPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Gets all video event Ids for a given filter without mapping to a VideoEventResponse
     * @param xIntegrationUserCredential 
     * @param body VideoPlatform.DataService.Postgres.Models.Requests.VideoEventFilterMultiselectRequest - The filter object
     */
    apiV1GetVideoEventIdsPost(params: {  "xIntegrationUserCredential": string; "body"?: StandaloneVideoEventFilterMultiselectRequest; }, options?: any) {
        return VideoEventApiFp.apiV1GetVideoEventIdsPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param xIntegrationUserCredential 
     * @param eventId 
     */
    apiV1GetvideoeventhistoryGet(params: {  "xIntegrationUserCredential": string; "eventId"?: number; }, options?: any) {
        return VideoEventApiFp.apiV1GetvideoeventhistoryGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param xIntegrationUserCredential 
     * @param eventId 
     */
    apiV1PromotevideorecallPost(params: {  "xIntegrationUserCredential": string; "eventId"?: number; }, options?: any) {
        return VideoEventApiFp.apiV1PromotevideorecallPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Request a new recalled video
     * @param xIntegrationUserCredential 
     * @param integrationPartnerVehicleId Vehicle to fetch video from
     * @param startDate Start of recording
     * @param endDate End of Recording
     */
    apiV1RecallvideoPost(params: {  "xIntegrationUserCredential": string; "integrationPartnerVehicleId"?: string; "startDate"?: string; "endDate"?: string; }, options?: any) {
        return VideoEventApiFp.apiV1RecallvideoPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param xIntegrationUserCredential 
     * @param eventId 
     */
    apiV1RemovedriverPost(params: {  "xIntegrationUserCredential": string; "eventId"?: number; }, options?: any) {
        return VideoEventApiFp.apiV1RemovedriverPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param xIntegrationUserCredential 
     * @param eventId 
     */
    apiV1ReopeneventPost(params: {  "xIntegrationUserCredential": string; "eventId"?: number; }, options?: any) {
        return VideoEventApiFp.apiV1ReopeneventPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Completely unflag a video event (removes all flags unlike the flagvideo endpoint)
     * @param xIntegrationUserCredential 
     * @param eventId 
     */
    apiV1UnflagvideoPost(params: {  "xIntegrationUserCredential": string; "eventId"?: number; }, options?: any) {
        return VideoEventApiFp.apiV1UnflagvideoPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Update the assigned driver for a list of video events
     * @param xIntegrationUserCredential 
     * @param driverId Id of Driver that should be assigned
     * @param body List of VideoEvents to update
     */
    apiV1UpdateAssignedDriverForListOfVideoEventsPost(params: {  "xIntegrationUserCredential": string; "driverId"?: number; "body"?: Array<number>; }, options?: any) {
        return VideoEventApiFp.apiV1UpdateAssignedDriverForListOfVideoEventsPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param xIntegrationUserCredential 
     * @param eventId 
     * @param body 
     */
    apiV1UpdatedriverPost(params: {  "xIntegrationUserCredential": string; "eventId"?: number; "body"?: VideoEventDriverRequest; }, options?: any) {
        return VideoEventApiFp.apiV1UpdatedriverPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * @param xIntegrationUserCredential 
     * @param eventId 
     * @param status 
     */
    apiV1UpdatevideoeventPost(params: {  "xIntegrationUserCredential": string; "eventId"?: number; "status"?: string; }, options?: any) {
        return VideoEventApiFp.apiV1UpdatevideoeventPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     *   The M:Website.Core.Controllers.VideoEventController.DeleteVideoEvent(VideoPlatform.DataService.Website.Models.Requests.BulkRequest) endpoint flags video events as \&quot;soft deleted\&quot;.  This means that                         the data is still there, but flagged in such a manner that it will not be displayed in any data                        set.  It will later, after a determined length of time, be \&quot;hard delted\&quot; and will not be                        recoverable.
     *   This works on one or more video event delete request.    If no video event ids are passed in, it will return a bad request stating it requires at least one                        video event ID.    If video event IDs are passed in, but none of them get updated (video Event doesn&#39;t exist for example)                        it returns a bad request as well saying no matching video events were found.    If multiple video event IDs are passed in and one or more of those are not found, but at least one is,                        it returns OK.    If all Video events are found, it returns OK.    When it returns OK, it will return with a JSON object that contains all the Video Events found for that list.                        Any video event ID that was invalid is not included.  Therefore, you can compare request list with response                        list and tell if it was a partial success, and if diffing, you can tell which ones.
     * @param xIntegrationUserCredential 
     * @param body An array of integers representing the video event ids that need to be deleted.
     */
    apiV1VideoEventDeleteDelete(params: {  "xIntegrationUserCredential": string; "body"?: BulkRequest; }, options?: any) {
        return VideoEventApiFp.apiV1VideoEventDeleteDelete(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Returns whether AI overlay video is available for all assets of a video event.  Intended to be polled by the client after calling requestAiOverlay.
     * @param id VideoEvent display ID
     * @param xIntegrationUserCredential 
     */
    apiV1VideoEventIdAiVideoAvailableGet(params: {  "id": string; "xIntegrationUserCredential": string; }, options?: any) {
        return VideoEventApiFp.apiV1VideoEventIdAiVideoAvailableGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Get Event by Id
     * @param id VideoEventId
     * @param xIntegrationUserCredential 
     */
    apiV1VideoEventIdGet(params: {  "id": string; "xIntegrationUserCredential": string; }, options?: any) {
        return VideoEventApiFp.apiV1VideoEventIdGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Request AI overlay transcoding for a video event
     * @param id VideoEvent display ID
     * @param xIntegrationUserCredential 
     */
    apiV1VideoEventIdRequestAiOverlayPost(params: {  "id": string; "xIntegrationUserCredential": string; }, options?: any) {
        return VideoEventApiFp.apiV1VideoEventIdRequestAiOverlayPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     *   This endpoint restores a soft deleted video event.    The process simply sets the VideoEvent.SoftDeleteDate to null.
     *   &lt;b&gt;Note:&lt;/b&gt; This should only be done if the video event is not hard deleted.
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VideoEventRestorePut(params: {  "xIntegrationUserCredential": string; "body"?: BulkRequest; }, options?: any) {
        return VideoEventApiFp.apiV1VideoEventRestorePut(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Event Types
     * @param xIntegrationUserCredential 
     */
    apiV1VideoEventTypesGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
        return VideoEventApiFp.apiV1VideoEventTypesGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Filter events with based on multiselect filter inputs
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VideoEventsFilteredEventsMultiselectPost(params: {  "xIntegrationUserCredential": string; "body"?: VideoEventFilterMultiselectRequest; }, options?: any) {
        return VideoEventApiFp.apiV1VideoEventsFilteredEventsMultiselectPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Filter events with based on multiselect filter inputs
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VideoEventsFilteredEventsReportMultiselectPost(params: {  "xIntegrationUserCredential": string; "body"?: VideoEventFilterMultiselectRequest; }, options?: any) {
        return VideoEventApiFp.apiV1VideoEventsFilteredEventsReportMultiselectPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Get All Video Events
     * @param xIntegrationUserCredential 
     * @param currentPage 
     * @param itemsPerPage 
     */
    apiV1VideoEventsGet(params: {  "xIntegrationUserCredential": string; "currentPage"?: number; "itemsPerPage"?: number; }, options?: any) {
        return VideoEventApiFp.apiV1VideoEventsGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * log the export action of one video event to the SpiLogVideoEvent and VideoEventActions tables
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VideoEventsLogexportPost(params: {  "xIntegrationUserCredential": string; "body"?: LogRequest; }, options?: any) {
        return VideoEventApiFp.apiV1VideoEventsLogexportPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Filter events for standalone specific purposes
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VideoEventsStandaloneFilteredEventsMultiselectPost(params: {  "xIntegrationUserCredential": string; "body"?: StandaloneVideoEventFilterMultiselectRequest; }, options?: any) {
        return VideoEventApiFp.apiV1VideoEventsStandaloneFilteredEventsMultiselectPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Filter events for standalone specific purposes
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VideoEventsStandaloneReportPost(params: {  "xIntegrationUserCredential": string; "body"?: StandaloneVideoEventFilterMultiselectRequest; }, options?: any) {
        return VideoEventApiFp.apiV1VideoEventsStandaloneReportPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * delete video recall
     * @param xIntegrationUserCredential 
     * @param eventId 
     */
    apiV1VideorecallDeletevideorecallPost(params: {  "xIntegrationUserCredential": string; "eventId"?: number; }, options?: any) {
        return VideoEventApiFp.apiV1VideorecallDeletevideorecallPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Get All Recalled Videos
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VideorecallFilteredeventsPost(params: {  "xIntegrationUserCredential": string; "body"?: VideoEventFilterRequest; }, options?: any) {
        return VideoEventApiFp.apiV1VideorecallFilteredeventsPost(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Get All Recalled Videos
     * @param xIntegrationUserCredential 
     * @param startDate 
     * @param endDate 
     */
    apiV1VideorecallsGet(params: {  "xIntegrationUserCredential": string; "startDate"?: Date; "endDate"?: Date; }, options?: any) {
        return VideoEventApiFp.apiV1VideorecallsGet(params, options)(this.fetch, this.basePath);
    }
};

/**
 * VideoEventApi - factory interface
 */
export const VideoEventApiFactory = function (fetch?: FetchAPI, basePath?: string) {
    return {
        /** 
         * @param xIntegrationUserCredential 
         * @param eventId 
         * @param videoEventHistoryAction 
         * @param actionDescription 
         * @param driverId 
         */
        apiV1AddvideoeventactionrecordPost(params: {  "xIntegrationUserCredential": string; "eventId"?: number; "videoEventHistoryAction"?: string; "actionDescription"?: string; "driverId"?: number; }, options?: any) {
            return VideoEventApiFp.apiV1AddvideoeventactionrecordPost(params, options)(fetch, basePath);
        },
        /** 
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1AssignDriverToEventsPost(params: {  "xIntegrationUserCredential": string; "body"?: AssignDriverToEventsRequest; }, options?: any) {
            return VideoEventApiFp.apiV1AssignDriverToEventsPost(params, options)(fetch, basePath);
        },
        /** 
         * This endpoint dismisses multiple events more efficiently. This takes a list of all the video events to be dismissed. It also will update monthly driver score.
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1BulkDismissRangePost(params: {  "xIntegrationUserCredential": string; "body"?: BulkRequest; }, options?: any) {
            return VideoEventApiFp.apiV1BulkDismissRangePost(params, options)(fetch, basePath);
        },
        /** 
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1BulkPromoteVideoRecallsPost(params: {  "xIntegrationUserCredential": string; "body"?: Array<number>; }, options?: any) {
            return VideoEventApiFp.apiV1BulkPromoteVideoRecallsPost(params, options)(fetch, basePath);
        },
        /** 
         *   This endpoint allows a user to apply the same rating (\&quot;Score\&quot;) to multiple Video Events, Unique endopint for Standalone and Core.
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1BulkScoreVideoEventsPost(params: {  "xIntegrationUserCredential": string; "body"?: BulkRatingRequest; }, options?: any) {
            return VideoEventApiFp.apiV1BulkScoreVideoEventsPost(params, options)(fetch, basePath);
        },
        /** 
         * @param xIntegrationUserCredential 
         * @param eventId 
         * @param actionTaken 
         */
        apiV1CompletevideoPost(params: {  "xIntegrationUserCredential": string; "eventId"?: number; "actionTaken"?: string; }, options?: any) {
            return VideoEventApiFp.apiV1CompletevideoPost(params, options)(fetch, basePath);
        },
        /** 
         *   Gets all the id/value parings for the Video Event Ratings control.
         * @param xIntegrationUserCredential 
         */
        apiV1ControlsVideoEventRatingsGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
            return VideoEventApiFp.apiV1ControlsVideoEventRatingsGet(params, options)(fetch, basePath);
        },
        /** 
         * delete a list of video recalls by eventId. Created for Stand alone
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1DeletevideorecallsPut(params: {  "xIntegrationUserCredential": string; "body"?: Array<number>; }, options?: any) {
            return VideoEventApiFp.apiV1DeletevideorecallsPut(params, options)(fetch, basePath);
        },
        /** 
         *   This endpoint dismisses multiple events.  This takes a list of all the video events to be dismissed.
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1DismissMultipleVideoEventPost(params: {  "xIntegrationUserCredential": string; "body"?: BulkRequest; }, options?: any) {
            return VideoEventApiFp.apiV1DismissMultipleVideoEventPost(params, options)(fetch, basePath);
        },
        /** 
         *   This endpoint dismisses a single event.
         * The muliple dismiss functionality is based off of this.
         * @param xIntegrationUserCredential 
         * @param eventId 
         * @param actionTaken 
         */
        apiV1DismissVideoPost(params: {  "xIntegrationUserCredential": string; "eventId"?: number; "actionTaken"?: string; }, options?: any) {
            return VideoEventApiFp.apiV1DismissVideoPost(params, options)(fetch, basePath);
        },
        /** 
         * @param xIntegrationUserCredential 
         * @param eventId 
         * @param videoType 
         */
        apiV1DownloadvideoPost(params: {  "xIntegrationUserCredential": string; "eventId"?: number; "videoType"?: string; }, options?: any) {
            return VideoEventApiFp.apiV1DownloadvideoPost(params, options)(fetch, basePath);
        },
        /** 
         * @param xIntegrationUserCredential 
         * @param eventId 
         */
        apiV1FlagvideoPost(params: {  "xIntegrationUserCredential": string; "eventId"?: number; }, options?: any) {
            return VideoEventApiFp.apiV1FlagvideoPost(params, options)(fetch, basePath);
        },
        /** 
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1GetFullVideoEventIdListPost(params: {  "xIntegrationUserCredential": string; "body"?: VideoEventFilterMultiselectRequest; }, options?: any) {
            return VideoEventApiFp.apiV1GetFullVideoEventIdListPost(params, options)(fetch, basePath);
        },
        /** 
         * Gets all video event Ids for a given filter without mapping to a VideoEventResponse
         * @param xIntegrationUserCredential 
         * @param body VideoPlatform.DataService.Postgres.Models.Requests.VideoEventFilterMultiselectRequest - The filter object
         */
        apiV1GetVideoEventIdsPost(params: {  "xIntegrationUserCredential": string; "body"?: StandaloneVideoEventFilterMultiselectRequest; }, options?: any) {
            return VideoEventApiFp.apiV1GetVideoEventIdsPost(params, options)(fetch, basePath);
        },
        /** 
         * @param xIntegrationUserCredential 
         * @param eventId 
         */
        apiV1GetvideoeventhistoryGet(params: {  "xIntegrationUserCredential": string; "eventId"?: number; }, options?: any) {
            return VideoEventApiFp.apiV1GetvideoeventhistoryGet(params, options)(fetch, basePath);
        },
        /** 
         * @param xIntegrationUserCredential 
         * @param eventId 
         */
        apiV1PromotevideorecallPost(params: {  "xIntegrationUserCredential": string; "eventId"?: number; }, options?: any) {
            return VideoEventApiFp.apiV1PromotevideorecallPost(params, options)(fetch, basePath);
        },
        /** 
         * Request a new recalled video
         * @param xIntegrationUserCredential 
         * @param integrationPartnerVehicleId Vehicle to fetch video from
         * @param startDate Start of recording
         * @param endDate End of Recording
         */
        apiV1RecallvideoPost(params: {  "xIntegrationUserCredential": string; "integrationPartnerVehicleId"?: string; "startDate"?: string; "endDate"?: string; }, options?: any) {
            return VideoEventApiFp.apiV1RecallvideoPost(params, options)(fetch, basePath);
        },
        /** 
         * @param xIntegrationUserCredential 
         * @param eventId 
         */
        apiV1RemovedriverPost(params: {  "xIntegrationUserCredential": string; "eventId"?: number; }, options?: any) {
            return VideoEventApiFp.apiV1RemovedriverPost(params, options)(fetch, basePath);
        },
        /** 
         * @param xIntegrationUserCredential 
         * @param eventId 
         */
        apiV1ReopeneventPost(params: {  "xIntegrationUserCredential": string; "eventId"?: number; }, options?: any) {
            return VideoEventApiFp.apiV1ReopeneventPost(params, options)(fetch, basePath);
        },
        /** 
         * Completely unflag a video event (removes all flags unlike the flagvideo endpoint)
         * @param xIntegrationUserCredential 
         * @param eventId 
         */
        apiV1UnflagvideoPost(params: {  "xIntegrationUserCredential": string; "eventId"?: number; }, options?: any) {
            return VideoEventApiFp.apiV1UnflagvideoPost(params, options)(fetch, basePath);
        },
        /** 
         * Update the assigned driver for a list of video events
         * @param xIntegrationUserCredential 
         * @param driverId Id of Driver that should be assigned
         * @param body List of VideoEvents to update
         */
        apiV1UpdateAssignedDriverForListOfVideoEventsPost(params: {  "xIntegrationUserCredential": string; "driverId"?: number; "body"?: Array<number>; }, options?: any) {
            return VideoEventApiFp.apiV1UpdateAssignedDriverForListOfVideoEventsPost(params, options)(fetch, basePath);
        },
        /** 
         * @param xIntegrationUserCredential 
         * @param eventId 
         * @param body 
         */
        apiV1UpdatedriverPost(params: {  "xIntegrationUserCredential": string; "eventId"?: number; "body"?: VideoEventDriverRequest; }, options?: any) {
            return VideoEventApiFp.apiV1UpdatedriverPost(params, options)(fetch, basePath);
        },
        /** 
         * @param xIntegrationUserCredential 
         * @param eventId 
         * @param status 
         */
        apiV1UpdatevideoeventPost(params: {  "xIntegrationUserCredential": string; "eventId"?: number; "status"?: string; }, options?: any) {
            return VideoEventApiFp.apiV1UpdatevideoeventPost(params, options)(fetch, basePath);
        },
        /** 
         *   The M:Website.Core.Controllers.VideoEventController.DeleteVideoEvent(VideoPlatform.DataService.Website.Models.Requests.BulkRequest) endpoint flags video events as \&quot;soft deleted\&quot;.  This means that                         the data is still there, but flagged in such a manner that it will not be displayed in any data                        set.  It will later, after a determined length of time, be \&quot;hard delted\&quot; and will not be                        recoverable.
         *   This works on one or more video event delete request.    If no video event ids are passed in, it will return a bad request stating it requires at least one                        video event ID.    If video event IDs are passed in, but none of them get updated (video Event doesn&#39;t exist for example)                        it returns a bad request as well saying no matching video events were found.    If multiple video event IDs are passed in and one or more of those are not found, but at least one is,                        it returns OK.    If all Video events are found, it returns OK.    When it returns OK, it will return with a JSON object that contains all the Video Events found for that list.                        Any video event ID that was invalid is not included.  Therefore, you can compare request list with response                        list and tell if it was a partial success, and if diffing, you can tell which ones.
         * @param xIntegrationUserCredential 
         * @param body An array of integers representing the video event ids that need to be deleted.
         */
        apiV1VideoEventDeleteDelete(params: {  "xIntegrationUserCredential": string; "body"?: BulkRequest; }, options?: any) {
            return VideoEventApiFp.apiV1VideoEventDeleteDelete(params, options)(fetch, basePath);
        },
        /** 
         * Returns whether AI overlay video is available for all assets of a video event.  Intended to be polled by the client after calling requestAiOverlay.
         * @param id VideoEvent display ID
         * @param xIntegrationUserCredential 
         */
        apiV1VideoEventIdAiVideoAvailableGet(params: {  "id": string; "xIntegrationUserCredential": string; }, options?: any) {
            return VideoEventApiFp.apiV1VideoEventIdAiVideoAvailableGet(params, options)(fetch, basePath);
        },
        /** 
         * Get Event by Id
         * @param id VideoEventId
         * @param xIntegrationUserCredential 
         */
        apiV1VideoEventIdGet(params: {  "id": string; "xIntegrationUserCredential": string; }, options?: any) {
            return VideoEventApiFp.apiV1VideoEventIdGet(params, options)(fetch, basePath);
        },
        /** 
         * Request AI overlay transcoding for a video event
         * @param id VideoEvent display ID
         * @param xIntegrationUserCredential 
         */
        apiV1VideoEventIdRequestAiOverlayPost(params: {  "id": string; "xIntegrationUserCredential": string; }, options?: any) {
            return VideoEventApiFp.apiV1VideoEventIdRequestAiOverlayPost(params, options)(fetch, basePath);
        },
        /** 
         *   This endpoint restores a soft deleted video event.    The process simply sets the VideoEvent.SoftDeleteDate to null.
         *   &lt;b&gt;Note:&lt;/b&gt; This should only be done if the video event is not hard deleted.
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1VideoEventRestorePut(params: {  "xIntegrationUserCredential": string; "body"?: BulkRequest; }, options?: any) {
            return VideoEventApiFp.apiV1VideoEventRestorePut(params, options)(fetch, basePath);
        },
        /** 
         * Event Types
         * @param xIntegrationUserCredential 
         */
        apiV1VideoEventTypesGet(params: {  "xIntegrationUserCredential": string; }, options?: any) {
            return VideoEventApiFp.apiV1VideoEventTypesGet(params, options)(fetch, basePath);
        },
        /** 
         * Filter events with based on multiselect filter inputs
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1VideoEventsFilteredEventsMultiselectPost(params: {  "xIntegrationUserCredential": string; "body"?: VideoEventFilterMultiselectRequest; }, options?: any) {
            return VideoEventApiFp.apiV1VideoEventsFilteredEventsMultiselectPost(params, options)(fetch, basePath);
        },
        /** 
         * Filter events with based on multiselect filter inputs
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1VideoEventsFilteredEventsReportMultiselectPost(params: {  "xIntegrationUserCredential": string; "body"?: VideoEventFilterMultiselectRequest; }, options?: any) {
            return VideoEventApiFp.apiV1VideoEventsFilteredEventsReportMultiselectPost(params, options)(fetch, basePath);
        },
        /** 
         * Get All Video Events
         * @param xIntegrationUserCredential 
         * @param currentPage 
         * @param itemsPerPage 
         */
        apiV1VideoEventsGet(params: {  "xIntegrationUserCredential": string; "currentPage"?: number; "itemsPerPage"?: number; }, options?: any) {
            return VideoEventApiFp.apiV1VideoEventsGet(params, options)(fetch, basePath);
        },
        /** 
         * log the export action of one video event to the SpiLogVideoEvent and VideoEventActions tables
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1VideoEventsLogexportPost(params: {  "xIntegrationUserCredential": string; "body"?: LogRequest; }, options?: any) {
            return VideoEventApiFp.apiV1VideoEventsLogexportPost(params, options)(fetch, basePath);
        },
        /** 
         * Filter events for standalone specific purposes
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1VideoEventsStandaloneFilteredEventsMultiselectPost(params: {  "xIntegrationUserCredential": string; "body"?: StandaloneVideoEventFilterMultiselectRequest; }, options?: any) {
            return VideoEventApiFp.apiV1VideoEventsStandaloneFilteredEventsMultiselectPost(params, options)(fetch, basePath);
        },
        /** 
         * Filter events for standalone specific purposes
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1VideoEventsStandaloneReportPost(params: {  "xIntegrationUserCredential": string; "body"?: StandaloneVideoEventFilterMultiselectRequest; }, options?: any) {
            return VideoEventApiFp.apiV1VideoEventsStandaloneReportPost(params, options)(fetch, basePath);
        },
        /** 
         * delete video recall
         * @param xIntegrationUserCredential 
         * @param eventId 
         */
        apiV1VideorecallDeletevideorecallPost(params: {  "xIntegrationUserCredential": string; "eventId"?: number; }, options?: any) {
            return VideoEventApiFp.apiV1VideorecallDeletevideorecallPost(params, options)(fetch, basePath);
        },
        /** 
         * Get All Recalled Videos
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1VideorecallFilteredeventsPost(params: {  "xIntegrationUserCredential": string; "body"?: VideoEventFilterRequest; }, options?: any) {
            return VideoEventApiFp.apiV1VideorecallFilteredeventsPost(params, options)(fetch, basePath);
        },
        /** 
         * Get All Recalled Videos
         * @param xIntegrationUserCredential 
         * @param startDate 
         * @param endDate 
         */
        apiV1VideorecallsGet(params: {  "xIntegrationUserCredential": string; "startDate"?: Date; "endDate"?: Date; }, options?: any) {
            return VideoEventApiFp.apiV1VideorecallsGet(params, options)(fetch, basePath);
        },
    };
};


/**
 * VideoEventCommentApi - fetch parameter creator
 */
export const VideoEventCommentApiFetchParamCreator = {
    /** 
     * Gets video and driver comments for a given video
     * @param eventId EventId
     * @param xIntegrationUserCredential 
     */
    apiV1VideoCommentDriverCommentEventIdGet(params: {  "eventId": number; "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "eventId" is set
        if (params["eventId"] == null) {
            throw new Error("Missing required parameter eventId when calling apiV1VideoCommentDriverCommentEventIdGet");
        }
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1VideoCommentDriverCommentEventIdGet");
        }
        const baseUrl = `/api/v1/videoComment/driverComment/{eventId}`
            .replace(`{${"eventId"}}`, `${ params["eventId"] }`);
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Remove a comment from an event
     * @param eventId EventId
     * @param commentId CommentId
     * @param xIntegrationUserCredential 
     */
    apiV1VideoCommentEventIdCommentIdDelete(params: {  "eventId": number; "commentId": number; "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "eventId" is set
        if (params["eventId"] == null) {
            throw new Error("Missing required parameter eventId when calling apiV1VideoCommentEventIdCommentIdDelete");
        }
        // verify required parameter "commentId" is set
        if (params["commentId"] == null) {
            throw new Error("Missing required parameter commentId when calling apiV1VideoCommentEventIdCommentIdDelete");
        }
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1VideoCommentEventIdCommentIdDelete");
        }
        const baseUrl = `/api/v1/videoComment/{eventId}/{commentId}`
            .replace(`{${"eventId"}}`, `${ params["eventId"] }`)
            .replace(`{${"commentId"}}`, `${ params["commentId"] }`);
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "DELETE" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Modify a comment
     * @param eventId EventId
     * @param commentId CommentId
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VideoCommentEventIdCommentIdPut(params: {  "eventId": number; "commentId": number; "xIntegrationUserCredential": string; "body"?: VideoCommentRequest; }, options?: any): FetchArgs {
        // verify required parameter "eventId" is set
        if (params["eventId"] == null) {
            throw new Error("Missing required parameter eventId when calling apiV1VideoCommentEventIdCommentIdPut");
        }
        // verify required parameter "commentId" is set
        if (params["commentId"] == null) {
            throw new Error("Missing required parameter commentId when calling apiV1VideoCommentEventIdCommentIdPut");
        }
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1VideoCommentEventIdCommentIdPut");
        }
        const baseUrl = `/api/v1/videoComment/{eventId}/{commentId}`
            .replace(`{${"eventId"}}`, `${ params["eventId"] }`)
            .replace(`{${"commentId"}}`, `${ params["commentId"] }`);
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "PUT" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Get all comments for a video
     * @param eventId EventId
     * @param xIntegrationUserCredential 
     */
    apiV1VideoCommentEventIdGet(params: {  "eventId": number; "xIntegrationUserCredential": string; }, options?: any): FetchArgs {
        // verify required parameter "eventId" is set
        if (params["eventId"] == null) {
            throw new Error("Missing required parameter eventId when calling apiV1VideoCommentEventIdGet");
        }
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1VideoCommentEventIdGet");
        }
        const baseUrl = `/api/v1/videoComment/{eventId}`
            .replace(`{${"eventId"}}`, `${ params["eventId"] }`);
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "GET" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
    /** 
     * Create a new comment for an event
     * @param eventId EventId
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VideoCommentEventIdPost(params: {  "eventId": number; "xIntegrationUserCredential": string; "body"?: VideoCommentRequest; }, options?: any): FetchArgs {
        // verify required parameter "eventId" is set
        if (params["eventId"] == null) {
            throw new Error("Missing required parameter eventId when calling apiV1VideoCommentEventIdPost");
        }
        // verify required parameter "xIntegrationUserCredential" is set
        if (params["xIntegrationUserCredential"] == null) {
            throw new Error("Missing required parameter xIntegrationUserCredential when calling apiV1VideoCommentEventIdPost");
        }
        const baseUrl = `/api/v1/videoComment/{eventId}`
            .replace(`{${"eventId"}}`, `${ params["eventId"] }`);
        let urlObj = url.parse(baseUrl, true);
        let fetchOptions: RequestInit = assign({}, { method: "POST" }, options);

        let contentTypeHeader: Dictionary<string> = {};
        contentTypeHeader = { "Content-Type": "application/json" };
        if (params["body"]) {
            fetchOptions.body = JSON.stringify(params["body"] || {});
        }
        fetchOptions.headers = assign({
            "x-integration-user-credential": params["xIntegrationUserCredential"],
        }, contentTypeHeader);
        return {
            url: url.format(urlObj),
            options: fetchOptions,
        };
    },
};

/**
 * VideoEventCommentApi - functional programming interface
 */
export const VideoEventCommentApiFp = {
    /** 
     * Gets video and driver comments for a given video
     * @param eventId EventId
     * @param xIntegrationUserCredential 
     */
    apiV1VideoCommentDriverCommentEventIdGet(params: { "eventId": number; "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<VideoEventCommentResponse>> {
        const fetchArgs = VideoEventCommentApiFetchParamCreator.apiV1VideoCommentDriverCommentEventIdGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Remove a comment from an event
     * @param eventId EventId
     * @param commentId CommentId
     * @param xIntegrationUserCredential 
     */
    apiV1VideoCommentEventIdCommentIdDelete(params: { "eventId": number; "commentId": number; "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<VideoEventCommentResponse>> {
        const fetchArgs = VideoEventCommentApiFetchParamCreator.apiV1VideoCommentEventIdCommentIdDelete(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Modify a comment
     * @param eventId EventId
     * @param commentId CommentId
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VideoCommentEventIdCommentIdPut(params: { "eventId": number; "commentId": number; "xIntegrationUserCredential": string; "body"?: VideoCommentRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<VideoEventCommentResponse>> {
        const fetchArgs = VideoEventCommentApiFetchParamCreator.apiV1VideoCommentEventIdCommentIdPut(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Get all comments for a video
     * @param eventId EventId
     * @param xIntegrationUserCredential 
     */
    apiV1VideoCommentEventIdGet(params: { "eventId": number; "xIntegrationUserCredential": string;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<VideoEventCommentResponse>> {
        const fetchArgs = VideoEventCommentApiFetchParamCreator.apiV1VideoCommentEventIdGet(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
    /** 
     * Create a new comment for an event
     * @param eventId EventId
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VideoCommentEventIdPost(params: { "eventId": number; "xIntegrationUserCredential": string; "body"?: VideoCommentRequest;  }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<VideoEventCommentResponse>> {
        const fetchArgs = VideoEventCommentApiFetchParamCreator.apiV1VideoCommentEventIdPost(params, options);
        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        };
    },
};

/**
 * VideoEventCommentApi - object-oriented interface
 */
export class VideoEventCommentApi extends BaseAPI {
    /** 
     * Gets video and driver comments for a given video
     * @param eventId EventId
     * @param xIntegrationUserCredential 
     */
    apiV1VideoCommentDriverCommentEventIdGet(params: {  "eventId": number; "xIntegrationUserCredential": string; }, options?: any) {
        return VideoEventCommentApiFp.apiV1VideoCommentDriverCommentEventIdGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Remove a comment from an event
     * @param eventId EventId
     * @param commentId CommentId
     * @param xIntegrationUserCredential 
     */
    apiV1VideoCommentEventIdCommentIdDelete(params: {  "eventId": number; "commentId": number; "xIntegrationUserCredential": string; }, options?: any) {
        return VideoEventCommentApiFp.apiV1VideoCommentEventIdCommentIdDelete(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Modify a comment
     * @param eventId EventId
     * @param commentId CommentId
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VideoCommentEventIdCommentIdPut(params: {  "eventId": number; "commentId": number; "xIntegrationUserCredential": string; "body"?: VideoCommentRequest; }, options?: any) {
        return VideoEventCommentApiFp.apiV1VideoCommentEventIdCommentIdPut(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Get all comments for a video
     * @param eventId EventId
     * @param xIntegrationUserCredential 
     */
    apiV1VideoCommentEventIdGet(params: {  "eventId": number; "xIntegrationUserCredential": string; }, options?: any) {
        return VideoEventCommentApiFp.apiV1VideoCommentEventIdGet(params, options)(this.fetch, this.basePath);
    }
    /** 
     * Create a new comment for an event
     * @param eventId EventId
     * @param xIntegrationUserCredential 
     * @param body 
     */
    apiV1VideoCommentEventIdPost(params: {  "eventId": number; "xIntegrationUserCredential": string; "body"?: VideoCommentRequest; }, options?: any) {
        return VideoEventCommentApiFp.apiV1VideoCommentEventIdPost(params, options)(this.fetch, this.basePath);
    }
};

/**
 * VideoEventCommentApi - factory interface
 */
export const VideoEventCommentApiFactory = function (fetch?: FetchAPI, basePath?: string) {
    return {
        /** 
         * Gets video and driver comments for a given video
         * @param eventId EventId
         * @param xIntegrationUserCredential 
         */
        apiV1VideoCommentDriverCommentEventIdGet(params: {  "eventId": number; "xIntegrationUserCredential": string; }, options?: any) {
            return VideoEventCommentApiFp.apiV1VideoCommentDriverCommentEventIdGet(params, options)(fetch, basePath);
        },
        /** 
         * Remove a comment from an event
         * @param eventId EventId
         * @param commentId CommentId
         * @param xIntegrationUserCredential 
         */
        apiV1VideoCommentEventIdCommentIdDelete(params: {  "eventId": number; "commentId": number; "xIntegrationUserCredential": string; }, options?: any) {
            return VideoEventCommentApiFp.apiV1VideoCommentEventIdCommentIdDelete(params, options)(fetch, basePath);
        },
        /** 
         * Modify a comment
         * @param eventId EventId
         * @param commentId CommentId
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1VideoCommentEventIdCommentIdPut(params: {  "eventId": number; "commentId": number; "xIntegrationUserCredential": string; "body"?: VideoCommentRequest; }, options?: any) {
            return VideoEventCommentApiFp.apiV1VideoCommentEventIdCommentIdPut(params, options)(fetch, basePath);
        },
        /** 
         * Get all comments for a video
         * @param eventId EventId
         * @param xIntegrationUserCredential 
         */
        apiV1VideoCommentEventIdGet(params: {  "eventId": number; "xIntegrationUserCredential": string; }, options?: any) {
            return VideoEventCommentApiFp.apiV1VideoCommentEventIdGet(params, options)(fetch, basePath);
        },
        /** 
         * Create a new comment for an event
         * @param eventId EventId
         * @param xIntegrationUserCredential 
         * @param body 
         */
        apiV1VideoCommentEventIdPost(params: {  "eventId": number; "xIntegrationUserCredential": string; "body"?: VideoCommentRequest; }, options?: any) {
            return VideoEventCommentApiFp.apiV1VideoCommentEventIdPost(params, options)(fetch, basePath);
        },
    };
};

